{
  "products.title": "Groups",
  "products.allGroups": "All groups",
  "products.new": "New group",
  "products.search": "Search groups…",
  "products.missionCount_one": "{{count}} mission",
  "products.missionCount_other": "{{count}} missions",
  "products.unassigned": "No group",
  "products.noMatch": "No group matches your search.",
  "products.noMissions": "No missions in this group yet.",
  "products.settings": "Settings",
  "products.col.backlog": "Backlog",
  "products.col.done": "Done",
  "products.col.dropped": "Dropped",
  "products.boardHint": "Where each mission sits — read-only.",
  "products.board.expandAll": "Expand all columns",
  "products.board.collapseAll": "Collapse all columns",
  "products.board.perColumn": "{{count}} per column",
  "products.board.more": "+{{count}} more",
  "products.createTitle": "New group",
  "products.nameLabel": "Name",
  "products.namePlaceholder": "e.g. v1 — Catch up to market",
  "products.colorLabel": "Color",
  "products.create": "Create",
  "filter.basic": "Basic",
  "filter.run": "Run",
  "filter.clear": "Clear all",
  "filter.saveAs": "Save as",
  "filter.views": "Views",
  "filter.noViews": "No saved views yet.",
  "filter.savePrompt": "Name this view",
  "filter.saved": "View saved",
  "nav.label": "Office navigation",
  "nav.home": "Dashboard",
  "nav.dashboard": "Dashboard",
  "nav.goals": "Goals",
  "nav.routines": "Routines",
  "nav.wiki": "Wiki",
  "nav.org": "Org chart",
  "nav.settings": "Settings",
  "nav.newMission": "New mission",
  "nav.newProject": "New project",
  "nav.sections.work": "Work",
  "nav.sections.projects": "Projects",
  "nav.sections.agents": "Agents",
  "nav.sections.office": "Office",
  "nav.sections.agency": "Office",
  "nav.reporting": "Reporting",
  "nav.schedule": "Planning",
  "nav.audit": "Agent audit",
  "nav.guild": "Guild",
  "nav.skills": "Roles",
  "nav.billing": "Billing",
  "nav.admin": "Admin",
  "nav.processes": "Processes",
  "roles.title": "Roles",
  "roles.subtitle": "Every position in the studio catalog, grouped by studio — any champion can assume one.",
  "roles.allStudios": "All Studios",
  "roles.add": "Add",
  "roles.added": "Added",
  "roles.championAffinity": "champion affin : {{name}}",
  "roles.empty": "No roles for this studio yet.",
  "roles.slots": "/ {{count}} slots",
  "processes.title": "Processes",
  "processes.subtitle": "Reusable building blocks your squad applies to missions.",
  "processes.catalogBlueprints.title": "Blueprints",
  "processes.catalogBlueprints.description": "The office's business processes: known standards (OKR, BDD, C4, TDD, funnel audit…) applied as is, each with its squad, steps and guardrails. A mission can customize its own in its Process tab.",
  "processes.skills.title": "Skills",
  "processes.skills.description": "The office's own know-how per type of task (new feature, bug, endpoint, review…): a squad, steps and guardrails. Unlike blueprints, which are known standards, a skill is meant to evolve with the office.",
  "processes.skill.edit": "Edit skill",
  "processes.skill.edited": "Edited",
  "processes.skill.editedTitle": "Office edition v{{version}}",
  "processes.skill.readOnlyProcess": "Known standard — read-only",
  "processes.skill.readOnlyMember": "Only the office POC can edit this skill",
  "processes.skill.save": "Save as a new version",
  "processes.skill.cancel": "Cancel",
  "processes.skill.note": "Version note (optional)",
  "processes.skill.saved": "Version {{version}} saved",
  "processes.skill.unchanged": "No change — version unchanged",
  "processes.skill.saveError": "Could not save the skill",
  "processes.skill.conflict": "Another version was saved meanwhile — reloaded",
  "processes.skill.reset": "Reset to the plugin version",
  "processes.skill.resetConfirm": "Reset to the plugin version? A new version is created; running missions keep theirs.",
  "processes.skill.futureMissions": "Applies to missions that pick this skill from now on (Camille and the Studio squad); running missions keep their version. GitHub builds will apply it once platform-composed-agents ships.",
  "processes.skill.diff": "Difference from canonical",
  "processes.skill.diffCanonical": "Catalog",
  "processes.skill.diffOffice": "Your edition",
  "processes.skill.drift": "The canonical changed since this edition",
  "processes.skill.versions": "Version history",
  "processes.skill.versionReset": "Reset to the plugin version",
  "processes.skill.add": "Add",
  "processes.skill.remove": "Remove",
  "processes.skill.field.phases": "Steps",
  "processes.skill.field.required_roles": "Required roles",
  "processes.skill.field.optional_roles": "Optional roles",
  "processes.skill.field.role_guidance": "Working rules per role",
  "processes.skill.field.notes": "Notes",
  "processes.skill.field.abort_conditions": "Stop conditions",
  "processes.skill.phase.name": "Step name",
  "processes.skill.phase.owner": "Owner role",
  "processes.skill.phase.gate": "Gate",
  "processes.skill.phase.artifact": "Artifact",
  "processes.skill.activateWhen": "When to activate",
  "processes.skill.triggers": "Rules",
  "processes.skill.skills": "Skills",
  "processes.skill.moveUp": "Move up",
  "processes.skill.moveDown": "Move down",
  "processes.filter.vertical": "Vertical",
  "processes.filter.problem": "Problem",
  "processes.filter.role": "Role",
  "processes.filter.champion": "Champion",
  "processes.filter.all": "All",
  "processes.filter.clear": "Clear filters",
  "processes.filter.empty": "No results for these filters.",
  "processes.filter.otherProblem": "Other",
  "processes.filter.byRole": "Show blueprints with the {{name}} role",
  "processes.filter.byChampion": "Show blueprints {{name}} can work on",
  "processes.vertical.engineering": "Engineering",
  "processes.vertical.product": "Product",
  "processes.vertical.marketing": "Marketing",
  "processes.vertical.sales": "Sales",
  "processes.vertical.strategy": "Strategy",
  "processes.vertical.project-management": "Project management",
  "processes.vertical.operations": "Operations",
  "processes.vertical.ecommerce": "E-commerce",
  "processes.vertical.social-media": "Social media",
  "processes.vertical.finance": "Finance",
  "processes.vertical.real-estate": "Real estate",
  "processes.vertical.testing": "Testing",
  "processes.vertical.design": "Design",
  "processes.vertical.support": "Support",
  "processes.vertical.knowledge": "Knowledge",
  "processes.vertical.compliance": "Compliance",
  "processes.vertical.other": "Other",
  "processes.bp.open": "View details →",
  "processes.bp.what": "What",
  "processes.bp.whatQ": "what the mission produces",
  "processes.bp.why": "Why",
  "processes.bp.whyQ": "why this process exists",
  "processes.bp.whyNone": "The blueprint does not explain its rationale beyond its description.",
  "processes.bp.when": "When",
  "processes.bp.whenQ": "the situations it fits",
  "processes.bp.who": "Who",
  "processes.bp.whoQ": "the squad's roles and the Champions who fill them",
  "processes.bp.whoIntro": "Each role is filled by a composed agent: a Champion (personality, working style) × the role (responsibilities, deliverable). The Champions listed fit the role best on this blueprint, primary first, then fallback.",
  "processes.bp.how": "How",
  "processes.bp.howQ": "the steps, rules and effort",
  "processes.bp.deliverables": "Deliverables",
  "processes.bp.disciplines": "Mandatory disciplines",
  "processes.bp.situations": "Typical situations",
  "processes.bp.keywords": "Trigger words",
  "processes.bp.stopWhen": "The mission stops if",
  "processes.bp.required": "Required",
  "processes.bp.optional": "Optional",
  "processes.bp.joinsWhen": "Joins the squad when:",
  "processes.bp.champions": "Champions:",
  "processes.bp.leads": "Leads:",
  "processes.bp.phaseOwner": "Led by",
  "processes.bp.phaseArtifact": "Produces",
  "processes.bp.phaseGate": "Stops if:",
  "processes.bp.steps": "Steps",
  "processes.bp.defaultFlowIntro": "No specific phases: the squad follows the standard mission flow, each step validated by a gate.",
  "processes.bp.flow.spec": "Spec (architect, G4)",
  "processes.bp.flow.implement": "Implementation (G5)",
  "processes.bp.flow.test": "Tests (G6)",
  "processes.bp.flow.review": "Review (G7)",
  "processes.bp.flow.retro": "Retro",
  "processes.bp.methodology": "Methodology applied:",
  "processes.bp.roleRules": "Working rules per role",
  "processes.bp.notes": "Notes",
  "processes.bp.tools": "Suggested tools (MCP):",
  "processes.bp.budget": "Estimated effort: ~{{duration}}, {{iterations}} iterations, {{tokens}} tokens at most.",
  "processes.bp.cadence": "Cadence:",
  "processes.bp.horizon.today": "Today",
  "processes.bp.horizon.this_week": "This week",
  "processes.bp.horizon.this_sprint": "This sprint",
  "processes.bp.horizon.this_quarter": "This quarter",
  "processes.bp.horizon.this_year": "This year",
  "processes.bp.cadenceValue.annual": "annual",
  "processes.bp.cadenceValue.monthly": "monthly",
  "processes.bp.cadenceValue.quarterly": "quarterly",
  "processes.bp.cadenceValue.per_sprint": "every sprint",
  "processes.bp.cadenceValue.monthly_or_six_week": "monthly or every 6 weeks",
  "processes.bp.shape.micro": "Micro",
  "processes.bp.shape.lite": "Lite",
  "processes.bp.shape.standard": "Standard",
  "processes.bp.shape.heavy": "Heavy",
  "processes.bp.shape.orchestration": "Orchestration",
  "processes.bp.shapeDesc.micro": "a single agent, a mini-brief, no gates: for a few-minute task.",
  "processes.bp.shapeDesc.lite": "an implementer + reviewer pair, a mini-brief, no scoping questions.",
  "processes.bp.shapeDesc.standard": "the full path: scoping (intent, brief, stories), full squad, gates G1 to G7.",
  "processes.bp.shapeDesc.heavy": "the full path plus a mandatory pre-mortem, an added security-reviewer, a tighter budget and a forced second review pass.",
  "processes.bp.shapeDesc.orchestration": "splits the intent into a project of several child missions, each with its own path.",
  "processes.blueprints.title": "Methodologies",
  "processes.blueprints.description": "The methodologies the team applies; each blueprint follows one.",
  "processes.templates.title": "Entry doors",
  "processes.templates.description": "The intake doors that seed a new mission, by nature.",
  "nav.accountSettings": "Settings",
  "nav.loadError": "Failed to load.",
  "office.switcher.label": "Switch office",
  "office.notFound": "Office not found or access denied.",
  "userMenu.label": "User menu",
  "userMenu.theme.label": "Theme",
  "userMenu.theme.light": "Light",
  "userMenu.theme.dark": "Dark",
  "userMenu.theme.auto": "Auto",
  "userMenu.editProfile": "Edit profile",
  "pocOnly": "Restricted to the office POC.",
  "form.create": "Create",
  "form.save": "Save",
  "form.cancel": "Cancel",
  "form.submitting": "Submitting…",
  "form.required": "Required field.",
  "form.name": "Name",
  "form.slug": "Slug",
  "form.slug.hint": "kebab-case: lowercase letters, digits, dashes.",
  "form.slug.invalid": "Invalid slug (kebab-case expected).",
  "form.description": "Description (optional)",
  "onboarding.title": "Welcome",
  "onboarding.intro": "Create your agency, then its first office to get started.",
  "onboarding.agency.title": "1. Create the agency",
  "onboarding.agency.created": "Agency created.",
  "onboarding.office.title": "2. Create the first office",
  "dashboard.title": "Dashboard",
  "dashboard.metrics.activeAgents": "Active agents",
  "dashboard.metrics.executingMissions": "Missions in progress",
  "dashboard.metrics.pendingSignoffs": "Pending signoffs",
  "dashboard.agentsAtWork": "Agents at work",
  "dashboard.noAgents": "No agents hired yet.",
  "dashboard.noActivity": "No current activity",
  "agent.status.idle": "Idle",
  "agent.status.working": "Working",
  "agent.status.waiting": "Waiting",
  "agent.status.offline": "Offline",
  "agent.tabs.label": "Agent sections",
  "agent.tabs.overview": "Overview",
  "agent.tabs.activity": "Activity",
  "agent.overview.status": "Status",
  "agent.overview.currentStory": "Current story",
  "agent.overview.currentActivity": "Current activity",
  "agent.overview.supervisor": "Supervisor",
  "agent.overview.runtimeTier": "Runtime",
  "agent.overview.hiredAt": "Hired on",
  "agent.overview.none": "—",
  "agent.activity.empty": "No recorded activity.",
  "agent.notFound": "Agent not found.",
  "projects.new": "New project",
  "projects.created": "Project created.",
  "projects.empty": "No projects yet. Create the first one.",
  "projects.statusUpdated": "Project status updated.",
  "projects.archive": "Archive",
  "projects.unarchive": "Restore",
  "projects.filter.label": "Filter projects",
  "projects.filter.active": "Active",
  "projects.filter.archived": "Archived",
  "project.notFound": "Project not found.",
  "project.tabs.label": "Project sections",
  "project.tabs.board": "Board",
  "project.tabs.missions": "Missions",
  "project.tabs.wiki": "Wiki",
  "board.label": "Kanban board",
  "board.newStory": "New story",
  "board.storyCreated": "Story created.",
  "board.moveFailed": "Failed to move the story.",
  "board.story.title": "Title",
  "board.story.mission": "Mission",
  "board.story.missionPlaceholder": "Pick a mission…",
  "board.story.acceptance": "Acceptance criteria (BDD)",
  "board.column.backlog": "Backlog",
  "board.column.planned": "Shaped",
  "board.column.in_progress": "In progress",
  "board.column.blocked": "Blocked",
  "board.column.in_review": "In review",
  "board.column.done": "Done",
  "board.column.cancelled": "Cancelled",
  "board.column.icebox": "Icebox",
  "board.column.brainstorming": "Exploring",
  "board.column.shaping": "Shaping",
  "board.column.building": "Building",
  "board.column.validating": "Validating",
  "board.column.operating": "Operating",
  "board.column.shipped": "Shipped",
  "board.column.archived": "Archived",
  "missions.new": "New mission",
  "missions.created": "Mission created.",
  "missions.empty": "No missions in this project.",
  "missions.cronInvalid": "A 5-field cron expression is required.",
  "missions.type.goal": "Goal",
  "missions.type.routine": "Routine",
  "missions.form.title": "Title",
  "missions.form.type": "Type",
  "missions.form.cron": "Cron expression (5 fields)",
  "missions.form.project": "Project",
  "missions.form.projectPlaceholder": "Pick a project…",
  "missions.form.process": "Execution process",
  "missions.process.sequential": "Sequential",
  "missions.process.hierarchical": "Hierarchical",
  "goals.empty": "No goal missions yet.",
  "routines.empty": "No routines yet.",
  "mission.notFound": "Mission not found.",
  "mission.artifacts.title": "Artifacts",
  "mission.artifacts.empty": "Artifacts will appear here once agents produce deliverables.",
  "mission.artifacts.version": "v{{n}}",
  "mission.artifacts.phase": "{{phase}}",
  "mission.artifacts.author": "By {{name}}",
  "mission.artifacts.download": "Download {{name}}",
  "mission.artifacts.preview": "Preview {{name}}",
  "mission.artifacts.cadrage": "Cadrage",
  "mission.files.title": "Mission files",
  "mission.files.empty": "No files yet.",
  "mission.files.selectFile": "Select a file to preview it.",
  "mission.files.source.github": "GitHub",
  "mission.files.source.studio": "Studio",
  "mission.files.status.stored": "Stored",
  "mission.files.status.deleted": "Deleted",
  "mission.files.status.oversize": "Oversize",
  "mission.files.status.binary": "Binary",
  "mission.files.revision": "v{{n}}",
  "mission.files.readOnly": "Read-only — mirrored from GitHub.",
  "mission.files.openOnGithub": "Open on GitHub",
  "mission.files.editorLabel": "Edit {{path}}",
  "mission.files.save": "Save",
  "mission.files.saving": "Saving…",
  "mission.files.saveError": "Could not save. Try again.",
  "mission.files.stale": "This file changed since you opened it.",
  "mission.files.reload": "Reload",
  "mission.files.history": "History",
  "mission.files.diffFrom": "From",
  "mission.files.diffTo": "To",
  "mission.files.showDiff": "Show diff",
  "mission.files.diffTooLarge": "Too large to diff.",
  "mission.artifactViewer.pending": "Not produced yet.",
  "mission.artifactViewer.openPdf": "Open the PDF",
  "mission.artifactViewer.download": "Download",
  "mission.process.view.flow": "Flow",
  "mission.process.officeEdition": "Office edition v{{version}}",
  "mission.process.view.list": "List",
  "mission.process.mode.plan": "Plan",
  "mission.process.mode.progression": "Progression",
  "mission.process.legend.advance": "Advance / passes",
  "mission.process.legend.failBranch": "Failure branch (halt · re-decompose · escalate)",
  "mission.process.legend.gate": "Decision gate",
  "mission.process.legend.done": "Done",
  "mission.process.legend.current": "In progress",
  "mission.process.legend.upcoming": "Upcoming",
  "mission.process.artifact.open": "Open {{name}}",
  "mission.process.throughline.title": "Process",
  "mission.process.status.done": "Done",
  "mission.process.status.current": "Current",
  "mission.process.status.upcoming": "Upcoming",
  "mission.process.upcoming": "Upcoming",
  "mission.process.methodologyLabel": "Methodology",
  "mission.process.step.kind.step": "Step",
  "mission.process.step.kind.checkpoint": "Checkpoint",
  "mission.process.step.kind.gate": "Gate",
  "mission.process.noMethodology": "No methodology chosen yet",
  "mission.process.customizeBlueprint": "Customize this blueprint",
  "mission.process.expandPhase": "Expand {{phase}}",
  "mission.process.collapsePhase": "Collapse {{phase}}",
  "mission.process.stepsProgress": "{{done}} / {{total}} steps done",
  "mission.process.stepState.done": "Done",
  "mission.process.stepState.todo": "To do",
  "mission.process.stepState.skipped": "Skipped — not done",
  "mission.process.evidence.file": "Evidence: {{ref}}",
  "mission.process.evidence.record": "Evidence: {{ref}}",
  "mission.process.evidence.signoff": "Gate approved by {{name}}",
  "mission.process.decision.approved": "Approved by {{name}} · {{date}}",
  "mission.process.decision.rejected": "Sent back by {{name}} · {{date}}",
  "mission.process.role.unassigned": "Unassigned",
  "mission.process.role.claude-main": "Claude (orchestrator)",
  "mission.process.role.architect": "Architect",
  "mission.process.role.implementer": "Implementer",
  "mission.process.role.implementers": "Implementers",
  "mission.process.role.tester": "Tester",
  "mission.process.role.reviewer": "Reviewer",
  "mission.process.role.analyst": "Analyst",
  "mission.process.role.backend-engineer": "Backend Engineer",
  "mission.process.role.frontend-engineer": "Frontend Engineer",
  "mission.process.role.debugger": "Debugger",
  "mission.process.role.depends-on-hotspot": "Depends on hotspot",
  "mission.process.role.devops-engineer": "DevOps Engineer",
  "mission.process.role.doc-writer": "Doc Writer",
  "mission.process.role.docs-architect": "Docs Architect",
  "mission.process.role.migration-engineer": "Migration Engineer",
  "mission.process.role.performance-engineer": "Performance Engineer",
  "mission.process.role.researcher": "Researcher",
  "mission.process.role.shaper": "Shaper",
  "mission.process.role.tech-writer": "Tech Writer",
  "mission.process.role.tutorial-engineer": "Tutorial Engineer",
  "mission.status.proposal": "Proposal",
  "mission.status.clarification": "Clarification",
  "mission.status.methodology": "Methodology",
  "mission.status.planning": "Planning",
  "mission.status.awaiting_signoff": "Signoff",
  "mission.status.executing": "Executing",
  "mission.status.review": "Review",
  "mission.status.done": "Done",
  "mission.status.paused": "Paused",
  "mission.status.archived": "Archived",
  "mission.stepper.label": "Mission lifecycle",
  "mission.stepper.manualHint": "Manual driver (Phase 1) — click a phase to move the mission there.",
  "mission.stepper.goTo": "Move to \"{{phase}}\"",
  "mission.journey.label": "Mission journey",
  "mission.journey.processLabel": "View process",
  "mission.journey.openProcess": "View process",
  "mission.journey.forked": "Process forked",
  "mission.journey.closePopover": "Close step details",
  "mission.journey.gatePending": "Signoff pending — jump to the gate",
  "mission.journey.gateApproved": "Gate approved",
  "mission.journey.gateLocked": "Gate locked",
  "mission.journey.gateLine": "{{label}} — {{state}}",
  "mission.journey.gateState.approved": "approved",
  "mission.journey.gateState.pending": "awaiting signoff",
  "mission.journey.gateState.locked": "locked",
  "mission.journey.status.done": "Done",
  "mission.journey.status.current": "Current",
  "mission.journey.status.future": "Upcoming",
  "mission.journey.history.empty": "No decision yet.",
  "mission.journey.mark.pass": "Gate approved",
  "mission.journey.mark.bypassed": "Gate approved with bypass",
  "mission.journey.mark.fail": "Gate rejected",
  "mission.journey.mark.defer": "Gate pending — evidence missing, jump to the gate",
  "mission.journey.tooltip.proven": "{{n}}/{{m}} criteria proven",
  "mission.journey.tooltip.bypass": "Bypass: {{reason}}",
  "mission.lifecycle.note.done": "Step cleared and validated.",
  "mission.lifecycle.note.current": "In progress — work is focused here.",
  "mission.lifecycle.note.planned": "Planned — not reached yet.",
  "mission.step.idea.explore": "Explore",
  "mission.step.idea.validate": "Validate",
  "mission.step.idea.verdict": "Verdict",
  "mission.step.idea.act": "Act",
  "mission.step.decision.frame": "Frame",
  "mission.step.decision.weigh": "Weigh",
  "mission.step.decision.recommend": "Recommend",
  "mission.step.decision.act": "Act",
  "mission.step.question.research": "Research",
  "mission.step.question.synthesize": "Synthesize",
  "mission.step.question.answer": "Answer",
  "mission.step.question.act": "Act",
  "mission.step.issue.diagnose": "Diagnose",
  "mission.step.issue.plan": "Plan",
  "mission.step.issue.implement": "Implement",
  "mission.step.issue.test": "Test",
  "mission.step.issue.release": "Release",
  "mission.step.goal.framing": "Framing",
  "mission.step.goal.shaping": "Shaping",
  "mission.step.goal.building": "Building",
  "mission.step.goal.testing": "Testing",
  "mission.step.goal.releasing": "Releasing",
  "mission.step.concern.framing": "Framing",
  "mission.step.concern.shaping": "Shaping",
  "mission.step.concern.building": "Building",
  "mission.step.concern.testing": "Testing",
  "mission.step.concern.releasing": "Releasing",
  "mission.step.review.audit": "Audit",
  "mission.step.review.prioritize": "Prioritize",
  "mission.step.review.verdict": "Verdict",
  "mission.step.monitor.cadrage": "Scoping",
  "mission.step.monitor.launch": "Launch",
  "mission.step.monitor.piloting": "Piloting",
  "mission.step.improve.baseline": "Baseline",
  "mission.step.improve.launch": "Launch",
  "mission.step.improve.optimizing": "Optimizing",
  "mission.step.maintain.cadrage": "Scoping",
  "mission.step.maintain.launch": "Launch",
  "mission.step.maintain.running": "Running",
  "mission.step.advisory.setup": "Setup",
  "mission.step.advisory.observing": "Observing",
  "mission.clarifications.title": "Clarifications",
  "mission.clarifications.empty": "No questions yet.",
  "mission.clarifications.ask": "Ask a question",
  "mission.clarifications.answer": "Answer",
  "mission.clarifications.questionPlaceholder": "Your question…",
  "mission.clarifications.answerPlaceholder": "Your answer…",
  "mission.clarifications.round": "Round {{round}}",
  "mission.methodology.title": "Methodology",
  "mission.methodology.current": "Current methodology: {{methodology}}",
  "mission.methodology.none": "No methodology chosen.",
  "mission.methodology.placeholder": "e.g. bdd-stories",
  "mission.methodology.apply": "Set",
  "mission.methodology.suggestions": "Suggestions",
  "mission.signoffs.title": "Signoffs",
  "mission.signoffs.empty": "No signoff requested.",
  "mission.signoffs.request.plan": "Request plan signoff",
  "mission.signoffs.request.verdict": "Request verdict signoff",
  "mission.signoffs.pending": "{{kind}} signoff awaiting decision",
  "mission.signoffs.kind.plan": "plan",
  "mission.signoffs.kind.verdict": "verdict",
  "mission.signoffs.kind.data_write": "write access",
  "mission.signoffs.approve": "Approve",
  "mission.signoffs.reject": "Reject",
  "mission.signoffs.approved": "Approved",
  "mission.signoffs.rejected": "Rejected",
  "mission.signoffs.comment": "Comment",
  "mission.signoffs.commentPlaceholder": "Comment (optional)",
  "mission.signoffs.waitPoc": "Waiting for the POC's decision.",
  "mission.gate.blueprint": "Blueprint: {{name}}",
  "mission.gate.methodology": "Method: {{name}}",
  "mission.gate.pending": "Gate: {{label}}",
  "mission.gate.approve": "Approve",
  "mission.gate.sendBack": "Send back",
  "mission.gate.pocOnly": "POC-only for this office.",
  "mission.gate.title": "Gate — {{label}}",
  "mission.gate.required": "signoff required",
  "mission.gate.approvedBy": "Approved by {{name}} · {{date}}",
  "mission.gate.rejectedBy": "Sent back by {{name}} · {{date}}",
  "mission.gate.dataWrite.summary": "Allow this mission's agents to WRITE to {{source}} (create / update / send). Reading is unchanged.",
  "mission.gate.ledger.title": "Phase criteria",
  "mission.gate.ledger.proven": "{{n}}/{{m}} proven",
  "mission.gate.ledger.missingTag": "Missing",
  "mission.gate.ledger.missingList": "Missing evidence: {{codes}}",
  "mission.gate.ledger.bypassLabel": "Bypass reason",
  "mission.gate.ledger.bypassHint": "Required to approve despite missing evidence.",
  "mission.gate.ledger.bypassCounter": "{{count}}/{{max}}",
  "mission.gate.ledger.approveWithBypass": "Approve with bypass",
  "mission.gate.ledger.receiptProven": "{{verified}}/{{total}} proven at decision time",
  "mission.gate.ledger.receiptBypass": "Bypass: {{reason}}",
  "mission.gate.ledger.bypassTag": "Bypass",
  "mission.gate.plan.squadTitle": "Squad",
  "mission.gate.plan.viewOnGithub": "View on GitHub",
  "mission.github.issue": "Mission issue on GitHub",
  "mission.github.issueN": "Issue #{{n}} on GitHub",
  "mission.github.stories": "Stories on GitHub",
  "mission.github.storyIssue": "Issue",
  "mission.github.storyPr": "PR #{{n}}",
  "mission.gate.plan.role": "Role",
  "mission.gate.plan.champion": "Champion",
  "mission.gate.plan.model": "Model",
  "mission.gate.plan.effort": "Effort",
  "mission.gate.plan.budget": "Budget",
  "mission.gate.plan.receiptSquad": "Squad approved: {{squad}}",
  "mission.kickoff.title": "Next step: {{phase}}",
  "mission.kickoff.storyTitle": "Assign: {{title}}",
  "mission.kickoff.objective.reasoning": "Frame the mission: understand the need, state the assumptions, pick the blueprint.",
  "mission.kickoff.objective.shaping": "Shape the solution: spec, break down into stories, confirm the squad.",
  "mission.kickoff.objective.building": "Build the deliverable: implement, test, document.",
  "mission.kickoff.objective.steering": "Steer in production: monitor, adjust, report.",
  "mission.kickoff.artifactSuffix": "Deliverable: {{artifact}}",
  "mission.kickoff.gateSuffix": "Gate: {{gate}}",
  "mission.kickoff.methodologyLabel": "Methodology",
  "mission.kickoff.agentLabel": "Agent",
  "mission.kickoff.modelLabel": "Model",
  "mission.kickoff.modelAuto": "Auto (routed)",
  "mission.kickoff.effortLabel": "Effort",
  "mission.kickoff.effort.low": "Low",
  "mission.kickoff.effort.medium": "Medium",
  "mission.kickoff.effort.high": "High",
  "mission.kickoff.pickAgent": "Choose an agent",
  "mission.kickoff.recommended": "recommended",
  "mission.kickoff.launch": "Launch",
  "mission.kickoff.launching": "Launching…",
  "mission.stories.title": "Stories",
  "mission.stories.empty": "No stories planned.",
  "mission.stories.viewBoard": "View the project board",
  "mission.squad.title": "Squad",
  "mission.squad.empty": "No agents assigned to this mission.",
  "mission.squad.pocYou": "You",
  "mission.squad.pocUnnamed": "POC",
  "mission.squad.rolesAria": "Roles on the mission",
  "mission.squad.badge.lead": "Lead",
  "mission.squad.badge.pm": "PM",
  "mission.squad.badge.productOwner": "Product owner",
  "mission.squad.badge.projectManager": "Project manager",
  "mission.squad.badge.leadPm": "Lead · PM",
  "mission.squad.badge.temporary": "one-off",
  "mission.squad.variant.lead": "Mission lead",
  "mission.squad.variant.temporary": "Temporary (one-off)",
  "mission.squad.variant.permanent": "Permanent",
  "story.verdict.ship": "Ship",
  "story.verdict.needs_work": "Needs work",
  "story.verdict.block": "Block",
  "org.empty": "No agents on the office staff.",
  "org.hire": "Hire an agent",
  "org.hireSubmit": "Hire",
  "org.hired": "Agent hired.",
  "org.form.displayName": "Display name",
  "org.form.champion": "Champion (slug)",
  "org.form.role": "Role (slug)",
  "org.form.supervisor": "Supervisor",
  "org.form.noSupervisor": "None",
  "org.form.runtimeTier": "Runtime",
  "wiki.empty": "No pages yet. Create the first one.",
  "wiki.tree.label": "Page tree",
  "wiki.newPage": "New page",
  "wiki.selectPage": "Select a page in the tree.",
  "wiki.editorLabel": "Page content",
  "wiki.save": "Save",
  "wiki.saved": "Page saved.",
  "wiki.version": "v{{version}}",
  "wiki.delete": "Delete page",
  "wiki.deleteConfirm": "Confirm deletion?",
  "wiki.pageCreated": "Page created.",
  "wiki.pageDeleted": "Page deleted.",
  "wiki.pageNotFound": "Page not found.",
  "wiki.form.title": "Title",
  "wiki.form.parent": "Parent page (optional)",
  "wiki.form.noParent": "None",
  "wiki.search.label": "Wiki search",
  "wiki.search.placeholder": "Search the wiki…",
  "wiki.search.button": "Search",
  "wiki.search.empty": "No results.",
  "settings.identity.title": "Office identity",
  "settings.identity.save": "Save",
  "settings.identity.saved": "Office updated",
  "settings.identity.slugTaken": "That slug is taken",
  "settings.stakeholders.title": "Stakeholders",
  "settings.stakeholders.add": "Add",
  "settings.stakeholders.added": "Stakeholder added.",
  "settings.stakeholders.removed": "Stakeholder removed.",
  "settings.stakeholders.email": "Email",
  "settings.stakeholders.emailInvalid": "Invalid email address.",
  "settings.stakeholders.role": "Role",
  "settings.stakeholders.name": "Name",
  "settings.stakeholders.remove": "Remove",
  "settings.stakeholders.removeConfirm": "Confirm?",
  "settings.stakeholders.empty": "No stakeholders.",
  "settings.stakeholders.actions": "Actions",
  "settings.stakeholders.invite": "Invite",
  "settings.stakeholders.invited": "Invitation sent. They become a member once they accept.",
  "settings.invitations.title": "Pending invitations",
  "settings.invitations.pending": "Pending",
  "settings.invitations.revoke": "Revoke",
  "settings.invitations.revoked": "Invitation revoked.",
  "invitations.title": "Invitations",
  "invitations.intro": "You become a member of an office only once you accept. Until then, nothing about you is shared with it.",
  "invitations.empty": "No pending invitations.",
  "invitations.from": "Invited by {{name}} as {{role}}",
  "invitations.accept": "Accept",
  "invitations.decline": "Decline",
  "invitations.accepted": "Invitation accepted.",
  "invitations.declined": "Invitation declined.",
  "invitations.continue": "Continue without joining",
  "settings.role.poc": "POC",
  "settings.role.stakeholder": "Stakeholder",
  "settings.role.viewer": "Viewer",
  "nav.rail.label": "Agency navigation",
  "nav.rail.inbox": "Inbox",
  "nav.rail.offices": "Offices",
  "nav.agency.switcher.label": "Switch agency",
  "nav.agency.admin": "admin",
  "nav.agency.new": "New agency",
  "nav.office.bubble.add": "New office",
  "nav.breadcrumb.label": "Breadcrumb",
  "nav.missions": "Missions",
  "office.new": "New office — {{agency}}",
  "office.created": "Office created",
  "form.slug.taken": "This slug is already taken",
  "nav.automations": "Automations",
  "missions.form.goal": "Goal (the outcome)",
  "missions.form.goalPlaceholder": "The outcome, not the artifact…",
  "missions.form.trigger": "Trigger",
  "missions.trigger.manual": "Manual (one-shot)",
  "missions.trigger.cron": "Routine (cron)",
  "missions.trigger.event": "Automation (event)",
  "missions.trigger.eventSoon": "Soon — needs the inbox",
  "missions.officeEmpty": "No missions yet.",
  "missions.gateBand.label": "{{pass}} passed, {{bypassed}} bypassed, {{fail}} failed, {{pending}} pending",
  "missions.gateBand.bypassCount_one": "{{count}} bypass",
  "missions.gateBand.bypassCount_other": "{{count}} bypasses",
  "missions.index.title": "Mission folders",
  "missions.index.empty": "No mission folders yet.",
  "missions.index.columns.date": "Date",
  "missions.index.columns.mid": "MID",
  "missions.index.columns.title": "Title",
  "missions.index.columns.state": "State",
  "missions.index.columns.phase": "Phase",
  "missions.index.columns.source": "Source",
  "missions.index.columns.links": "Links",
  "missions.index.import": "Import",
  "missions.index.importing": "Importing…",
  "missions.index.importError": "Import failed.",
  "missions.index.importSuccess": "Import complete.",
  "missions.index.export": "Export",
  "missions.index.openStudio": "Open",
  "missions.index.openGithub": "GitHub",
  "missions.index.openIssue": "Issue",
  "automations.empty": "No automations yet.",
  "catalog.picker.role": "Role",
  "catalog.picker.rolePlaceholder": "Choose a role…",
  "catalog.picker.champion": "Champion",
  "catalog.picker.championPlaceholder": "Choose a champion…",
  "catalog.picker.compatible": "Compatible",
  "catalog.picker.lowAffinity": "Low affinity",
  "catalog.picker.affinity": "Affinity: {{affinity}}",
  "catalog.picker.affinityLow": "Low affinity for this role",
  "org.actions.buildSquad": "Build a squad",
  "squad.catalog.title": "Build a squad",
  "squad.catalog.tab.ready": "Ready Squads",
  "squad.catalog.tab.custom": "Custom",
  "squad.catalog.customSoon": "The custom builder is coming soon.",
  "squad.card.hire": "Hire",
  "squad.card.workflow": "Workflow",
  "squad.card.members_one": "{{count}} agent",
  "squad.card.members_other": "{{count}} agents",
  "squad.hired": "Squad hired.",
  "org.node.human": "Human",
  "org.node.reportsTo": "Reports to",
  "org.node.topOfChart": "Top of the chart",
  "org.node.remove": "Remove",
  "org.node.removeConfirm": "Remove this member from the chart?",
  "org.node.saved": "Updated.",
  "org.node.removed": "Removed.",
  "org.node.cycle": "That would create a reporting loop.",
  "org.node.editHint": "Click a node to move or remove it.",
  "org.chart.dragHint": "Drag from a node’s bottom onto a manager to connect ; drop an edge on empty space to detach ; click a node to edit or remove it.",
  "nav.agency.settings": "Agency settings",
  "agency.settings.title": "Agency — {{name}}",
  "agency.settings.delete": "Delete agency",
  "agency.settings.deleteConfirm": "Delete this agency? This cannot be undone.",
  "agency.settings.notEmpty": "Remove its offices first.",
  "agency.settings.saved": "Agency updated.",
  "agency.settings.deleted": "Agency deleted.",
  "agency.manage.title": "Manage agencies",
  "agency.manage.empty": "No agencies to manage.",
  "agency.manage.back": "Back",
  "agency.manage.edit": "Edit agency",
  "hotkeys.title": "Keyboard shortcuts",
  "hotkeys.group.general": "General",
  "hotkeys.group.navigate": "Navigation",
  "hotkeys.group.create": "Create",
  "hotkeys.help": "Show shortcuts",
  "hotkeys.palette": "Command palette",
  "hotkeys.goBrainstorming": "Brainstorming",
  "hotkeys.goExecution": "Execution",
  "hotkeys.goGroups": "Groups",
  "hotkeys.goMission": "Go to mission…",
  "hotkeys.goInbox": "Inbox",
  "hotkeys.goHome": "My work",
  "hotkeys.newGroup": "New group",
  "hotkeys.goDashboard": "Dashboard",
  "hotkeys.goMissions": "Missions",
  "hotkeys.goRoutines": "Routines",
  "hotkeys.goAutomations": "Automations",
  "hotkeys.goProjects": "Projects",
  "hotkeys.goOrg": "Org chart",
  "hotkeys.goWiki": "Wiki",
  "hotkeys.newMission": "New mission",
  "hotkeys.newProject": "New project",
  "nav.flow": "Flow",
  "flow.title": "Mission flow",
  "flow.empty": "No stories to display for this mission.",
  "flow.error": "The story DAG cannot be built (cyclic or unknown dependency).",
  "flow.launch": "Launch mission",
  "flow.launched": "Mission launched",
  "flow.phase": "Phase: {{phase}}",
  "flow.escalation": "Escalation pending: a story is blocked and needs a decision.",
  "flow.node.unassigned": "Unassigned",
  "flow.node.artifact": "Artifact produced",
  "flow.node.escalated": "Escalated",
  "flow.sub.queued": "Queued",
  "flow.sub.implementing": "Implementing",
  "flow.sub.reviewing": "Reviewing",
  "flow.sub.awaiting_merge": "Awaiting merge",
  "flow.sub.blocked": "Blocked",
  "flow.sub.cancelled": "Cancelled",
  "flow.sub.done": "Done",
  "loop.empty": "No reviewer verdict yet for this story.",
  "loop.error": "Could not load this story's verdict history.",
  "loop.attempt": "Attempt {{n}}",
  "loop.evidence.kind.test_output": "Test output",
  "loop.evidence.kind.artifact": "Artifact",
  "loop.evidence.kind.data": "Data",
  "loop.evidence.kind.unknown": "Evidence",
  "loop.evidence.error.malformed_json": "This attempt's evidence could not be read (malformed data).",
  "loop.evidence.error.not_array": "This attempt's evidence could not be read (unexpected shape).",
  "loop.header.shipped": "Shipped on attempt {{n}} of {{max}} allowed ({{rigor}} rigor)",
  "loop.header.shippedNoRigor": "Shipped on attempt {{n}} of {{max}} allowed",
  "loop.header.escalated": "Escalated to the POC after attempt {{n}} of {{max}} allowed ({{rigor}} rigor)",
  "loop.header.escalatedNoRigor": "Escalated to the POC after attempt {{n}} of {{max}} allowed",
  "loop.header.rework": "Needs rework: attempt {{n}} of {{max}} allowed, another attempt follows ({{rigor}} rigor)",
  "loop.header.reworkNoRigor": "Needs rework: attempt {{n}} of {{max}} allowed, another attempt follows",
  "loop.header.in_progress": "In progress: attempt {{n}} of {{max}} allowed ({{rigor}} rigor)",
  "loop.header.in_progressNoRigor": "In progress: attempt {{n}} of {{max}} allowed",
  "loop.ceiling.help": "Attempt ceiling: after {{max}} reviews without approval, the story is escalated to the POC. It comes from the mission rigor ({{rigor}}); the review cycle allows at most {{graphMax}}.",
  "loop.ceiling.helpNoRigor": "Attempt ceiling: after {{max}} reviews without approval, the story is escalated to the POC.",
  "loop.rigor.fast": "Fast",
  "loop.rigor.steady": "Steady",
  "loop.rigor.solid": "Solid",
  "loop.verdict.ship": "Approved",
  "loop.verdict.needsWork": "Needs rework",
  "loop.verdict.block": "Blocked",
  "loop.who.unknown": "Unknown agent",
  "loop.who.withRole": "{{name}} ({{role}})",
  "loop.step.implement": "Implementation",
  "loop.step.tests": "Tests (G6)",
  "loop.step.review": "Review",
  "loop.step.security": "Security review",
  "loop.run.none": "No run recorded for this attempt.",
  "loop.run.effort": "{{effort}} effort",
  "loop.run.outcome.ok": "succeeded",
  "loop.run.outcome.needs_human": "needs a human",
  "loop.run.outcome.blocked": "blocked",
  "loop.run.outcome.failed": "failed",
  "loop.tests.summary": "{{passed}} passed, {{failed}} failed",
  "loop.review.by.ship": "{{who}} approved the story.",
  "loop.review.by.needsWork": "{{who}} asked for rework.",
  "loop.review.by.block": "{{who}} blocked the story.",
  "loop.review.by.other": "{{who}} returned verdict {{verdict}}.",
  "loop.security.none": "Required by the {{rigor}} rigor: no security review recorded for this attempt.",
  "loop.checks.title": "Acceptance criteria",
  "loop.checks.none": "No evidence attached to this verdict.",
  "loop.check.status.pass": "Passed",
  "loop.check.status.fail": "Failed",
  "loop.check.status.waived": "Waived",
  "loop.check.status.pending": "Pending",
  "loop.check.status.unknown": "Unknown status",
  "loop.check.untitled": "Evidence",
  "loop.check.raw": "Raw detail",
  "loop.oracle.test": "checked by an automated test",
  "loop.oracle.eval": "checked by an eval case",
  "loop.oracle.e2e": "checked by an end-to-end test",
  "loop.oracle.live": "checked live",
  "loop.oracle.review": "checked in code review",
  "loop.oracle.capture": "checked on a screenshot",
  "loop.oracle.checklist": "checked against a checklist",
  "loop.oracle.crossref": "checked by cross-referencing the file",
  "loop.oracle.recompute": "checked by recomputing the result",
  "loop.oracle.prediction": "to be confirmed later (prediction)",
  "loop.oracle.human_verify": "to be checked by a human",
  "loop.oracle.other": "method: {{oracle}}",
  "loop.link.pr": "Pull request #{{n}}",
  "loop.link.issue": "GitHub issue",
  "loop.link.commit": "Commit",
  "loop.link.branch": "Branch",
  "loop.link.runLog": "Run log",
  "loop.link.reviewLog": "Review run log",
  "loop.link.reviewComment": "Review comment",
  "loop.link.open": "Open",
  "loop.prompt.button": "Prompt",
  "loop.prompt.buttonLabel": "Show the exact prompt of this run",
  "loop.prompt.title": "Run prompt",
  "loop.prompt.titleWho": "Run prompt — {{who}}",
  "loop.prompt.close": "Close",
  "loop.prompt.loading": "Loading the prompt…",
  "loop.prompt.error": "The prompt of this run could not be loaded.",
  "loop.prompt.empty": "No prompt recorded for this run: it started before prompts were recorded.",
  "loop.prompt.mode.compiled": "Compiled by the platform",
  "loop.prompt.mode.plugin": "Plugin path",
  "loop.prompt.mode.host": "Step run by the platform (no prompt)",
  "loop.prompt.mode.unknown": "Unknown prompt origin",
  "loop.prompt.verify.checking": "Checking…",
  "loop.prompt.verify.verified": "verified",
  "loop.prompt.verify.verifiedServer": "verified by the server",
  "loop.prompt.verify.mismatch": "not verified",
  "loop.prompt.verify.noRecord": "no fingerprint recorded",
  "loop.prompt.verify.help.verified": "Your browser recomputed the SHA-256 fingerprint of the text shown: it equals the one recorded when the run started.",
  "loop.prompt.verify.help.verifiedServer": "Some values are masked on screen, so your browser cannot recompute the fingerprint. The server computed it on the stored text: it equals the one recorded when the run started.",
  "loop.prompt.verify.help.mismatch": "The stored text's fingerprint differs from the one recorded when the run started: this may not be exactly what the agent received.",
  "loop.prompt.verify.help.noRecord": "This run has no recorded fingerprint: the text cannot be verified.",
  "loop.prompt.sha": "Fingerprint {{sha}}",
  "loop.prompt.bundle": "Configuration {{id}}",
  "loop.prompt.compiler": "Compiler {{version}}",
  "loop.prompt.pluginVersion": "Plugin {{version}}",
  "loop.prompt.fallback": "Compilation was refused ({{code}}): the run used the plugin path.",
  "runs.agentConfig.platform": "Agents: platform · v{{version}}",
  "runs.agentConfig.fallback": "Agents: plugin (fallback — {{reason}})",
  "build.agentConfig.reason.architect_spec_requires_llm": "the squad has an architect — the plugin writes the spec",
  "build.agentConfig.reason.bundle_unavailable": "no agent catalogue is available yet",
  "build.agentConfig.reason.preflight_failed": "the check could not run",
  "build.agentConfig.reason.other": "the platform cannot compose this mission",
  "runs.agentConfig.reason.agent_config_unbound": "the platform service is not connected",
  "runs.agentConfig.reason.agent_config_rpc_failed": "the platform did not answer in time",
  "runs.agentConfig.reason.agent_config_unknown": "the version does not belong to this mission",
  "runs.agentConfig.reason.manifest_mismatch": "the published files did not match their version",
  "runs.agentConfig.reason.mount_failed": "the folder could not be mounted",
  "runs.agentConfig.reason.mount_unreadable": "the mounted folder could not be read",
  "runs.agentConfig.reason.mount_writable": "the mounted folder was not read-only",
  "runs.agentConfig.reason.refused": "the platform refused to compose",
  "runs.agentConfig.reason.refused_architect_spec_requires_llm": "the squad has an architect",
  "runs.agentConfig.reason.refused_secret_detected": "a secret was detected in the configuration",
  "runs.agentConfig.reason.refused_bundle_unavailable": "no agent catalogue is available",
  "runs.agentConfig.reason.refused_no_plan": "no approved plan was found",
  "runs.agentConfig.reason.other": "unexpected error",
  "loop.prompt.redacted": "Values that look like secrets or personal data are masked on screen.",
  "loop.prompt.truncated": "Text truncated on screen: only the end is shown.",
  "loop.prompt.sections": "Sections ({{count}})",
  "loop.prompt.sectionsHelp": "In send order. Platform and plugin sections are locked; only office sections can be edited.",
  "loop.prompt.jumpTo": "Go to section {{title}}",
  "loop.prompt.origin.platform": "platform",
  "loop.prompt.origin.plugin": "plugin",
  "loop.prompt.origin.office": "office",
  "loop.prompt.locked": "locked",
  "loop.prompt.editable": "editable by the office",
  "loop.prompt.version": "version {{version}}",
  "loop.prompt.item": "item {{sha}}",
  "loop.prompt.chars": "{{count}} characters",
  "loop.prompt.text": "Full text",
  "loop.prompt.argv": "Launch line",
  "loop.prompt.guidance": "Appended instructions (guidance)",
  "loop.prompt.copy": "Copy the text",
  "loop.prompt.copied": "Copied",
  "loop.prompt.raw": "Raw text",
  "loop.prompt.rawManifest": "Manifest (JSON)",
  "loop.step.testRun": "Test run",
  "loop.verdict.none": "No verdict",
  "loop.step.testCycle": "Test run, cycle {{n}}",
  "loop.review.none": "No review verdict for this attempt.",
  "workspaceActivity.empty": "No activity yet for this mission.",
  "workspaceActivity.latestVerdicts": "Latest verdicts",
  "workspaceActivity.retryCount": "{{n}} retry(ies)",
  "workspaceActivity.feed": "Live feed",
  "workspaceActivity.ghTransition": "{{sid}} -> {{to}}",
  "nav.connectors": "Connectors",
  "connectors.title": "Connectors",
  "connectors.subtitle": "MCP servers connected to this office.",
  "connectors.empty": "No connectors registered yet.",
  "connectors.register": "Register a connector",
  "connectors.registered": "Connector registered.",
  "connectors.removed": "Connector removed.",
  "connectors.remove": "Remove",
  "connectors.removeConfirm": "Remove this connector?",
  "connectors.column.name": "Name",
  "connectors.column.url": "Server URL",
  "connectors.column.status": "Status",
  "connectors.column.actions": "Actions",
  "connectors.status.registered": "Registered",
  "connectors.status.credential_pending": "Credential pending",
  "connectors.status.active": "Active",
  "connectors.form.name": "Name",
  "connectors.form.serverUrl": "Server URL",
  "connectors.form.serverUrlHint": "The MCP server endpoint (https URL).",
  "connectors.form.urlInvalid": "Enter a valid URL.",
  "connectors.setToken": "Set token",
  "connectors.updateToken": "Update token",
  "connectors.token": "Auth token",
  "connectors.tokenSaved": "Token saved.",
  "connectors.tokenHint": "Stored encrypted; used only by the host when your automations call this connector.",
  "automations.title": "Automations",
  "automations.subtitle": "This office's automations.",
  "automations.create": "New automation",
  "automations.created": "Automation created.",
  "automations.column.name": "Name",
  "automations.column.status": "Status",
  "automations.status.draft": "Draft",
  "automations.status.active": "Active",
  "automations.status.paused": "Paused",
  "automations.form.name": "Name",
  "automations.viewFlow": "View flow",
  "automations.backToList": "Back to automations",
  "automations.flow.title": "Automation flow",
  "home.title": "My Work",
  "home.greeting.morning": "Good morning",
  "home.greeting.afternoon": "Good afternoon",
  "home.greeting.evening": "Good evening",
  "home.greeting.named": "Hello, {{name}}",
  "home.greeting.anon": "Hello",
  "home.myTasks.title": "My tasks",
  "home.myTasks.empty": "No tasks assigned to you.",
  "home.myTasks.filterLabel": "Filter tasks by due date",
  "home.myTasks.filter.all": "All",
  "home.myTasks.filter.today": "Today",
  "home.myTasks.filter.upcoming": "Upcoming",
  "home.myTasks.filter.overdue": "Overdue",
  "home.myTasks.filter.no_due": "No due date",
  "home.myTasks.viewToggle": "Task view",
  "home.myTasks.viewList": "List view",
  "home.myTasks.viewCalendar": "Calendar view",
  "home.myTasks.col.title": "Task",
  "home.myTasks.col.project": "Project",
  "home.myTasks.col.status": "Status",
  "home.myTasks.col.due": "Due",
  "home.myTasks.noDue": "—",
  "home.myTasks.addTask": "Add task",
  "home.myTasks.addTaskProject": "In project",
  "home.myTasks.addTaskPick": "Pick a project…",
  "home.myTasks.addTaskGo": "Open board",
  "home.calendar.prev": "Previous month",
  "home.calendar.next": "Next month",
  "home.calendar.noDue": "No due date",
  "home.todos.title": "To-do list",
  "home.todos.add": "Add to-do",
  "home.todos.addLabel": "New to-do",
  "home.todos.addPlaceholder": "Add a personal to-do…",
  "home.todos.empty": "Nothing on your list.",
  "home.todos.delete": "Delete \"{{title}}\"",
  "home.activity.title": "Activity",
  "home.activity.tabsLabel": "Activity feed",
  "home.activity.tab.tasks": "Tasks",
  "home.activity.tab.time": "Time logged",
  "home.activity.kind.human": "Human",
  "home.activity.kind.agent": "Agent",
  "home.activity.empty.tasks": "No recent task activity.",
  "home.activity.empty.time": "No time logged yet.",
  "home.activity.notif.assignment": "You were assigned a story",
  "home.activity.notif.mention": "You were mentioned",
  "home.activity.notif.app_ci.failed": "A branch build failed ({{code}})",
  "home.activity.notif.app_ci.ready_to_go_live": "A new version of main is built and ready to go live",
  "home.activity.notif.app_ci.budget_exhausted": "Branch builds are paused: the office budget is reached",
  "home.activity.notif.app_ci.preview_evicted": "An older branch preview was removed (limit of {{cap}} per app)",
  "home.activity.notif.delivery.failed": "Going online did not complete ({{code}})",
  "home.activity.timeEntry": "logged {{duration}} on {{date}}",
  "home.recent.title": "Projects",
  "home.recent.tabsLabel": "Recent and favorite projects",
  "home.recent.tab.recents": "Recent",
  "home.recent.tab.favorites": "Favorites",
  "home.recent.empty.recents": "No recently viewed projects.",
  "home.recent.empty.favorites": "No favorite projects yet.",
  "home.recent.star": "Add \"{{name}}\" to favorites",
  "home.recent.unstar": "Remove \"{{name}}\" from favorites",
  "projects.filter.all": "All",
  "projects.filter.favourites": "Favourites",
  "projects.view.list": "List",
  "projects.view.group": "Group",
  "projects.groupBy.label": "Group by",
  "projects.groupBy.category": "Category",
  "projects.groupBy.health": "Health",
  "projects.groupBy.none": "No category",
  "projects.column.name": "Project",
  "projects.column.category": "Category",
  "projects.column.progress": "Progress",
  "projects.column.pm": "PM",
  "projects.column.updated": "Updated",
  "projects.health.not_set": "Not set",
  "projects.health.on_track": "On track",
  "projects.health.at_risk": "At risk",
  "projects.health.off_track": "Off track",
  "projects.favorite.add": "Add to favourites",
  "projects.favorite.remove": "Remove from favourites",
  "projects.favorite.failed": "Could not update favourite",
  "projects.pm.none": "Unassigned",
  "projects.progress.label": "{{pct}}% done",
  "projects.edit": "Edit project",
  "projects.updated": "Project updated",
  "projects.drawer.createTitle": "New project",
  "projects.drawer.editTitle": "Edit project",
  "projects.form.color": "Color",
  "projects.form.status": "Status",
  "projects.form.health": "Health",
  "projects.form.category": "Category",
  "projects.form.categoryNone": "No category",
  "projects.form.startDate": "Start date",
  "projects.form.endDate": "End date",
  "projects.form.manager": "Project manager",
  "projects.form.managerNone": "Unassigned",
  "projects.status.active": "Active",
  "projects.status.archived": "Archived",
  "projectView.tabs.label": "Project views",
  "projectView.tabs.taskList": "Stories",
  "projectView.tabs.board": "Board",
  "projectView.tabs.files": "Files",
  "projectView.tabs.members": "Members",
  "projectView.tabs.updates": "Updates",
  "projectView.tabs.insights": "Insights",
  "projectView.tabs.roadmap": "Roadmap",
  "projectView.tabs.workload": "Workload",
  "projectView.tabs.finance": "Finance",
  "projectView.tabs.budget": "Budget",
  "projectView.tabs.missions": "Missions",
  "projectView.tabs.wiki": "Wiki",
  "projectView.tabs.brainstorming": "Thinking",
  "projectView.header.pm": "PM",
  "projectView.header.noPm": "No PM",
  "projectView.header.newStory": "New story",
  "projectView.placeholder.comingSoon": "Coming in a later pass.",
  "taskList.empty": "No stories yet. Add one to get started.",
  "taskList.search": "Search stories",
  "taskList.groupBy.label": "Group by",
  "taskList.groupBy.status": "Status",
  "taskList.groupBy.priority": "Priority",
  "taskList.groupBy.assignee": "Assignee",
  "taskList.groupBy.due_date": "Due date",
  "taskList.filter.priority": "Priority",
  "taskList.filter.labels": "Labels",
  "taskList.filter.members": "Members",
  "taskList.column.key": "Key",
  "taskList.column.name": "Name",
  "taskList.column.progress": "Progress",
  "taskList.column.status": "Status",
  "taskList.column.assignees": "Assignees",
  "taskList.column.labels": "Labels",
  "taskList.column.priority": "Priority",
  "taskList.column.due": "Due",
  "taskList.column.time": "Time",
  "taskList.group.none": "Ungrouped",
  "taskList.group.unassigned": "Unassigned",
  "taskList.group.due.overdue": "Overdue",
  "taskList.group.due.today": "Today",
  "taskList.group.due.this_week": "This week",
  "taskList.group.due.this_month": "This month",
  "taskList.group.due.later": "Later",
  "taskList.group.due.__none__": "No due date",
  "taskList.subtasks_one": "{{count}} subtask",
  "taskList.subtasks_other": "{{count}} subtasks",
  "taskList.blockedBy": "Blocked by {{count}}",
  "taskList.addStory": "Add story",
  "taskList.addStory.mission": "Mission",
  "taskList.addStory.title": "Story title",
  "taskList.addStory.save": "Add",
  "taskList.addStory.cancel": "Cancel",
  "taskList.priority.low": "Low",
  "taskList.priority.medium": "Medium",
  "taskList.priority.high": "High",
  "taskList.priority.urgent": "Urgent",
  "storyDrawer.assignee.kind.human": "Human",
  "storyDrawer.assignee.kind.agent": "Agent",
  "storyDrawer.assignee.unassigned": "Unassigned",
  "storyDrawer.assignee.pinned": "This assignment has a trust / rigor adjusted for the story: open its setting and « Back to the member » before removing it.",
  "storyDrawer.assignee.notInSquad": "This agent is not in the mission squad: hire it onto the mission first.",
  "storyDrawer.tabs.label": "Story details",
  "storyDrawer.tabs.info": "Info",
  "storyDrawer.tabs.activity": "Activity",
  "storyDrawer.tabs.loop": "Loop",
  "storyDrawer.close": "Close",
  "storyDrawer.peek.side": "Side peek",
  "storyDrawer.peek.modal": "Modal",
  "storyDrawer.peek.full": "Full screen",
  "storyDrawer.notFound": "Story not found",
  "storyDrawer.title": "Title",
  "storyDrawer.titlePlaceholder": "Story title",
  "storyDrawer.parentLink": "Parent: {{title}}",
  "storyDrawer.field.assignees": "Assignees",
  "storyDrawer.field.labels": "Labels",
  "storyDrawer.field.priority": "Priority",
  "storyDrawer.field.due": "Due date",
  "storyDrawer.field.description": "Description",
  "storyDrawer.field.descriptionPlaceholder": "Add a description…",
  "storyDrawer.field.save": "Save",
  "storyDrawer.field.add": "Add",
  "storyDrawer.priority.none": "No priority",
  "storyDrawer.priority.low": "Low",
  "storyDrawer.priority.medium": "Medium",
  "storyDrawer.priority.high": "High",
  "storyDrawer.priority.urgent": "Urgent",
  "storyDrawer.saveFailed": "Could not save change",
  "subtasks.title": "Subtasks",
  "subtasks.empty": "No subtasks.",
  "subtasks.add": "Add subtask",
  "subtasks.placeholder": "Subtask title",
  "subtasks.save": "Add",
  "subtasks.open": "Open subtask",
  "dependencies.title": "Dependencies",
  "dependencies.blockedBy": "Blocked by",
  "dependencies.blocks": "Blocks",
  "dependencies.empty": "No dependencies.",
  "dependencies.add": "Add dependency",
  "dependencies.placeholder": "Pick a story this depends on",
  "dependencies.remove": "Remove dependency",
  "dependencies.addFailed": "Could not add dependency",
  "storyDrawer.time.add": "Log time",
  "storyDrawer.time.duration": "Duration (minutes)",
  "storyDrawer.time.date": "Date",
  "storyDrawer.time.note": "Note",
  "storyDrawer.time.billable": "Billable",
  "storyDrawer.time.save": "Save",
  "storyDrawer.activity.empty": "No activity yet.",
  "storyDrawer.blocked.title": "Why this story is blocked",
  "storyDrawer.blocked.failed": "The {{step}} run failed on attempt {{attempt}}",
  "storyDrawer.blocked.failedNoAttempt": "The {{step}} run failed",
  "storyDrawer.blocked.codeLabel": "Error code",
  "storyDrawer.blocked.unknownCode": "This error code has no explanation yet — the run logs in the Loop tab have the details.",
  "storyDrawer.blocked.noCode": "The run failed without a readable error code.",
  "storyDrawer.blocked.noFailure": "No failed run is recorded for this story : it was stopped by a review verdict, the retry ceiling or a mission rule (see the Loop tab).",
  "storyDrawer.blocked.cost": "cost {{cost}}",
  "storyDrawer.blocked.hint": "To continue, reply {{retry}} on the story's GitHub issue to run it again, or {{abort}} to abandon it.",
  "storyDrawer.blocked.issueLink": "Open the GitHub issue",
  "storyDrawer.blocked.step.plan": "plan",
  "storyDrawer.blocked.step.compose": "compose",
  "storyDrawer.blocked.step.implement": "implement",
  "storyDrawer.blocked.step.review": "review",
  "storyDrawer.blocked.step.retro": "retro",
  "storyDrawer.blocked.step.other": "agent",
  "storyDrawer.blocked.code.verdict_missing": "The reviewer finished without writing a verdict (SHIP, NEEDS_WORK or BLOCK).",
  "storyDrawer.blocked.code.block_missing": "The agent finished without writing its result block.",
  "storyDrawer.blocked.code.block_truncated": "The agent's result block was cut off before its end.",
  "storyDrawer.blocked.code.block_invalid": "The agent's result block did not match the expected format.",
  "storyDrawer.blocked.code.result_unparseable": "The agent's output could not be read as a result.",
  "storyDrawer.blocked.code.no_stdout_captured": "The agent produced no output at all.",
  "storyDrawer.blocked.code.exit_nonzero": "The agent process exited with an error.",
  "storyDrawer.blocked.code.timeout": "The run took longer than its time limit.",
  "storyDrawer.blocked.code.step_timeout": "The run took longer than its time limit.",
  "storyDrawer.blocked.code.poll_deadline": "The run did not report back before the deadline.",
  "storyDrawer.blocked.code.step_lost": "The runner lost the run before it finished.",
  "storyDrawer.blocked.code.run_interrupted": "The sandbox run was interrupted before it finished.",
  "storyDrawer.blocked.code.launch_failed": "The agent could not be started in the sandbox.",
  "storyDrawer.blocked.code.seed_failed": "The sandbox could not be prepared (clone, fetch or install failed).",
  "storyDrawer.blocked.code.capacity_exceeded": "No runner capacity was free to start the run.",
  "storyDrawer.blocked.code.runner_unbound": "No runner is configured for this office.",
  "storyDrawer.blocked.code.sandbox_unavailable": "The sandbox was not available.",
  "storyDrawer.blocked.code.invalid_step_request": "The runner refused the step request as invalid.",
  "storyDrawer.blocked.code.plugin_missing": "The NovaTechnica plugin was not found in the sandbox.",
  "storyDrawer.blocked.code.harness_unsupported_feature": "The configured coding harness does not support this step.",
  "storyDrawer.blocked.code.model_unmappable": "The configured model is not available for this harness.",
  "storyDrawer.blocked.code.review_env_dirty": "The review workspace had unexpected changes, so the review was not trusted.",
  "storyDrawer.blocked.code.review_level_unrecorded": "The review level could not be recorded before the review started.",
  "storyDrawer.blocked.code.review_level_unreadable": "The review level could not be read back after the review.",
  "storyDrawer.blocked.code.retro_inputs_incomplete": "The retro inputs were incomplete.",
  "storyDrawer.blocked.code.push_refused": "The push of the agent's commits was refused.",
  "storyDrawer.blocked.code.push_failed": "The push of the agent's commits failed.",
  "storyDrawer.blocked.code.base_conflict": "The story branch still conflicts with the mission branch: the run did not merge it, so nothing was pushed.",
  "storyDrawer.blocked.code.no_commit": "The implementer finished without committing any change.",
  "storyDrawer.blocked.code.no_diff": "The implementer finished without changing any file.",
  "storyDrawer.blocked.code.finalize_failed": "The run result could not be saved.",
  "storyDrawer.blocked.code.cancelled": "The run was cancelled.",
  "storyDrawer.activity.sentence.verdict.ship": "{{who}} approved the story — attempt {{n}}",
  "storyDrawer.activity.sentence.verdict.needsWork": "{{who}} asked for rework — attempt {{n}}",
  "storyDrawer.activity.sentence.verdict.block": "{{who}} blocked the story — attempt {{n}}",
  "storyDrawer.activity.sentence.verdict.other": "{{who}} returned verdict {{verdict}} — attempt {{n}}",
  "storyDrawer.activity.sentence.comment": "{{who}} commented",
  "storyDrawer.activity.sentence.timeLog": "{{who}} logged {{minutes}} min of work",
  "storyDrawer.activity.actor.workflow": "GitHub workflow",
  "storyDrawer.activity.actor.unknownAgent": "Unknown agent",
  "storyDrawer.activity.actor.unknownMember": "Unknown member",
  "storyDrawer.activity.actor.system": "System",
  "storyDrawer.activity.link.attempt": "See attempt {{n}}",
  "storyDrawer.activity.link.review": "Review comment",
  "storyDrawer.activity.link.pr": "Pull request",
  "storyDrawer.activity.sentence.status": "{{who}} moved the story from “{{from}}” to “{{to}}”",
  "storyDrawer.activity.sentence.statusTo": "{{who}} moved the story to “{{to}}”",
  "storyDrawer.activity.sentence.run.implement.running": "{{who}} is implementing — attempt {{n}}",
  "storyDrawer.activity.sentence.run.implement.finished": "{{who}} finished the implementation ({{outcome}}) — attempt {{n}}",
  "storyDrawer.activity.sentence.run.implement.finishedBare": "{{who}} finished the implementation — attempt {{n}}",
  "storyDrawer.activity.sentence.run.review.running": "{{who}} is reviewing — attempt {{n}}",
  "storyDrawer.activity.sentence.run.review.finished": "{{who}} finished the review ({{outcome}}) — attempt {{n}}",
  "storyDrawer.activity.sentence.run.review.finishedBare": "{{who}} finished the review — attempt {{n}}",
  "storyDrawer.activity.run.model": "Model: {{model}}",
  "storyDrawer.activity.currentStatus": "Current status: {{status}}",
  "storyDrawer.activity.actor.github": "GitHub",
  "storyDrawer.activity.actor.champion": "The champion",
  "storyDrawer.activity.link.prNumber": "Pull request #{{n}}",
  "storyDrawer.activity.link.issue": "GitHub issue",
  "storyDrawer.tabs.review": "Review",
  "storyDrawer.review.branch": "Branch",
  "storyDrawer.review.diffTitle": "Changes",
  "storyDrawer.review.files_one": "{{count}} file",
  "storyDrawer.review.files_other": "{{count}} files",
  "storyDrawer.review.noDiff": "No changes recorded for this story yet.",
  "storyDrawer.review.diffUnavailable": "The changes could not be loaded right now.",
  "storyDrawer.review.truncated": "Diff truncated: only the first 256 KiB are shown.",
  "storyDrawer.review.binary": "Binary file, not shown.",
  "storyDrawer.review.status.added": "Added",
  "storyDrawer.review.status.deleted": "Deleted",
  "storyDrawer.review.status.renamed": "Renamed",
  "storyDrawer.review.status.modified": "Modified",
  "storyDrawer.review.previewTitle": "Preview",
  "storyDrawer.review.previewOpen": "Open preview",
  "storyDrawer.review.previewPending": "Preview pending: the link appears here once the build is deployed.",
  "storyDrawer.review.previewPrivateNote": "Private link, valid 12 hours, for members of this office.",
  "storyDrawer.review.previewUnavailable": "Preview deployed but private: secure access is not configured yet, so it cannot be opened from here.",
  "storyDrawer.review.share": "Share preview",
  "storyDrawer.review.shareLabel": "Share link (valid 7 days). Anyone with it can open the preview.",
  "storyDrawer.review.shareExpiry": "Only you see this link. It expires in 7 days.",
  "storyDrawer.review.shareFailed": "Could not create a share link.",
  "storyDrawer.review.decisionTitle": "Your decision",
  "storyDrawer.review.approve": "Approve",
  "storyDrawer.review.sendBack": "Send back",
  "storyDrawer.review.commentLabel": "What should change?",
  "storyDrawer.review.commentPlaceholder": "Describe what to fix. This is passed to the next attempt.",
  "storyDrawer.review.sendBackConfirm": "Send back with this comment",
  "storyDrawer.review.cancel": "Cancel",
  "storyDrawer.review.commentRequired": "A comment is required to send a story back.",
  "storyDrawer.review.noGate": "No review gate is open for this story yet, so there is nothing to decide.",
  "storyDrawer.review.decideFailed": "Could not record the decision.",
  "storyDrawer.review.stale": "This was already decided. Refreshing.",
  "storyDrawer.review.loadFailed": "Could not load the review.",
  "ledger.criteria.listLabel": "Acceptance criteria",
  "ledger.criteria.empty": "No criteria yet.",
  "ledger.criteria.noEvidence": "No evidence",
  "ledger.criteria.evidenceCount_one": "{{count}} evidence",
  "ledger.criteria.evidenceCount_other": "{{count}} evidence",
  "ledger.criteria.more": "+{{count}}",
  "ledger.criteria.addEvidence": "Add evidence",
  "ledger.criteria.toggle.rows": "Rows",
  "ledger.criteria.toggle.markdown": "Markdown",
  "ledger.criteria.markdownHint": "Rows are the source of truth — this markdown is regenerated on save.",
  "ledger.criteria.save": "Save",
  "ledger.criteria.importError.generic": "Could not import criteria from this markdown.",
  "ledger.criteria.importError.story_seq_out_of_range": "Story number is out of range.",
  "ledger.criteria.importError.too_many_criteria": "Too many criteria in this block.",
  "ledger.criteria.importError.story_block_not_found": "No story block found in this markdown.",
  "ledger.criteria.importError.ambiguous_story_block": "More than one story block matches — be more specific.",
  "ledger.criteria.importError.oracle_invalid": "One criterion has an invalid oracle.",
  "ledger.status.unverified": "Unverified",
  "ledger.status.verified": "Verified",
  "ledger.status.failed": "Failed",
  "ledger.status.waived": "Waived",
  "ledger.oracle.test": "test",
  "ledger.oracle.checklist": "checklist",
  "ledger.oracle.crossref": "crossref",
  "ledger.oracle.recompute": "recompute",
  "ledger.oracle.prediction": "prediction",
  "ledger.oracle.human_verify": "human verify",
  "ledger.evidence.kind.artifact": "Artifact",
  "ledger.evidence.kind.url": "URL",
  "ledger.evidence.kind.commit": "Commit",
  "ledger.evidence.kind.quote": "Quote",
  "ledger.evidence.kind.number": "Number",
  "ledger.evidence.kind.routine": "Routine",
  "ledger.evidence.kind.test_run": "Test run",
  "ledger.evidence.kind.prediction": "Prediction",
  "ledger.evidence.field.url": "URL",
  "ledger.evidence.field.artifact": "Artifact",
  "ledger.evidence.field.version": "Version",
  "ledger.evidence.field.sha": "Commit SHA",
  "ledger.evidence.field.source": "Source",
  "ledger.evidence.field.excerpt": "Excerpt",
  "ledger.evidence.field.value": "Value",
  "ledger.evidence.field.unit": "Unit",
  "ledger.evidence.field.note": "Note",
  "ledger.evidence.submit": "Add evidence",
  "ledger.evidence.cancel": "Cancel",
  "ledger.evidence.copySha": "Copy",
  "ledger.evidence.copied": "Copied",
  "ledger.evidence.chipLabel": "{{kind}}: {{label}}",
  "ledger.activity.title": "Read / done",
  "ledger.activity.empty": "No reads or actions recorded yet.",
  "ledger.activity.proven": "Proven",
  "ledger.activity.read": "Read",
  "ledger.activity.done": "Done",
  "ledger.activity.atLeast": "{{count}}+",
  "ledger.actions.title": "Actions ({{count}})",
  "ledger.actions.status.staged": "Staged",
  "ledger.actions.status.pending": "Pending",
  "ledger.actions.status.approved": "Approved",
  "ledger.actions.status.rejected": "Rejected",
  "ledger.actions.status.claimed": "Running",
  "ledger.actions.status.applied": "Applied",
  "ledger.actions.status.failed": "Failed",
  "ledger.actions.kind.datasource.write": "Data write",
  "ledger.actions.kind.git.push": "Git push",
  "ledger.actions.kind.github.pr.open": "Open PR",
  "ledger.actions.decidedBy": "{{name}} · {{date}}",
  "ledger.actions.via.manual": "Manual decision",
  "ledger.actions.via.rule": "Via gate {{gate}}",
  "ledger.actions.decider.poc": "POC",
  "ledger.actions.awaiting": "Awaiting decision",
  "ledger.actions.showAll": "Show all ({{count}})",
  "ledger.loadMore": "Load more",
  "ledger.actions.reject.button": "Reject",
  "ledger.actions.reject.confirm": "Confirm rejection",
  "ledger.actions.reject.cancel": "Cancel",
  "ledger.actions.reject.confirmLabel": "Reject \"{{title}}\"?",
  "ledger.actions.reject.comment": "Comment (optional)",
  "ledger.actions.reject.done": "Action rejected.",
  "ledger.actions.reject.error.action_not_pending": "This action is no longer pending, view refreshed.",
  "ledger.actions.reject.error.not_found": "Action not found.",
  "ledger.observations.title": "Reads ({{count}})",
  "ledger.observations.kind.datasource": "Data source",
  "ledger.observations.kind.office_tool": "Office tool",
  "ledger.observations.restricted": "Restricted",
  "ledger.observations.restrictedCount": "{{count}} restricted",
  "ledger.rail.proven": "{{phase}}: {{count}} evidence",
  "ledger.rail.read": "{{phase}}: {{count}} reads",
  "ledger.rail.done": "{{phase}}: {{count}} actions",
  "ledger.rail.provenAtLeast": "{{phase}}: at least {{count}} evidence",
  "ledger.rail.readAtLeast": "{{phase}}: at least {{count}} reads",
  "ledger.rail.doneAtLeast": "{{phase}}: at least {{count}} actions",
  "workspace.tab.traceability": "Traceability",
  "traceability.label": "Mission traceability",
  "traceability.kpi.readiness": "Readiness",
  "traceability.error": "Could not load the ledger.",
  "traceability.empty": "No criteria or links yet.",
  "traceability.view.matrix": "Matrix",
  "traceability.view.flow": "Flow",
  "traceability.kpi.coverage": "Coverage",
  "traceability.kpi.unverified": "Unverified",
  "traceability.kpi.failed": "Failed",
  "traceability.kpi.waived": "Waived",
  "traceability.kpi.bypassed": "Bypassed gates",
  "traceability.kpi.clarifications": "Open clarifications",
  "traceability.kpi.read": "Read",
  "traceability.kpi.done": "Done",
  "traceability.kpi.contradictions": "Contradictions",
  "traceability.kpi.showContradictions": "Show contradictions in the flow",
  "traceability.kpi.proven": "{{n}}/{{m}} proven",
  "traceability.kpi.missing": "Missing evidence:",
  "traceability.kpi.blocked": "Gate blocked",
  "traceability.kpi.readinessUnavailable": "Readiness unavailable",
  "traceability.matrix.col.code": "Code",
  "traceability.matrix.col.text": "Criterion",
  "traceability.matrix.col.oracle": "Oracle",
  "traceability.matrix.col.status": "Status",
  "traceability.matrix.col.evidence": "Evidence",
  "traceability.matrix.col.gate": "Gate",
  "traceability.matrix.openStory": "Open {{code}} ({{story}})",
  "traceability.matrix.gateAll": "All",
  "traceability.matrix.count": "{{shown}} / {{total}} criteria",
  "traceability.matrix.noMatch": "No criterion matches the filters.",
  "traceability.filter.status": "Status",
  "traceability.filter.oracle": "Oracle",
  "traceability.filter.phase": "Phase",
  "traceability.filter.noEvidence": "No evidence",
  "traceability.filter.all": "All",
  "traceability.filter.untagged": "Untagged",
  "traceability.filter.reset": "Reset",
  "traceability.rel.covers": "covers",
  "traceability.rel.contradicts": "contradicts",
  "traceability.rel.derives_from": "derives from",
  "traceability.rel.supersedes": "supersedes",
  "traceability.rel.cites": "cites",
  "traceability.rel.blocks": "blocks",
  "traceability.flow.edgeAria": "{{from}} {{rel}} {{to}}",
  "traceability.flow.edgeAriaCross": "(other mission: {{mission}})",
  "traceability.flow.foreign": "{{type}} · {{mission}}",
  "traceability.flow.otherMission": "Other mission",
  "traceability.flow.unknownArtifact": "unknown artifact",
  "traceability.flow.linksList": "Link list ({{count}})",
  "traceability.flow.empty": "No links recorded for this mission.",
  "traceability.type.criterion": "Criterion",
  "traceability.type.story": "Story",
  "traceability.type.artifact": "Artifact",
  "traceability.type.mission": "Mission",
  "board.card.subtasks_one": "{{count}} subtask",
  "board.card.subtasks_other": "{{count}} subtasks",
  "files.title": "Files",
  "files.layout": "Layout",
  "files.layoutGrid": "Grid view",
  "files.layoutList": "List view",
  "files.upload": "Upload a file",
  "files.uploading": "Uploading…",
  "files.uploadHint": "Drag a file here or click to browse",
  "files.download": "Download {{name}}",
  "files.delete": "Delete {{name}}",
  "files.empty": "No files yet.",
  "members.title": "Members",
  "members.empty": "No members yet.",
  "updates.empty": "No updates yet.",
  "updates.unknownStory": "a story",
  "updates.onStory": "On {{title}}",
  "updates.composer.story": "Story",
  "updates.composer.storyPlaceholder": "Choose a story…",
  "updates.composer.comment": "Comment",
  "updates.composer.placeholder": "Share an update…",
  "updates.composer.post": "Post",
  "automations.flow.placeholder": "Describe what this automation should do — the copilot drafts the crew here.",
  "automations.process": "Process",
  "automations.process.sequential": "Sequential",
  "automations.editAgent": "Edit agent",
  "automations.editTask": "Edit task",
  "automations.save": "Save",
  "automations.saving": "Saving…",
  "automations.saved": "Automation updated.",
  "automations.fields.champion": "Champion",
  "automations.fields.role": "Role",
  "automations.fields.personaRole": "Persona role",
  "automations.fields.goal": "Goal",
  "automations.fields.backstory": "Backstory",
  "automations.fields.key": "Task key",
  "automations.fields.description": "Description",
  "automations.fields.expectedOutput": "Expected output",
  "automations.fields.connector": "Connector",
  "automations.fields.connectorId": "Connector ID",
  "automations.fields.method": "Method",
  "automations.fields.path": "Path",
  "automations.fields.model": "Model",
  "automations.fields.modelDefault": "Default (inherit)",
  "automations.process.hierarchical": "Hierarchical",
  "automations.palette.title": "Components",
  "automations.palette.hint": "Drag onto the canvas to add.",
  "automations.palette.crew": "Crew",
  "automations.palette.tools": "Tools",
  "automations.palette.agent": "Agent",
  "automations.palette.agentHint": "A crew member",
  "automations.palette.task": "Task",
  "automations.palette.taskHint": "A unit of work",
  "automations.palette.noTools": "No active connectors. Add a token on the Connectors page.",
  "automations.palette.newAgentRole": "New agent",
  "automations.palette.newTaskDescription": "Describe this task…",
  "automations.palette.newToolDescription": "Call {{name}}",
  "automations.tabs.canvas": "Canvas",
  "automations.tabs.runs": "Runs",
  "automations.triggers.title": "Triggers",
  "automations.triggers.manual": "Manual",
  "automations.triggers.cron": "Cron",
  "automations.triggers.cronExpr": "Cron expression",
  "automations.triggers.cronHint": "Standard 5-field cron (min hour day month weekday).",
  "automations.triggers.saved": "Trigger saved.",
  "automations.triggers.comingSoon": "Scheduling isn't available yet — coming soon.",
  "automations.runs.empty": "No runs yet.",
  "automations.runs.noOutput": "No output recorded for this run.",
  "automations.generating": "Generating…",
  "automations.copilot.label": "Copilot",
  "automations.copilot.empty": "Describe what this automation should do — the copilot drafts the crew.",
  "automations.copilot.placeholder": "Describe what this automation should do…",
  "automations.copilot.send": "Generate",
  "automations.copilot.done": "Crew generated.",
  "automations.copilot.thinking.understanding": "Understanding the request…",
  "automations.copilot.thinking.designing": "Designing the crew…",
  "automations.copilot.thinking.compiling": "Compiling the workflow…",
  "automations.copilot.summary.created": "{{parts}}",
  "automations.copilot.summary.agents": "Created {{n}} agents ({{keys}})",
  "automations.copilot.summary.tasks": "and {{n}} tasks ({{keys}}).",
  "automations.run.label": "Run",
  "automations.run.input": "Input",
  "automations.run.running": "Running…",
  "automations.run.output": "Output",
  "automations.run.needsSpec": "Generate a crew before running.",
  "automations.run.status.queued": "Queued",
  "automations.run.status.running": "Running",
  "automations.run.status.complete": "Complete",
  "automations.run.status.errored": "Errored",
  "sidebar.new": "New",
  "sidebar.pinned": "Pinned",
  "sidebar.groupBy.phase": "Phase",
  "sidebar.groupBy.product": "Product",
  "sidebar.groupBy.last_activity": "Activity",
  "sidebar.lens.think": "Brainstorming",
  "sidebar.lens.do": "Execution",
  "sidebar.lens.products": "Overview",
  "sidebar.portfolio.add": "New group",
  "sidebar.portfolio.search": "Filter groups",
  "sidebar.mission.search": "Search missions…",
  "sidebar.portfolio.filterPlaceholder": "Filter groups…",
  "sidebar.lens.empty": "No missions in this view yet.",
  "sidebar.lens.on": "Lens: {{name}}",
  "sidebar.phase.other": "Other",
  "sidebar.phase.reasoning": "Exploring",
  "sidebar.phase.shaping": "Shaping",
  "sidebar.phase.building": "Building",
  "sidebar.phase.steering": "Steering",
  "sidebar.product.settings": "Product settings",
  "sidebar.tree.toggle": "Tasks waiting on you: {{title}}",
  "sidebar.tree.group": "Tasks waiting on you — {{title}}",
  "sidebar.tree.waitingYou": "waiting on you",
  "sidebar.tree.waitingCount": "{{count}} waiting on you",
  "sidebar.tree.countLabel_one": "{{count}} task waiting on you",
  "sidebar.tree.countLabel_other": "{{count}} tasks waiting on you",
  "sidebar.tree.allTickets": "All tickets in the pane",
  "sidebar.product.addMission": "New mission in this group",
  "sidebar.product.none": "No product",
  "sidebar.filter.label": "Filter missions",
  "sidebar.filter.heading": "Show",
  "sidebar.filter.all": "All missions",
  "sidebar.filter.active": "Active only",
  "sidebar.filter.activeShort": "Active",
  "sidebar.filter.clear": "Clear all filters",
  "breadcrumb.assignProduct": "Add product",
  "breadcrumb.changeProduct": "Change product",
  "breadcrumb.productSearch": "Search groups…",
  "breadcrumb.productEmpty": "No products yet",
  "breadcrumb.productCreate": "Create \"{{name}}\"",
  "productSettings.title": "Settings",
  "productSettings.back": "Back to groups",
  "productSettings.notFound": "Product not found",
  "productSettings.section.config.title": "Configuration",
  "productSettings.section.config.description": "Name, color, and general settings for this group.",
  "productSettings.section.connectors.title": "Connectors",
  "productSettings.section.connectors.description": "Data sources and integrations scoped to this group.",
  "productSettings.section.squad.title": "Squad",
  "productSettings.section.squad.description": "Agents and people assigned to work on this group.",
  "productSettings.section.budget.title": "Budget",
  "productSettings.section.budget.description": "Spend limits and cost tracking for this group's missions.",
  "intake.title": "Where to start?",
  "intake.placeholderTitle": "New mission",
  "conductor.advanced": "Advanced",
  "conductor.model": "Camille model",
  "conductor.effort": "Camille effort",
  "conductor.loading": "Loading models…",
  "conductor.hint": "Chosen at creation. Afterwards, adjust Camille from the mission per-agent settings.",
  "intake.launcher.placeholder": "Describe what you want to work on, or ask a question to get started…",
  "intake.launcher.orPick": "or pick a starting point",
  "intake.launcher.orType": "or describe it to get started",
  "intake.launcher.start": "Start",
  "intake.group.think": "Reflect",
  "intake.group.act": "Act",
  "intake.group.operate": "Sustain",
  "intake.door.idea": "Idea",
  "intake.door.decision": "Decision",
  "intake.door.question": "Question",
  "intake.door.concern": "Concern",
  "intake.door.goal": "Goal",
  "intake.door.review": "Review",
  "intake.door.prototype": "Prototype",
  "intake.flavorLabel": "What kind of prototype?",
  "intake.flavor.app": "App",
  "intake.flavor.workflow": "Workflow",
  "intake.flavorHint.app": "Vibe-code a small app to test an idea.",
  "intake.flavorHint.workflow": "Vibe-code a workflow — ships as an automation.",
  "intake.door.monitor": "Monitor",
  "intake.door.improve": "Improve",
  "intake.door.maintain": "Maintain",
  "intake.door.advisory": "Advisory",
  "intake.tagline.idea": "I've got an idea to explore.",
  "intake.tagline.decision": "I need to choose between options.",
  "intake.tagline.question": "I'd like to understand something.",
  "intake.tagline.concern": "Something's nagging me — let's solve it.",
  "intake.tagline.goal": "Help me reach a goal.",
  "intake.tagline.review": "I'd like an expert opinion.",
  "intake.tagline.prototype": "I want to build a quick prototype.",
  "intake.tagline.monitor": "Help me keep an eye on my metrics.",
  "intake.tagline.improve": "I'd like to improve something.",
  "intake.tagline.maintain": "Help me maintain something.",
  "intake.tagline.advisory": "Advise me continuously.",
  "intake.placeholder.idea": "What's the idea?",
  "intake.placeholder.decision": "What needs to be decided?",
  "intake.placeholder.question": "What's the question?",
  "intake.placeholder.concern": "What problem do you want to solve?",
  "intake.placeholder.goal": "What's the goal?",
  "intake.placeholder.review": "What needs reviewing?",
  "intake.placeholder.prototype": "What do you want to prototype?",
  "intake.placeholder.monitor": "What to monitor?",
  "intake.placeholder.improve": "What to improve?",
  "intake.placeholder.maintain": "What are we keeping running? e.g. platform uptime, SLA support…",
  "intake.placeholder.advisory": "What advice is needed?",
  "intake.titleLabel": "Title",
  "intake.back": "Back",
  "intake.product": "Product (optional)",
  "intake.productNone": "No product",
  "intake.created": "Item created.",
  "intake.error": "Could not create. Try again.",
  "think.attention.title": "Needs you",
  "think.attention.columnTitle": "To handle",
  "think.attention.pending_one": "{{count}} pending",
  "think.attention.pending_other": "{{count}} pending",
  "think.attention.gateSummary": "{{kind}} gate — signoff required",
  "think.attention.silenceSummary_one": "Silent mission — no activity for {{count}} d",
  "think.attention.silenceSummary_other": "Silent mission — no activity for {{count}} d",
  "think.attention.openThread": "Open the thread",
  "think.attention.silenceMore_one": "+{{count}} silent mission",
  "think.attention.silenceMore_other": "+{{count}} silent missions",
  "think.attention.silenceLess": "Show less",
  "think.attention.empty": "Nothing needs you — the squads are moving.",
  "think.attention.badge.gate": "gate pending",
  "think.attention.badge.silence_one": "silent · {{count}} d",
  "think.attention.badge.silence_other": "silent · {{count}} d",
  "think.attention.age.minutes_one": "{{count}} min ago",
  "think.attention.age.minutes_other": "{{count}} min ago",
  "think.attention.age.hours_one": "{{count}} h ago",
  "think.attention.age.hours_other": "{{count}} h ago",
  "think.attention.age.days_one": "{{count}} d ago",
  "think.attention.age.days_other": "{{count}} d ago",
  "think.attention.doorsToggle": "Type",
  "workspace.tabs.label": "Workspace sections",
  "workspace.tabs.more": "More sections",
  "workspace.tickets.back": "Back to tickets",
  "workspace.tickets.working": "{{name}} is working…",
  "workspace.tickets.workingUnknown": "An agent is working…",
  "workspace.tickets.agents": "Agents",
  "workspace.dock.close": "Fold the panel",
  "workspace.dock.resize": "Resize panel",
  "workspace.tickets.checklist.title": "Sub-tasks",
  "workspace.tickets.checklist.progress": "{{done}}/{{total}} done",
  "workspace.tickets.checklist.untitled": "Untitled sub-task",
  "workspace.tickets.checklist.state.pending": "Pending",
  "workspace.tickets.checklist.state.in_progress": "In progress",
  "workspace.tickets.checklist.state.done": "Done",
  "workspace.tickets.checklist.state.blocked": "Blocked",
  "workspace.dock.sections": "Mission sections",
  "workspace.dock.mcp": "MCP connections",
  "workspace.dock.dataSources": "Data sources",
  "workspace.tickets.chip": "Open ticket {{sid}} · {{title}}",
  "champion.title": "Champion",
  "champion.subtitle": "Ask me to import a PRD onto the board, or show the board.",
  "champion.thinking": "{{name}} is thinking…",
  "champion.sendFailed": "Message not sent — it is kept above.",
  "champion.queued": "Message saved. Camille is finishing a step in progress and will answer right after.",
  "champion.refused.budget_exceeded": "This office's budget is spent. New messages are refused until {{date}} (UTC), or until the budget is raised in Consumption.",
  "champion.refused.rate_limited": "Too many messages in a short time. Wait a minute, then retry.",
  "champion.refused.gateway_budget_block": "The platform's spending limit was reached. Retrying will not help; the platform team has been alerted.",
  "champion.retry": "Retry",
  "champion.autoContinue": "{{name}} continues ({{n}}/{{max}})…",
  "champion.details": "Details",
  "champion.step.list_blueprints": "is reading the blueprints",
  "champion.step.select_blueprint": "is picking a blueprint",
  "champion.step.recommend_squad": "is composing the squad",
  "champion.step.hire_agent_for_mission": "is hiring an agent",
  "champion.step.set_mission_brief": "is writing the brief",
  "champion.step.recategorize_mission": "is recategorizing the mission",
  "champion.step.record_decision": "is recording a decision",
  "champion.step.ask_questions": "is preparing questions",
  "champion.step.request_phase_signoff": "is preparing the signoff",
  "champion.step.create_story": "is creating a story",
  "champion.step.list_board": "is reading the board",
  "champion.step.save_mission_file": "is writing a mission file",
  "champion.step.generic": "is working",
  "champion.step.advance_phase": "is moving the phase forward",
  "champion.step.list_prds": "is reading the PRDs",
  "champion.step.import_prd": "is importing a PRD",
  "champion.step.set_conductor_status": "is updating the status",
  "champion.step.record_methodology_step": "is recording a method step",
  "champion.step.propose_mission_mcp": "is proposing data sources",
  "champion.step.propose_mission_mode": "is proposing a mode",
  "champion.step.start_build": "is starting the build",
  "champion.step.codemode": "is looking things up",
  "champion.step.add_org_node": "is adding an org node",
  "champion.step.analyze_story_retro": "is analysing a story retro",
  "champion.step.answer_agent": "is answering an agent",
  "champion.step.assign_mission_role": "is assigning a mission role",
  "champion.step.assign_story": "is assigning a story",
  "champion.step.attach_evidence": "is attaching evidence",
  "champion.step.configure_agent_inference": "is configuring an agent's model",
  "champion.step.confirm_cadrage": "is confirming the framing",
  "champion.step.connect_mcp": "is connecting a data source",
  "champion.step.create_follow_up_mission": "is creating a follow-up mission",
  "champion.step.create_squad": "is creating the squad",
  "champion.step.datasource_list_tools": "is listing a data source's tools",
  "champion.step.decline_ui_mock": "is declining a UI mock",
  "champion.step.get_agent_inference": "is reading an agent's model",
  "champion.step.get_methodology_progress": "is checking the method progress",
  "champion.step.get_plan": "is reading the plan",
  "champion.step.list_criteria": "is reading the criteria",
  "champion.step.list_data_sources": "is listing the data sources",
  "champion.step.list_mcp_connectors": "is listing the connectors",
  "champion.step.list_merged_stories": "is listing the merged stories",
  "champion.step.list_squad": "is reading the squad",
  "champion.step.mcp_call": "is calling a connected tool",
  "champion.step.mcp_list_tools": "is listing a connector's tools",
  "champion.step.post_dojo_judgment": "is posting a dojo judgment",
  "champion.step.propose_office_hire": "is proposing a hire",
  "champion.step.propose_office_release": "is proposing a release",
  "champion.step.record_decomposition": "is recording the decomposition",
  "champion.step.reparent_org_node": "is moving an org node",
  "champion.step.request_action": "is requesting an action",
  "champion.step.request_confirmation": "is requesting a confirmation",
  "champion.step.request_ui_mock": "is requesting a UI mock",
  "champion.step.save_artifact": "is saving an artifact",
  "champion.step.set_agent_status": "is updating an agent's status",
  "champion.step.set_delivery_route": "is setting the shipping route",
  "champion.step.set_stack": "is setting the stack",
  "champion.step.set_story_status": "is updating a story's status",
  "champion.step.set_supervisor": "is setting a supervisor",
  "champion.step.submit_plan": "is submitting the plan",
  "champion.step.supersede_story": "is superseding a story",
  "champion.step.update_dojo_lesson": "is updating a dojo lesson",
  "champion.step.update_story_status": "is updating a story's status",
  "champion.notFound": "No champion on this mission.",
  "champion.empty": "Try: « importe le PRD-016 » or « montre le board ».",
  "champion.inputLabel": "Message to the champion",
  "champion.placeholder": "Import a PRD, show the board…",
  "champion.intake.subtitle": "Describe what you need — I frame it with you, then run the mission.",
  "champion.intake.placeholder": "Describe what you need…",
  "champion.intake.empty": "Tell me what you want to achieve: the result, the constraints, the deadline.",
  "champion.send": "Send",
  "champion.mentionsLabel": "Mention a squad member",
  "champion.mentionsEmpty": "No match.",
  "champion.mentionIntent": "{{name}} will answer this message",
  "champion.attach": "Attach a file",
  "champion.uploading": "Uploading…",
  "champion.uploadError": "Upload failed",
  "champion.removeAttachment": "Remove {{name}}",
  "champion.recipientLabel": "Recipient",
  "champion.loadingOlder": "Loading older messages…",
  "champion.request.label": "Request",
  "champion.request.by": "by @{{author}}",
  "champion.request.issueLink": "GitHub issue #{{number}}",
  "champion.pins.region": "Pinned messages",
  "champion.pins.goTo": "Go to pinned message",
  "champion.pins.previous": "Go to previous pinned message",
  "champion.pins.next": "Go to next pinned message",
  "champion.pins.pin": "Pin message",
  "champion.pins.unpin": "Unpin message",
  "champion.pins.member": "Member",
  "champion.live.working": "{{name}} is working — {{what}}",
  "champion.live.workingBare": "{{name}} is working…",
  "champion.live.waitingYou": "Waiting on you: {{on}}",
  "champion.live.waitingYouBare": "Waiting on you",
  "champion.live.waiting": "{{name}} is waiting on {{owner}}: {{on}}",
  "champion.live.waitingBare": "{{name}} is waiting on {{owner}}",
  "champion.live.blocked": "Blocked — {{owner}}: {{on}}",
  "champion.live.blockedBare": "Blocked — {{owner}}",
  "champion.live.you": "you",
  "champion.live.unknownOwner": "someone",
  "champion.action.supersedeStory": "Story superseded (off the board)",
  "workspace.phase.reasoning": "Reasoning",
  "workspace.phase.shaping": "Shaping",
  "workspace.phase.building": "Building",
  "workspace.phase.steering": "Steering",
  "workspace.phase.advance": "Move to {{phase}}",
  "workspace.chat.hide": "Hide chat",
  "workspace.chat.show": "Chat",
  "workspace.tab.chats": "Chats",
  "workspace.tab.champion": "Champion",
  "workspace.tab.overview": "Overview",
  "workspace.tab.discussions": "Discussions",
  "workspace.tab.brainstorming": "Brainstorming",
  "workspace.tab.inbox": "Inbox",
  "workspace.discussions.title": "Discussions",
  "workspace.discussions.new": "New discussion",
  "workspace.discussions.placeholder": "Write a message…",
  "workspace.tab.canvas": "Canvas",
  "workspace.tab.sources": "Sources",
  "workspace.tab.verdict": "Verdict",
  "workspace.tab.board": "Board",
  "workspace.tab.backlog": "Stories",
  "workspace.tab.roadmap": "Roadmap",
  "workspace.tab.deliverables": "Deliverables",
  "workspace.tab.kpis": "KPIs",
  "workspace.tab.feed": "Feed",
  "workspace.tab.actions": "Workflows",
  "workspace.tab.activity": "Activity",
  "workspace.tab.connectors": "Connectors",
  "workspace.tab.team": "Team",
  "workspace.tab.artifacts": "Artifacts",
  "workspace.overview.pipeline": "Pipeline",
  "workspace.overview.phase": "Phase",
  "workspace.overview.currentPhase": "<- current",
  "workspace.overview.natureUnlocked": "Nature can still be requalified before moving to shaping.",
  "workspace.overview.parent": "Linked to",
  "workspace.kpis.building": "System under construction",
  "workspace.kpis.buildingHint": "KPIs will appear once the build is released. See the active builds tab.",
  "workspace.kpis.empty": "No KPI data yet.",
  "workspace.chantiers.intro": "Active builds linked to this ongoing work.",
  "workspace.chantiers.empty": "No active builds yet.",
  "workspace.nature.label": "Nature",
  "workspace.nature.think": "Think",
  "workspace.nature.act": "Act",
  "workspace.nature.operate": "Operate",
  "workspace.nature.locked": "Nature is locked — move to shaping first.",
  "mission.step._shared.framing": "Framing",
  "mission.step._shared.go": "Go",
  "mission.step._shared.appetite": "Appetite",
  "mission.step._shared.budget": "Budget",
  "mission.step._shared.scope": "Scope",
  "mission.step._shared.bet": "Bet",
  "mission.step._shared.build": "Build",
  "mission.step._shared.test": "Test",
  "mission.step._shared.release": "Release",
  "mission.step._shared.act": "Act",
  "mission.step._shared.verdict": "Verdict",
  "mission.step._shared.audit": "Audit",
  "mission.step._shared.triage": "Triage",
  "mission.step.decision.options": "Options",
  "mission.step.concern.diagnose": "Diagnose",
  "mission.step.prototype.spike": "Spike",
  "mission.step.prototype.demo": "Demo",
  "mission.step.prototype.learn": "Learn",
  "mission.step.monitor.metrics": "Metrics",
  "mission.step.monitor.instrument": "Instrument",
  "mission.step.monitor.alerts": "Alerts",
  "mission.step.improve.experiment": "Experiment",
  "mission.step.improve.measure": "Measure",
  "mission.step.maintain.inventory": "Inventory",
  "mission.step.maintain.intake": "Intake",
  "mission.step.advisory.context": "Context",
  "mission.step.advisory.observe": "Observe",
  "mission.step.advisory.advising": "Advising",
  "workspace.tab.memory": "Memory",
  "workspace.tab.squad": "Squad",
  "workspace.tab.files": "Files",
  "workspace.squad.stakeholders": "Stakeholders",
  "workspace.squad.reportsTo": "reports to",
  "workspace.squad.lead": "Mission lead",
  "workspace.squad.permanent": "Permanent",
  "workspace.squad.temporary": "Temporary",
  "workspace.squad.punctual": "punctual",
  "workspace.squad.noTemporary": "No temporary members",
  "settings.models.title": "Models",
  "settings.models.cardTitle": "Model configuration",
  "settings.models.cardDescription": "Set the default model, effort, max tokens and fallback for each role.",
  "settings.github.title": "GitHub App",
  "settings.github.connect": "Connect / add repos",
  "settings.github.connectFailed": "Could not start the GitHub connection.",
  "settings.github.targetAccountLabel": "GitHub organization or user",
  "settings.github.targetAccountPlaceholder": "e.g. my-org",
  "settings.github.targetAccountInvalid": "Enter a valid GitHub organization or user login.",
  "settings.github.notConfigured": "Not configured",
  "settings.github.healthy": "Healthy",
  "settings.github.degraded": "Degraded",
  "settings.github.empty": "No GitHub installation yet.",
  "settings.github.noMission": "No linked mission",
  "settings.github.linkSaved": "Repo linked to the mission.",
  "settings.github.linkFailed": "Could not link this repo.",
  "settings.github.linkArchived": "Link archived.",
  "settings.github.addMission": "Add a mission…",
  "settings.github.addMissionTo": "Add a mission to {{repo}}",
  "settings.github.archiveLink": "Archive link",
  "settings.github.archiveMission": "Archive link: {{title}}",
  "settings.github.limitReached": "Limit reached ({{count}}/{{limit}}): archive a mission link to add another.",
  "settings.github.repoBusy": "This repository already runs {{limit}} active missions (the limit of your office).",
  "settings.github.missionLimitLabel": "Active missions per repository",
  "settings.github.missionLimitHelp": "Per repository: empty = unlimited, or 1 to {{max}}. Office: 1 to {{officeMax}} (default 10). Beyond a limit, new issues wait for their turn in the office queue. Lowering a limit never stops a running mission.",
  "settings.github.missionLimitSave": "Save limit",
  "settings.github.missionLimitSaved": "Limit saved.",
  "settings.github.missionLimitFailed": "Could not save the limit.",
  "settings.github.autoMission": "Start a mission when a collaborator opens an issue",
  "settings.github.autoMissionSaved": "Auto-mission setting saved.",
  "settings.github.autoMissionFailed": "Could not change the auto-mission setting.",
  "settings.github.inboundTitle": "Recent deliveries",
  "settings.github.pending": "pending",
  "settings.github.replay": "Replay",
  "settings.github.replayed": "Delivery replayed.",
  "settings.github.replayFailed": "Replay failed.",
  "settings.github.never": "never",
  "settings.github.justNow": "just now",
  "settings.github.minutesAgo": "{{count}} min ago",
  "settings.github.hoursAgo": "{{count}} h ago",
  "settings.github.daysAgo": "{{count}} d ago",
  "settings.githubTriage.title": "Issue triage",
  "settings.githubTriage.description": "Proposals only: nothing is planned, closed or edited. Accept a proposal, or mark it corrected when you change its labels.",
  "settings.githubTriage.empty": "No triaged issue yet. Apply the nova:triage label to an issue, or comment /nova triage on any issue.",
  "settings.githubTriage.colIssue": "Issue",
  "settings.githubTriage.colLabels": "Proposed labels",
  "settings.githubTriage.colNext": "Next action",
  "settings.githubTriage.colCost": "Cost",
  "settings.githubTriage.colStatus": "Status",
  "settings.githubTriage.colDecision": "Judgment",
  "settings.githubTriage.statusFilter": "Status",
  "settings.githubTriage.statusAll": "All",
  "settings.githubTriage.status.running": "Running",
  "settings.githubTriage.status.proposed": "Proposed",
  "settings.githubTriage.status.accepted": "Accepted",
  "settings.githubTriage.status.corrected": "Corrected",
  "settings.githubTriage.status.superseded": "Superseded",
  "settings.githubTriage.status.failed": "Failed",
  "settings.githubTriage.next.plan": "Ready to plan",
  "settings.githubTriage.next.needs_info": "Needs info",
  "settings.githubTriage.next.duplicate": "Duplicate",
  "settings.githubTriage.next.human": "Needs a human",
  "settings.githubTriage.next.defer": "Deferred",
  "settings.githubTriage.accept": "Accept",
  "settings.githubTriage.correct": "Mark corrected",
  "settings.githubTriage.decisionSaved": "Decision saved.",
  "settings.githubTriage.decisionFailed": "Could not save the decision.",
  "settings.githubTriage.loadMore": "Load more",
  "settings.githubTriage.loadFailed": "Could not load the triage list.",
  "settings.githubTriage.spentToday": "Spent today: {{amount}}",
  "settings.githubTriage.spentTodayCap": "Spent today: {{amount}} of {{cap}}",
  "settings.githubTriage.acceptanceRate": "Accepted unchanged: {{rate}}",
  "settings.githubTriage.pending": "{{count}} to review",
  "settings.githubTriage.failedWith": "Failed ({{code}})",
  "settings.github.outcome.connected": "GitHub App connected.",
  "settings.github.outcome.updated": "GitHub App installation updated.",
  "settings.github.outcome.requested": "Installation request sent — an organization owner must approve it.",
  "settings.github.outcome.connected_partial": "Connected, but the repo list could not be refreshed yet.",
  "settings.githubIdentity.title": "GitHub identity",
  "settings.githubIdentity.subtitle": "Link your own GitHub account so /nova commands you post on GitHub are recognized as you.",
  "settings.githubIdentity.linked": "Linked as @{{login}}",
  "settings.githubIdentity.notLinked": "Not linked",
  "settings.githubIdentity.verifiedVia.oauth": "OAuth",
  "settings.githubIdentity.verifiedVia.claim": "Claimed",
  "settings.githubIdentity.verifiedVia.manual": "Manual (display only — never authorizes commands)",
  "settings.githubIdentity.link": "Link GitHub",
  "settings.githubIdentity.linkFailed": "Could not start the GitHub link.",
  "settings.githubIdentity.unlink": "Unlink",
  "settings.githubIdentity.unlinked": "GitHub identity unlinked.",
  "settings.githubIdentity.unlinkFailed": "Could not unlink.",
  "settings.githubIdentity.claimInstead": "Can't link right now? Claim from a comment instead.",
  "settings.githubIdentity.claimLoginLabel": "Your GitHub login",
  "settings.githubIdentity.claimSubmit": "Get a claim command",
  "settings.githubIdentity.claimFailed": "Could not create a claim.",
  "settings.githubIdentity.claimTooMany": "Too many pending claims — wait for one to expire, or use one already issued.",
  "settings.githubIdentity.claimCommand": "Paste this as a comment on GitHub, from @{{login}}:",
  "settings.githubIdentity.copy": "Copy",
  "settings.githubIdentity.copied": "Copied.",
  "settings.githubOnboarding.title": "Connect a repository",
  "settings.githubOnboarding.subtitle": "Install the App, link a repository, merge the bootstrap PR, then start a mission with /nova plan.",
  "settings.githubOnboarding.guideLink": "10-minute guide",
  "settings.githubOnboarding.checklist.app_installed": "App installed",
  "settings.githubOnboarding.checklist.repo_linked": "Repository linked",
  "settings.githubOnboarding.checklist.bootstrap_merged": "Bootstrap PR merged",
  "settings.githubOnboarding.checklist.first_plan": "First plan",
  "settings.githubOnboarding.action.install_app": "Install the App",
  "settings.githubOnboarding.action.configure_url": "Open GitHub settings",
  "settings.githubOnboarding.action.restart_install": "Finish authorization",
  "settings.githubOnboarding.action.retry": "Retry",
  "settings.githubOnboarding.action.view_pr": "View PR",
  "settings.githubOnboarding.action.guide_labels": "Why?",
  "settings.githubOnboarding.action.link_identity": "Link your GitHub identity",
  "settings.githubOnboarding.action.continue_import": "Continue import",
  "settings.githubOnboarding.action.connect_repo": "Connect",
  "settings.githubOnboarding.action.open_bootstrap_pr": "Open the bootstrap PR",
  "settings.githubOnboarding.action.review_pr": "Review and merge PR #{{number}}",
  "settings.githubOnboarding.action.comment_plan": "Comment /nova plan on an issue",
  "settings.githubOnboarding.action.open_mission": "Open mission",
  "settings.githubOnboarding.code.app_not_installed.message": "NovaTechnica's GitHub App is not installed for this Office.",
  "settings.githubOnboarding.code.app_suspended.message": "The App is suspended.",
  "settings.githubOnboarding.code.app_deleted.message": "The App was uninstalled.",
  "settings.githubOnboarding.code.app_pending.message": "The installation is waiting for your GitHub authorization.",
  "settings.githubOnboarding.code.repo_inaccessible.message": "The App cannot access {{repo}}.",
  "settings.githubOnboarding.code.bootstrap_in_progress.message": "A bootstrap is already running.",
  "settings.githubOnboarding.code.bootstrap_timeout.message": "The last bootstrap did not finish.",
  "settings.githubOnboarding.code.already_merged.message": "Already bootstrapped — PR #{{number}} was merged.",
  "settings.githubOnboarding.code.default_branch_up_to_date.message": "Nothing to add: the default branch already has the NovaTechnica files.",
  "settings.githubOnboarding.code.labels_fallback.message": "Issue types / fields are unavailable here: status, phase and priority use labels.",
  "settings.githubOnboarding.code.closed_unmerged.message": "PR #{{number}} was closed without merging.",
  "settings.githubOnboarding.code.bootstrap_branch_foreign.message": "A branch nova/bootstrap exists that NovaTechnica did not create.",
  "settings.githubOnboarding.code.repo_empty.message": "The repository has no commits yet.",
  "settings.githubOnboarding.code.github_forbidden.message": "GitHub refused the write (archived repo, branch rule on nova/*?).",
  "settings.githubOnboarding.code.mint_refused.message": "The token service refused the request.",
  "settings.githubOnboarding.code.rate_limited.message": "GitHub rate limit reached.",
  "settings.githubOnboarding.code.identity_unlinked.message": "/nova plan will be refused: your GitHub account is not linked.",
  "settings.githubOnboarding.code.onboarding_unavailable.message": "The onboarding service is not available in this environment.",
  "settings.githubOnboarding.code.import_partial.message": "{{mirrored}}/{{found}} existing missions imported.",
  "settings.githubOnboarding.picker.title": "Repositories",
  "settings.githubOnboarding.picker.empty": "No repositories available yet.",
  "settings.githubOnboarding.picker.linked": "Linked",
  "settings.githubOnboarding.picker.private": "Private",
  "settings.githubOnboarding.picker.public": "Public",
  "settings.githubOnboarding.import.inProgress": "Importing existing missions… {{mirrored}}/{{found}}",
  "settings.githubOnboarding.import.done": "{{mirrored}} missions imported.",
  "settings.githubOnboarding.import.skippedTitle": "Not imported",
  "settings.githubOnboarding.import.skipReason.mid_unavailable": "another mission already uses this id",
  "settings.githubOnboarding.import.skipReason.sync_dir_missing": "the folder was not found at the repository's current head",
  "settings.githubOnboarding.import.skipReason.sync_dir_ambiguous": "more than one folder in .missions/ matches this id",
  "settings.githubOnboarding.import.skipReason.sync_ref_missing": "the branch could not be read",
  "settings.githubOnboarding.import.skipReason.sync_tree_truncated": "the repository tree is too large to read in one request",
  "settings.githubOnboarding.import.skipReason.sync_failed": "a temporary error — Continue import will retry it",
  "settings.githubOnboarding.import.skipReason.unknown": "could not be imported",
  "settings.githubOnboarding.state.no_app": "Install the App to get started.",
  "settings.githubOnboarding.state.app_installed": "Pick a repository to connect.",
  "settings.githubOnboarding.state.repo_inaccessible": "Grant the App access to this repository.",
  "settings.githubOnboarding.state.linked": "Open the bootstrap PR.",
  "settings.githubOnboarding.state.bootstrapping": "Opening the bootstrap PR…",
  "settings.githubOnboarding.state.pr_open": "Review and merge PR #{{number}}.",
  "settings.githubOnboarding.state.bootstrapped": "Comment /nova plan on an issue.",
  "settings.githubOnboarding.state.planned": "Done — open mission {{title}}.",
  "models.title": "Models",
  "models.subtitle": "Office-wide model defaults, per role.",
  "models.precedence": "These are the office defaults for each role. They can be overridden by an agent's profile, then by a mission.",
  "models.precedence.agentsLink": "View agent profiles",
  "models.precedence.missionsLink": "View missions",
  "models.tabs.label": "Roles by stage",
  "models.tab.transverse": "Cross-cutting",
  "models.empty": "No role in this stage.",
  "models.card.default": "Default",
  "models.card.custom": "Custom",
  "models.card.configure": "Configure",
  "models.card.chip.effort": "Effort: {{effort}}",
  "models.card.chip.maxTokens": "Max tokens: {{value}}",
  "models.card.chip.fallback": "Fallback: {{model}}",
  "models.provider.anthropic": "Anthropic",
  "models.provider.workersAi": "Workers AI",
  "models.role.account-manager.purpose": "Mission conversation and steering.",
  "models.role.chief-of-staff.purpose": "Operational rhythm and cross-cutting unblocking.",
  "models.role.architect.purpose": "Framing, spec, and structural decisions.",
  "models.role.product-manager.purpose": "Product prioritization and scope trade-offs.",
  "models.role.backend-engineer.purpose": "Writing code and tests.",
  "models.role.frontend-engineer.purpose": "Writing code and tests (frontend).",
  "models.role.reviewer.purpose": "Critical review and verdict.",
  "models.role.security-reviewer.purpose": "Critical review and verdict (security).",
  "models.role.tester.purpose": "Running and analyzing tests.",
  "models.role.shaper.purpose": "Turning vague intent into structured action.",
  "models.role.analyst.purpose": "Analysis, signal synthesis, and research.",
  "models.dialog.title": "Configure {{role}}",
  "models.dialog.description": "Office-wide setting for this role — applies to every agent with this role, unless a more specific override exists.",
  "models.dialog.model": "Model",
  "models.dialog.effort": "Reasoning effort",
  "models.dialog.maxTokens": "Max tokens",
  "models.dialog.maxTokensHint": "Between {{min}} and {{max}}.",
  "models.params.thinking.always": "Reasoning always on",
  "models.params.thinking.optional": "Reasoning can be switched off",
  "models.params.thinking.adaptive": "Adaptive reasoning",
  "models.params.maxOutput": "Max output: {{value}} tokens ({{min}} – {{max}})",
  "models.params.maxOutputDefault": "Max output (default): {{value}} tokens ({{min}} – {{max}})",
  "models.params.temperature": "Temperature: model default ({{default}}, range {{min}}–{{max}})",
  "models.params.noEffort": "No effort setting for this model",
  "models.dialog.fallback": "Fallback model",
  "models.unavailable": "unavailable",
  "models.dialog.fallbackNone": "None",
  "models.dialog.systemDefault": "System default: {{value}}",
  "models.dialog.reset": "Reset",
  "models.dialog.save": "Save",
  "models.dialog.saving": "Saving…",
  "models.dialog.saved": "Configuration saved",
  "models.dialog.resetDone": "Reset to default",
  "models.providerPanels.platform.title": "Platform models",
  "models.providerPanels.platform.description": "Run through Anthropic via AI Gateway — selectable for every role.",
  "models.providerPanels.platform.empty": "No executable model yet.",
  "models.providerPanels.byok.title": "BYOK (bring your own key)",
  "models.providerPanels.byok.description": "Configured today via the platform-wide AI_GATEWAY_TOKEN.",
  "models.providerPanels.byok.body": "Per-office BYOK isn't available yet — planned for a later iteration.",
  "workspace.champion.action.modelFallback": "Fallback model: {{from}} → {{to}}",
  "workspace.champion.action.toolRefused": "Refused: {{tool}} ({{code}})",
  "workspace.champion.action.attachmentsOmitted_one": "{{count}} attachment not read: {{model}} cannot read images or PDFs",
  "workspace.champion.action.attachmentsOmitted_other": "{{count}} attachments not read: {{model}} cannot read images or PDFs",
  "mcp.title": "MCP connections",
  "mcp.subtitle": "Servers connected at the office level and shared by every mission. Connect one here — or ask Camille.",
  "mcp.status.active": "Active",
  "mcp.status.inactive": "Not connected",
  "mcp.action.connect": "Connect",
  "mcp.action.reconnect": "Reconnect",
  "mcp.action.disconnect": "Disconnect",
  "mcp.action.cancel": "Cancel",
  "mcp.auth.pat": "Personal access token (PAT)",
  "mcp.auth.oauth": "OAuth · consent screen",
  "mcp.token.placeholder": "Paste a token (PAT)",
  "mcp.token.inputLabel": "{{server}} personal access token",
  "mcp.toast.connectStartError": "Could not start the MCP connection.",
  "mcp.toast.connected": "{{name}} connected",
  "mcp.toast.connectTokenError": "Could not connect — check the token.",
  "mcp.toast.disconnected": "{{name}} disconnected",
  "mcp.toast.disconnectError": "Could not disconnect.",
  "mcp.toast.customError": "Could not register this server.",
  "mcp.toast.selectionError": "Could not save the MCP selection.",
  "mcp.toast.oauthError": "MCP connect failed: {{reason}}",
  "mcp.chip.proposed": "MCP proposed: {{list}}",
  "mcp.chip.proposedEmpty": "MCP proposed",
  "mcp.custom.add": "Custom server",
  "mcp.custom.title": "Add a custom server",
  "mcp.custom.pocNotice": "POC feature — an outbound egress target, internal use only.",
  "mcp.custom.slugLabel": "Identifier",
  "mcp.custom.slugPlaceholder": "my-server",
  "mcp.custom.labelLabel": "Name",
  "mcp.custom.labelPlaceholder": "My server",
  "mcp.custom.urlLabel": "URL (https)",
  "mcp.custom.urlPlaceholder": "https://my-server.example.com/mcp",
  "mcp.custom.authLabel": "Authentication",
  "mcp.custom.authPat": "Token (PAT)",
  "mcp.custom.authNone": "None",
  "mcp.custom.submit": "Save",
  "mcp.mission.heading": "Selection for this mission",
  "mcp.mission.curated": "Custom selection active — only the checked servers are usable.",
  "mcp.mission.notCurated": "No selection yet: every active office connector is usable.",
  "mcp.mission.checkboxLabel": "Enable {{name}} for this mission",
  "mcp.mission.save": "Save",
  "mcp.mission.reset": "Reset to office default",
  "mcp.mission.resetting": "Resetting…",
  "mcp.toast.resetSuccess": "Selection reset — this mission now follows the office default.",
  "mcp.toast.resetError": "Could not reset the MCP selection.",
  "mcp.card.title": "Suggested MCP servers",
  "mcp.card.empty": "No server in the catalogue.",
  "mcp.card.confirm": "Confirm selection",
  "mcp.card.confirming": "Saving…",
  "mcp.card.receiptSelected": "MCP selection saved: {{list}}",
  "mcp.card.receiptEmpty": "MCP selection saved: none",
  "missionDataSources.heading": "Mission data sources",
  "missionDataSources.intro": "Choose which sources this mission can consult. Connecting itself happens in Settings → Data sources ; here you authorize their use for this mission.",
  "missionDataSources.readonlyNotice": "Only the point of contact and an agency admin can change this selection.",
  "missionDataSources.save": "Save",
  "missionDataSources.saving": "Saving…",
  "missionDataSources.toast.selectionSaved": "Selection updated.",
  "missionDataSources.toast.selectionError": "Could not save the data-source selection.",
  "missionDataSources.selection.readLabel": "{{name}} — authorized for this mission",
  "missionDataSources.selection.writeLabel": "{{name}} — allow writing",
  "missionDataSources.selection.writeHint": "Reading looks at your data ; writing can change it (send a campaign, edit a product…). This mission's first write will need approval in the thread.",
  "missionDataSources.selection.notUsable": "Authorized — needs connecting",
  "missionDataSources.legacy.heading": "Direct connectors (legacy)",
  "missionDataSources.card.title": "Suggested data sources",
  "missionDataSources.card.empty": "No source published to this office.",
  "missionDataSources.card.confirm": "Confirm selection",
  "missionDataSources.card.confirming": "Saving…",
  "missionDataSources.card.receiptSelected": "Selected sources: {{list}}",
  "missionDataSources.card.receiptEmpty": "Selected sources: none",
  "missionDataSources.card.receiptFlag": "needs connecting",
  "missionDataSources.card.connectByPoc": "To be connected by the point of contact",
  "missionDataSources.card.obsolete": "Direct-connector proposal — superseded by data sources",
  "missionDataSources.chip.listed": "Sources: {{list}}",
  "missionDataSources.chip.listedEmpty": "Sources: none",
  "missionDataSources.chip.proposed": "Sources proposed: {{list}}",
  "missionDataSources.chip.proposedEmpty": "Sources proposed",
  "dataSources.title": "Data sources",
  "dataSources.intro": "Connect the tools you already use — Google Analytics, Shopify, Klaviyo — so your NovaTechnica team works from your real numbers instead of guessing. You stay in control: any connection can be revoked at any time.",
  "nav.connections": "Connections",
  "connections.title": "Connections",
  "connections.intro": "Connect your data sources and tools here. Your keys never go through NovaTechnica.",
  "connections.dataSources.title": "Data sources",
  "connections.dataSources.intro": "Your business data your agents can read, mission by mission.",
  "connections.dataSources.searchLabel": "Search a source",
  "connections.dataSources.searchPlaceholder": "Shopify, Odoo, Google Analytics…",
  "connections.dataSources.connected": "Connected",
  "connections.dataSources.catalogue": "Catalogue",
  "connections.dataSources.showMore": "Show more",
  "connections.dataSources.emptySearch": "No source matches “{{query}}”.",
  "connections.tooling.title": "Tooling",
  "connections.tooling.intro": "Build and operations tools: code, deploys, errors, design.",
  "connections.tooling.notUsedYet": "Connected for the office — not used by agents yet.",
  "connections.settingsLink.title": "Connections",
  "connections.settingsLink.description": "Data sources, GitHub and tools.",
  "dataSources.toast.pending": "This source is being set up, try again in a moment.",
  "dataSources.toast.cap": "Too many new sources today for this office. Try again tomorrow.",
  "dataSources.status.connected": "Connected",
  "dataSources.status.pending": "Pending",
  "dataSources.status.reconnect": "Needs reconnection",
  "dataSources.status.notConnected": "Not connected",
  "dataSources.shop.label": "Shop name",
  "dataSources.shop.placeholder": "my-shop",
  "dataSources.shop.helper": "my-shop.myshopify.com — the part before .myshopify.com",
  "dataSources.shop.invalid": "Enter your shop name, like my-shop (not an e-mail address).",
  "dataSources.badge.managed": "Direct sign-in",
  "dataSources.badge.apiKey": "API key required",
  "dataSources.badge.apiKeyHint": "You'll paste your own key on a secure page — it never passes through NovaTechnica.",
  "dataSources.action.connect": "Connect",
  "dataSources.action.reconnect": "Reconnect",
  "dataSources.action.disconnect": "Disconnect",
  "dataSources.action.disconnectConfirm": "Confirm disconnect",
  "dataSources.action.connectNamed": "Connect {{name}}",
  "dataSources.action.reconnectNamed": "Reconnect {{name}}",
  "dataSources.action.retry": "Retry",
  "dataSources.action.retryNamed": "Retry connecting {{name}}",
  "dataSources.action.disconnectNamed": "Disconnect {{name}}",
  "dataSources.action.disconnectConfirmNamed": "Confirm disconnect of {{name}}",
  "dataSources.toast.notConfigured": "Data sources are not set up for this office yet.",
  "dataSources.toast.gone": "This data source is no longer available.",
  "dataSources.toast.alreadyConnected": "This data source is already connected.",
  "dataSources.action.cancel": "Cancel",
  "dataSources.toast.connectStartError": "Could not start the connection.",
  "dataSources.toast.connected": "Data source connected",
  "dataSources.toast.connectReturnError": "The connection could not be completed.",
  "dataSources.toast.disconnected": "Data source disconnected",
  "dataSources.toast.disconnectError": "Could not disconnect.",
  "dataSources.state.notConfigured.title": "Not set up yet",
  "dataSources.state.notConfigured.description": "Your NovaTechnica team hasn't turned this on for your office yet. Ask your point of contact to enable data sources.",
  "dataSources.state.empty": "No data source is available here yet — NovaTechnica declares which ones are offered to your office.",
  "dataSources.state.error.title": "Data sources are temporarily unavailable",
  "dataSources.state.error.nonPoc": "Ask your office's point of contact to look into this.",
  "charts.aria.workloadUtilization": "Bar chart: capacity utilization per member",
  "charts.aria.workloadComparison": "Bar chart: allocated vs capacity hours per member",
  "charts.workload.capacityRuleNote": "Dashed line = 100% capacity",
  "charts.aria.statusDoughnut": "Doughnut chart: tasks by status",
  "charts.aria.doughnut": "Doughnut chart: {{label}} breakdown",
  "charts.aria.costByMission": "Bar chart: estimated vs actual cost by mission",
  "charts.aria.priorityBars": "Bar chart: tasks by priority",
  "charts.aria.countBars": "Bar chart: {{unit}} count by group",
  "charts.aria.hoursBars": "Bar chart: logged hours",
  "charts.aria.estimatedVsActualBars": "Bar chart: estimated vs actual hours",
  "questionSlides.title": "Question",
  "questionSlides.multiHint": "Several answers allowed.",
  "questionSlides.otherLabel": "Other answer",
  "questionSlides.otherPlaceholder": "Other / details…",
  "questionSlides.prev": "Back",
  "questionSlides.next": "Next",
  "questionSlides.submit": "Send answers",
  "questionSlides.answered": "Answered",
  "questionSlides.superseded": "Replaced by a newer question",
  "questionSlides.counter": "{{n}} / {{total}}",
  "questionSlides.missing": "Answer missing for question {{n}}",
  "questionSlides.goTo": "Go to question {{n}}",
  "delivery.liveTitle": "Your app is online",
  "delivery.deployingTitle": "Putting your app online",
  "delivery.deployingBody": "This usually takes a few minutes. The address appears here as soon as it is ready.",
  "delivery.failedTitle": "Going online did not complete",
  "delivery.failedBody": "Nothing was changed on the version that is already online. You can try again.",
  "delivery.retry": "Try again",
  "delivery.retryFailed": "Could not start it again. Try in a moment.",
  "delivery.copy": "Copy address",
  "delivery.copied": "Copied",
  "delivery.copiedAnnounce": "Address copied",
  "delivery.lastDeploy": "Last update",
  "delivery.version": "Version",
  "delivery.unknown": "Unknown",
  "delivery.lastFailed": "The latest update did not go online. The previous version is still running.",
  "delivery.exportGithub": "Export to GitHub",
  "delivery.exported": "Exported to {{repo}}.",
  "delivery.exportNeedsInstall": "Connect GitHub first, from the office settings.",
  "delivery.exportNeedsAccess": "GitHub needs your approval to continue. Open the GitHub settings of this office.",
  "delivery.exportFailed": "Could not export. Try again in a moment.",
  "delivery.claim": "Claim my account",
  "branches.title": "Branch builds",
  "branches.subtitle": "Every push builds its branch. Each branch other than main gets its own private preview.",
  "branches.status.building": "Building",
  "branches.status.deployed": "Preview ready",
  "branches.status.built": "Built — ready to go live",
  "branches.status.failed": "Failed",
  "branches.status.failedAt": "Failed at {{step}}",
  "branches.status.superseded": "Replaced by a newer push",
  "branches.status.skipped_budget": "Skipped — budget reached",
  "branches.status.blocked": "Waiting for the mock check",
  "branches.status.torn_down": "Preview removed",
  "branches.kind.main": "main",
  "branches.kind.story": "story",
  "branches.kind.other": "branch",
  "branches.open": "Open preview",
  "branches.cost": "Build cost",
  "branches.version": "Version",
  "branches.deleted": "deleted",
  "claim.title": "Claim my account",
  "claim.intro": "Move your app to an account you own. Until you confirm, it keeps running here.",
  "claim.close": "Close",
  "claim.optionsLabel": "How do you want to receive your app?",
  "claim.oauthTitle": "Use my Cloudflare account",
  "claim.oauthBody": "You sign in to Cloudflare and approve access once. Your app and all its data are copied to your account.",
  "claim.oauthStart": "Connect my Cloudflare account",
  "claim.tempTitle": "Create a new Cloudflare account for me",
  "claim.tempBody": "A new account is prepared with your app. You then have 60 minutes to claim it. Your app starts with an empty database.",
  "claim.tempUnavailable": "Not available for this app: it uses features a new account does not support.",
  "claim.tosLabel": "I accept the Cloudflare <tos>Terms of Service</tos> and <privacy>Privacy Policy</privacy>.",
  "claim.tosNew": "(opens in a new tab)",
  "claim.tempStart": "Create my account",
  "claim.noneAvailable": "Claiming is not available for this app.",
  "claim.consentTitle": "Waiting for your approval on Cloudflare",
  "claim.consentBody": "Finish signing in on the Cloudflare page. If you closed it, cancel and start again.",
  "claim.chooseTitle": "Choose the account that will receive your app",
  "claim.chooseContinue": "Move my app to this account",
  "claim.migratingTitle": "Moving your app and its data",
  "claim.migratingBody": "This can take a few minutes. Your app stays online here meanwhile.",
  "claim.deployedTitle": "Your app is ready in your account",
  "claim.deployedBody": "Check that it works at its new address. When you confirm, we stop hosting it here and the old address points to the new one.",
  "claim.newAddress": "New address",
  "claim.confirm": "Confirm and stop hosting it here",
  "claim.preparingTitle": "Preparing your new account",
  "claim.preparingBody": "This takes a moment. Keep this page open.",
  "claim.linkTitle": "Your account is ready to claim",
  "claim.linkBody": "Open the link, sign up or sign in to Cloudflare, and claim the account.",
  "claim.linkOpen": "Claim the account",
  "claim.linkWarning": "This link is shown only once and only to you. Do not share it: whoever opens it gets the account.",
  "claim.linkExpires": "Claim before {{time}}.",
  "claim.claimedConfirm": "I have claimed it",
  "claim.linkGoneTitle": "Waiting for your claim",
  "claim.linkGoneBody": "The claim link was shown once. If you did not use it, start over to get a new one.",
  "claim.startOver": "Start over",
  "claim.expiredTitle": "The claim link expired",
  "claim.expiredBody": "The account was not claimed in time. You can create a new one.",
  "claim.failedTitle": "The move did not complete",
  "claim.failedBody": "Nothing changed: your app is still online here. You can try again.",
  "claim.declined": "Access was not approved on Cloudflare. Nothing changed.",
  "claim.doneTitle": "Your app now lives in your account",
  "claim.doneBody": "We no longer host it or have access to your account. Any later update needs your approval again.",
  "claim.cancel": "Cancel",
  "claim.error": "Something went wrong. Try again in a moment.",
  "claim.working": "Working…",
  "build.title": "Build",
  "build.agentConfig.platform": "Agents: platform (composed by the platform, mounted read-only in the sandbox)",
  "build.agentConfig.plugin": "Agents: plugin ({{reason}})",
  "build.notStarted": "Build not started yet — no code runs for this mission.",
  "build.repoLabel": "Repository",
  "build.start": "Start the build",
  "build.noRepo": "No repository connected to this office.",
  "build.connectRepo": "Connect a repository (Settings → GitHub)",
  "build.planPending": "Plan: awaiting your approval",
  "build.mockHolds.title": "Waiting on a mock not validated yet",
  "build.mockHolds.line": "{{sids}} wait(s) on mock {{mock}}: the build will not start them until it is validated.",
  "build.mockHolds.hint": "It validates itself when you click « I checked » on the mock's PR and then merge it from the Studio.",
  "build.mockHolds.lift": "Lift the wait — mock {{mock}}",
  "build.mockHolds.reason": "Why lift the wait? (10 to 200 characters, logged)",
  "build.mockHolds.reasonPlaceholder": "E.g. mock checked on the preview and merged",
  "build.mockHolds.confirm": "Confirm",
  "build.mockHolds.cancel": "Cancel",
  "build.mockHolds.done": "Wait lifted: the stories resume on the engine's next pass.",
  "build.mockHolds.error": "Lifting the wait failed ({{code}}).",
  "build.mockHolds.unreadable": "A mock of this build is unreadable: the engine holds the stories that depend on it.",
  "build.openGate": "Open the gate",
  "build.status.executing": "Build in progress",
  "build.status.review": "In review",
  "build.status.done": "Delivered",
  "build.status.paused": "Paused",
  "build.status.archived": "Abandoned",
  "build.attention.title": "Step “{{step}}” stopped",
  "build.attention.attempt": "attempt {{attempt}}",
  "build.attention.storyLine": "{{sid}} · {{step}} · attempt {{attempt}} — {{reason}}",
  "build.attention.retryStory": "Retry {{sid}}",
  "build.attention.outcome.failed": "failed",
  "build.attention.outcome.needs_human": "needs a human decision",
  "build.attention.outcome.blocked": "blocked",
  "build.attention.reason": "Cause: {{reason}}",
  "build.attention.retry": "Retry",
  "build.attention.abort": "Abort",
  "build.attention.confirmAbort": "Abort the mission? Running jobs are stopped, the GitHub issue is closed and the repository is freed. Branches are kept.",
  "build.attention.confirmAbortPrompt": "Confirm the abort?",
  "build.attention.confirmAbortYes": "Confirm",
  "build.attention.confirmAbortNo": "Cancel",
  "build.attention.result.retry.accepted": "Retry requested — the orchestrator resumes the step.",
  "build.attention.result.retry.noop": "Nothing to retry: no failed step on the orchestrator side.",
  "build.attention.result.retry.rejected": "Retry refused by the orchestrator ({{reason}}).",
  "build.attention.result.retry.queued": "Retry queued — every build slot is busy; it will start as soon as a slot frees, before any story not started yet. No need to retry again.",
  "build.attention.result.abort.accepted": "Mission aborted — the repository is free.",
  "build.attention.result.abort.noop": "Mission already closed — the repository is free.",
  "build.attention.result.abort.rejected": "Abort refused by the orchestrator ({{reason}}).",
  "build.attention.ceiling.reached": "Retry ceiling reached — no automatic retry.",
  "build.attention.ceiling.override": "Override…",
  "build.attention.ceiling.reason": "Reason for one more retry (logged)",
  "build.attention.ceiling.submit": "Retry once more",
  "build.errors.build_not_started": "The build has not been started for this mission.",
  "build.delivery.live": "Live",
  "build.delivery.noUrl": "Delivered — no prod URL configured for this repository.",
  "build.errors.phase_not_building": "The mission is not in building: get the shaping gate approved first.",
  "build.errors.mission_closed": "The mission is done or archived.",
  "build.errors.build_started_other_repo": "The build already started on another repository.",
  "build.errors.story_set_drift": "The stories changed since the POC approved the plan: the build uses the approved set only.",
  "build.errors.plan_not_approved": "The plan has not been approved yet: approve it in the Plan tab, then start the build.",
  "build.errors.stories_outside_plan": "Some stories were not created by the approved plan: supersede them, then start the build.",
  "build.errors.repo_not_onboarded": "This repository is not onboarded in the office.",
  "build.errors.repo_busy": "This repository already carries another active mission.",
  "build.errors.mission_files_missing": "intent.md, brief.md and stories.md are missing: nothing to hand to the build.",
  "build.errors.mint_refused": "The GitHub App refused the access token.",
  "build.errors.github_error": "GitHub refused to create the mission issue.",
  "build.errors.mission_agent_unavailable": "The orchestrator is unavailable — retry, nothing is lost.",
  "build.errors.unknown": "The build could not be started.",
  "build.viewRuns": "View runs",
  "build.stories.toggle": "Stories ({{count}})",
  "build.stories.unreachable": "Orchestrator state unavailable.",
  "build.stories.attempt": "attempt {{attempt}}",
  "build.stories.pr": "PR #{{number}}",
  "build.stories.noopStory": "{{sid}} is already in progress ({{sub}})",
  "build.stories.sub.queued": "queued",
  "build.stories.sub.implementing": "implementing",
  "build.stories.sub.reviewing": "reviewing",
  "build.stories.sub.awaiting_merge": "awaiting merge",
  "build.stories.sub.blocked": "blocked",
  "build.stories.sub.done": "done",
  "build.stories.sub.cancelled": "cancelled",
  "build.stories.merge": "Merge",
  "build.stories.mergeAria": "Merge the PR of {{sid}}",
  "build.stories.confirmMerge": "Merge PR #{{number}} of {{sid}} into the mission branch, at the reviewed (SHIP) commit?",
  "build.stories.confirmYes": "Yes, merge",
  "build.stories.confirmNo": "Cancel",
  "build.stories.merged": "{{sid}}: PR merged.",
  "build.stories.verify": "I checked {{code}}",
  "build.stories.verifyAria": "Mark {{code}} as checked by me",
  "build.stories.verifyHint": "For you to check before the merge (open the preview):",
  "build.stories.verified": "{{code}} checked.",
  "build.stories.verifySha": "reviewed commit:",
  "build.stories.verifyNoSha": "A human check is requested, but the reviewed commit is unreadable: request a re-review (/nova review on PR #{{number}}).",
  "build.errors.head_moved": "The PR changed after the SHIP review: request a re-review (/nova review on the PR), then merge.",
  "build.errors.human_verify_pending": "Human checks are still pending: click « I checked » on each one first.",
  "build.errors.head_mismatch": "The story was reviewed on a new commit since this was shown: reload, check that commit, then click again.",
  "build.errors.human_verify_unknown": "The verdict asks for a human check the Studio has no record of (a review from before 10/21): request a re-review (/nova review on the PR), then check and merge.",
  "build.errors.invalid_sha": "The checked commit is invalid: reload the page.",
  "build.errors.not_shipped": "This story has no (or no longer a) SHIP verdict.",
  "build.errors.checks_pending": "CI has not finished on this commit yet: try again in a moment.",
  "build.errors.checks_not_green": "CI is red on this commit: nothing was merged.",
  "build.errors.sha_not_reviewed": "This commit is not the one the review approved.",
  "build.errors.pr_not_open": "The PR is no longer open.",
  "build.errors.not_pending": "This check is no longer pending.",
  "build.errors.verdict_publish_failed": "GitHub did not accept the new verdict: try again, the check stays pending.",
  "build.errors.invalid_decided_by": "Only an office POC with a linked GitHub account can do this.",
  "build.errors.poc_required": "Office POC only.",
  "build.budget.exceeded": "Budget exceeded: {{used}} M / {{max}} M tokens",
  "build.budget.exceededIterations": "Budget exceeded: {{used}} / {{max}} iterations",
  "build.budget.exceededOther": "Budget exceeded ({{metric}})",
  "build.budget.capLabel": "New cap (millions of tokens)",
  "build.budget.capUnit": "M tokens",
  "build.budget.capLabelIterations": "New cap (iterations)",
  "build.budget.capUnitIterations": "iterations",
  "build.budget.confirmAcceptIterations": "Raise the cap to {{cap}} iterations and restart the queued stories?",
  "build.budget.errorUnknown": "The budget decision could not be recorded.",
  "build.budget.accept": "Raise and continue",
  "build.budget.defer": "Pause",
  "build.budget.confirmAccept": "Raise the cap to {{cap}} M tokens and restart the queued stories?",
  "build.budget.confirmDefer": "Keep the mission paused without raising the budget?",
  "build.budget.confirmYes": "Confirm",
  "build.budget.confirmNo": "Cancel",
  "build.budget.result.accepted": "Budget raised — the orchestrator resumes on its next tick.",
  "build.budget.result.recorded": "Decision recorded — the mission stays paused.",
  "build.errors.github_identity_required": "Link your GitHub account (Settings → GitHub) to decide on the budget.",
  "build.errors.cap_not_above_usage": "The new cap must be above the current usage.",
  "build.errors.no_open_budget_escalation": "No budget breach is waiting for a decision.",
  "build.errors.budget_decision_rejected": "The orchestrator refused the budget decision.",
  "runs.title": "Runs",
  "runs.back": "Back to chat",
  "runs.listLabel": "Mission runs",
  "runs.empty": "No run for this mission yet: they appear once the build starts.",
  "runs.unavailable": "Logs are not available on this environment (artifacts bucket not bound).",
  "runs.error": "Could not load the runs.",
  "runs.pick": "Pick a run to see its logs.",
  "runs.attempt": "attempt {{attempt}}",
  "runs.heartbeat": "heartbeat {{age}} ago",
  "runs.status.running": "Running",
  "runs.status.succeeded": "Succeeded",
  "runs.status.failed": "Failed",
  "runs.status.fallback": "Fallback",
  "runs.copy": "Copy",
  "runs.copied": "Copied",
  "runs.logs.tabsLabel": "Log files",
  "runs.logs.tab.output": "Output",
  "runs.logs.tab.stderr": "Stderr",
  "runs.logs.tab.diagnostics": "Diagnostics",
  "runs.logs.tab.result": "Result",
  "runs.logs.tab.compose-mode": "Compose mode",
  "runs.logs.pending": "Full logs arrive at the end of the run.",
  "runs.logs.missing": "No file for this tab in this run.",
  "runs.logs.loading": "Loading…",
  "runs.logs.empty": "(empty file)",
  "runs.logs.error": "Could not load this log.",
  "mission.journey.runsLabel": "View runs",
  "roomThread.title": "Mission thread",
  "roomThread.listLabel": "Threads by story",
  "roomThread.thread.mission": "Mission",
  "roomThread.close": "Close the thread",
  "roomThread.empty": "No bus traffic yet.",
  "roomThread.emptyThread": "No message in this thread.",
  "roomThread.unavailable": "The live thread is not available on this environment.",
  "roomThread.error": "Could not load the thread.",
  "roomThread.summary.checkins_one": "{{count}} check-in",
  "roomThread.summary.checkins_other": "{{count}} check-ins",
  "roomThread.summary.eta": "ETA {{min}} min",
  "roomThread.summary.etaOverdue": "ETA overdue",
  "roomThread.summary.noBlocker": "no blocker",
  "roomThread.summary.blockers_one": "{{count}} blocker",
  "roomThread.summary.blockers_other": "{{count}} blockers",
  "roomThread.summary.pending_one": "{{count}} waiting",
  "roomThread.summary.pending_other": "{{count}} waiting",
  "roomThread.line.eta": "ETA {{min}} min",
  "roomThread.line.pending": "waiting on you",
  "roomThread.actor.poc": "POC",
  "roomThread.actor.engine": "engine",
  "roomThread.actor.run": "run",
  "roomThread.actor.agent": "agent",
  "roomThread.kind.progress_up": "progress",
  "roomThread.kind.progress_down": "setback",
  "roomThread.kind.eta": "ETA",
  "roomThread.kind.question": "question",
  "roomThread.kind.request": "request",
  "roomThread.kind.blocker": "blocker",
  "roomThread.kind.finding": "finding",
  "roomThread.kind.steer": "steer",
  "roomThread.kind.notice": "notice",
  "roomThread.kind.alert": "alert",
  "roomThread.turn.progressing": "progressing",
  "roomThread.turn.waiting_on": "waiting",
  "roomThread.turn.blocked": "blocked",
  "roomThread.turn.done": "done",
  "roomThread.pinned.title_one": "{{count}} item waiting",
  "roomThread.pinned.title_other": "{{count}} items waiting",
  "roomThread.pinned.question": "Question from Camille",
  "roomThread.pinned.answerInChat": "Answer in the chat",
  "roomThread.pinned.gate": "{{kind}} gate to approve",
  "roomThread.pinned.openGate": "Open the gate",
  "roomThread.pinned.ask": "{{actor}} asks · {{thread}}",
  "roomThread.confirmation.title": "Confirmation requested",
  "roomThread.confirmation.target": "Target: {{target}}",
  "roomThread.confirmation.confirm": "Confirm",
  "roomThread.confirmation.refuse": "Refuse",
  "roomThread.confirmation.waitPoc": "Waiting for the POC",
  "settings.localWorker.title": "Local worker",
  "settings.localWorker.description": "Run this office's implement steps with Claude Code on your machine. The code expires in 10 minutes and works once.",
  "settings.localWorker.button": "Get a pairing code",
  "settings.localWorker.copy": "Copy the prompt",
  "settings.localWorker.error": "The code could not be created. Try again.",
  "settings.mockOptional.title": "Optional mock",
  "settings.mockOptional.description": "When on, every UI line of the next plans goes without an HTML mock (reason: office setting). On a plan you can still ask a mock back for one line. Plans already approved do not change.",
  "settings.mockOptional.switchLabel": "Optional mock for the next plans",
  "settings.mockOptional.on": "On",
  "settings.mockOptional.off": "Off",
  "settings.mockOptional.readOnly": "Only the office POC can change this setting.",
  "settings.mockOptional.historyTitle": "Latest changes",
  "settings.mockOptional.historyEmpty": "No change yet.",
  "settings.mockOptional.historyOn": "Turned on by {{name}} on {{date}}",
  "settings.mockOptional.historyOff": "Turned off by {{name}} on {{date}}",
  "settings.mockOptional.unknownUser": "a former member",
  "settings.mockOptional.error.generic": "The setting could not be saved. Try again.",
  "settings.mockOptional.error.poc_required": "Only the office POC can change this setting.",
  "settings.mockOptional.error.forbidden": "Only the office POC can change this setting.",
  "settings.mockOptional.error.invalid_input": "Value refused. Reload the page and try again.",
  "settings.autonomy.title": "Camille's autonomy",
  "settings.autonomy.version": "version {{version}}",
  "settings.autonomy.intro": "What Camille may do alone on this office's missions. Outside this envelope she asks you for a confirmation.",
  "settings.autonomy.reversible": "Reversible actions",
  "settings.autonomy.merge": "Story PR merges",
  "settings.autonomy.release": "Mission release",
  "settings.autonomy.mode.act": "Alone",
  "settings.autonomy.mode.confirm": "With confirmation",
  "settings.autonomy.mode.auto": "Automatic",
  "settings.autonomy.maxTokens": "Budget ceiling (tokens)",
  "settings.autonomy.maxTokensHint": "Camille may raise a mission budget up to this ceiling.",
  "settings.autonomy.criticalPct": "\"Critical only\" threshold (%)",
  "settings.autonomy.criticalPctHint": "Above this share of the ceiling, only critical actions stay autonomous.",
  "settings.autonomy.wakeTokens": "Wake tokens per day",
  "settings.autonomy.wakesPerHour": "Max wakes per hour",
  "settings.autonomy.typical": "Typical durations (default ETA)",
  "settings.autonomy.typicalStep": "Typical duration · {{step}} (min)",
  "settings.autonomy.deployHosts": "Allowed deploy hosts",
  "settings.autonomy.deployHostsHint": "One host suffix per line (e.g. myteam.workers.dev), 10 at most. Camille records a deploy URL on these hosts alone; anywhere else she asks you to confirm. A public suffix alone (workers.dev, pages.dev, com) is refused.",
  "settings.autonomy.save": "Save the envelope",
  "settings.autonomy.saved": "Envelope saved.",
  "settings.autonomy.invalid": "Refused values: {{fields}}",
  "settings.autonomy.stale": "The envelope changed in the meantime: reloaded, check it and try again.",
  "settings.autonomy.error": "Could not save the envelope.",
  "settings.autonomy.pocOnly": "Only the POC can edit the envelope.",
  "roomThread.chatNotice": "Confirm it in the pinned card: Runs tab › Mission thread.",
  "office.audit.title": "Agent audit",
  "office.audit.subtitle": "Where the agent money and time go: office, project, mission, then agents and stories, ranked. Waste = work that did not ship (failed calls, lost runs, attempts rejected at review), counted once.",
  "office.audit.breadcrumb.label": "Audit breadcrumb",
  "office.audit.breadcrumb.office": "Office",
  "office.audit.level.label": "Level",
  "office.audit.level.project": "Projects",
  "office.audit.level.mission": "Missions",
  "office.audit.level.agent": "Agents",
  "office.audit.level.story": "Stories",
  "office.audit.level.activation": "Activations",
  "office.audit.level.model": "Models",
  "office.audit.lens.label": "Lens",
  "office.audit.lens.cost": "Cost",
  "office.audit.lens.time": "Time",
  "office.audit.lens.waste": "Waste",
  "office.audit.col.cost": "Cost",
  "office.audit.col.tokens": "Tokens",
  "office.audit.col.calls": "Calls",
  "office.audit.col.errorCalls": "Errors",
  "office.audit.col.agentTime": "Agent time",
  "office.audit.col.activations": "Activations",
  "office.audit.col.waste": "Wasted",
  "office.audit.col.wastePct": "% wasted",
  "office.audit.col.reruns": "Reruns",
  "office.audit.col.qaRetries": "QA retries",
  "office.audit.col.firstPass": "First pass",
  "office.audit.unattributed.project": "Unattributed (no project)",
  "office.audit.unattributed.mission": "No mission",
  "office.audit.unattributed.agent": "No agent",
  "office.audit.unattributed.story": "Mission level (no story)",
  "office.audit.unattributed.activation": "No activation",
  "office.audit.unattributed.model": "Unknown model",
  "office.audit.other": "Others (folded)",
  "office.audit.total": "Total",
  "office.audit.running": "running",
  "office.audit.top": "Top {{rank}}",
  "office.audit.models.count": "{{count}} models",
  "office.audit.models.toggle": "Models of {{name}}",
  "office.audit.filter.model": "Model",
  "office.audit.filter.env": "Environment",
  "office.audit.filter.all": "All",
  "office.audit.filter.envTimeNote": "The environment filter applies to cost only: agent activations carry no environment, so time is not filtered.",
  "office.audit.period.label": "Period",
  "office.audit.period.mode": "Period type",
  "office.audit.period.month": "Month",
  "office.audit.period.custom": "Custom",
  "office.audit.period.from": "From",
  "office.audit.period.to": "To (exclusive)",
  "office.audit.period.live": "Live",
  "office.audit.period.report": "Report",
  "office.audit.period.invalid": "Invalid period: pick an end after the start, 93 days at most.",
  "office.audit.header.spend": "Period spend",
  "office.audit.header.cap": "Spend / cap",
  "office.audit.header.pct": "{{pct}}% of the cap",
  "office.audit.header.noBudget": "No budget",
  "office.audit.header.burn": "Burn per day",
  "office.audit.header.projection": "End-of-period projection",
  "office.audit.header.wholeOffice": "Whole office, budget period",
  "office.audit.header.waste": "Wasted",
  "office.audit.header.wastePct": "{{pct}}% of spend",
  "office.audit.header.agentTime": "Agent time",
  "office.audit.export": "Export CSV",
  "office.audit.empty": "No spend and no agent activation in this period.",
  "office.audit.error": "Could not load the audit.",
  "office.audit.truncated": "More than 500 rows: the tail is folded into \"Others\".",
  "office.audit.settingsLink.title": "Agent audit",
  "office.audit.settingsLink.cardTitle": "Agent audit, budget and export",
  "office.audit.settingsLink.cardDescription": "Agent cost, time and waste by project, mission, agent, story and model, the office budget and the CSV export.",
  "office.audit.waste.by.error": "Failed calls",
  "office.audit.waste.by.lost_run": "Lost runs",
  "office.audit.waste.by.rejected": "Rejected attempts",
  "consumption.budget.title": "Budget",
  "consumption.budget.none": "No budget set. Spending is not capped by the platform for this office.",
  "consumption.budget.set": "Set a budget",
  "consumption.budget.edit": "Edit",
  "consumption.budget.summary": "{{spent}} spent of {{cap}} ({{pct}} %) this {{period}}.",
  "consumption.budget.until": "Until {{date}} (UTC)",
  "consumption.budget.period.day": "day",
  "consumption.budget.period.week": "week",
  "consumption.budget.period.month": "month",
  "consumption.budget.action.refuse": "When reached: refuse new turns",
  "consumption.budget.action.downgrade": "When reached: switch to a cheaper model",
  "consumption.budget.warn": "{{pct}} % of the budget is used. Turns still run; the budget will stop them when it is reached.",
  "consumption.budget.exhausted.refuse": "Budget reached. New turns are refused until {{date}}. Raise the budget to continue.",
  "consumption.budget.exhausted.downgrade": "Budget reached. Turns switch to a cheaper model of the same provider where one exists, and are refused otherwise (and always for review and test work) until {{date}}.",
  "consumption.budget.unknown": "Spending could not be read just now. Turns are not blocked.",
  "consumption.budget.form.period": "Period",
  "consumption.budget.form.cap": "Amount (USD)",
  "consumption.budget.form.capHint": "Between $0.01 and {{max}}, in dollars.",
  "consumption.budget.form.action": "When the budget is reached",
  "consumption.budget.form.actionHint.refuse": "New turns are refused with a clear message until the period ends or the budget is raised.",
  "consumption.budget.form.actionHint.downgrade": "Turns move to a cheaper model of the same provider when a validated one exists. Review and test work is never downgraded: it is refused. Above 125 % of the amount, everything is refused.",
  "consumption.budget.form.save": "Save",
  "consumption.budget.form.clear": "Remove the budget",
  "consumption.budget.form.cancel": "Cancel",
  "consumption.budget.form.saveError": "Could not save the budget.",
  "consumption.builds.title": "Builds",
  "consumption.builds.note": "Each push builds its branch. A build is charged for its container seconds; its cost is already in the totals above.",
  "consumption.builds.app": "App",
  "consumption.builds.branch": "Branch",
  "consumption.builds.version": "Version",
  "consumption.builds.seconds": "Seconds",
  "consumption.builds.cost": "Cost",
  "mission.mode.configTitle": "Configuration · this mission",
  "mission.mode.trust.label": "Trust granted",
  "mission.mode.trust.camille": "Trust granted to Camille",
  "mission.mode.trust.level.supervised": "Supervised",
  "mission.mode.trust.level.guided": "Guided",
  "mission.mode.trust.level.autonomous": "Autonomous",
  "mission.mode.trust.effect.supervised": "Camille asks you before every decision, with the options and her recommendation.",
  "mission.mode.trust.effect.guided": "Camille asks you whenever a decision is visible or commits you; she handles retries, sequencing, models and assignments alone, and records why.",
  "mission.mode.trust.effect.autonomous": "Camille asks you only for what is irreversible; she merges, cuts a story's scope and adjusts the squad alone, documenting each choice.",
  "mission.mode.trust.agentEffect.supervised": "Asks before each choice in its story.",
  "mission.mode.trust.agentEffect.guided": "Decides what is invisible, asks before a visible choice.",
  "mission.mode.trust.agentEffect.autonomous": "Decides everything reversible in its story, reports its visible choices.",
  "mission.mode.trust.always": "Always you: budget, release, money or irreversible beyond the envelope, legal, gate signoffs.",
  "mission.mode.rigor.missionDefault": "Mission default rigor",
  "mission.mode.rigor.story": "Story rigor",
  "mission.mode.rigor.level.fast": "Ship fast",
  "mission.mode.rigor.level.steady": "Ship steady",
  "mission.mode.rigor.level.solid": "Ship solid",
  "mission.mode.rigor.effect.fast": "Tests on critical paths; security review if the surface is sensitive; 3 review attempts.",
  "mission.mode.rigor.effect.steady": "Full tests; security review if sensitive; 3 attempts.",
  "mission.mode.rigor.effect.solid": "Full tests + e2e on every P0 story; security review every time; escalation at the 2nd review.",
  "mission.mode.squad.scope": "Squad: story scope",
  "mission.mode.source.matchmaking": "confirmed at matchmaking",
  "mission.mode.source.poc": "changed by the POC",
  "mission.mode.source.proposed": "proposed by Camille",
  "mission.mode.source.inherited": "inherited from the member",
  "mission.mode.source.adjusted": "adjusted for this story",
  "mission.mode.matchmaking.title": "Your squad",
  "mission.mode.matchmaking.intro": "Camille prefilled each member's trust and rigor. Confirm or adjust in one pass.",
  "mission.mode.matchmaking.confirm": "Confirm the squad",
  "mission.mode.matchmaking.confirming": "Confirming…",
  "mission.mode.matchmaking.confirmed": "Squad confirmed",
  "mission.mode.matchmaking.pocOnly": "Only the POC confirms",
  "mission.mode.matchmaking.member": "Member",
  "mission.mode.matchmaking.model": "Model",
  "mission.mode.matchmaking.effort": "Effort",
  "mission.mode.matchmaking.why": "Why",
  "mission.mode.matchmaking.rowAria": "{{name}}, {{role}}",
  "mission.mode.matchmaking.conductorRole": "Leads the mission",
  "mission.mode.matchmaking.effortSnapped": "Effort set to {{level}}: this model does not offer {{previous}}.",
  "mission.mode.matchmaking.failed": "Could not confirm the squad",
  "mission.mode.assignment.title": "Trust and rigor per assignee",
  "mission.mode.assignment.edit": "Adjust for this story: {{name}}",
  "mission.mode.assignment.save": "Save",
  "mission.mode.assignment.cancel": "Cancel",
  "mission.mode.assignment.revert": "Back to the member",
  "mission.mode.chip.trust": "Trust: {{trust}}",
  "mission.mode.chip.rigor": "Rigor: {{rigor}}",
  "mission.mode.badge.text": "{{rigor}} · Camille {{trust}}",
  "mission.mode.badge.aria": "Mission mode: {{rigor}}, trust granted to Camille {{trust}}",
  "mission.mode.badge.proposed": "proposed",
  "mission.mode.badge.proposedHint": "Proposed by Camille, not confirmed yet: the defaults apply.",
  "mission.mode.badge.decisions": "Decisions",
  "mission.mode.gate.summaryTitle": "Mission mode (confirmed)",
  "mission.mode.gate.members": "Squad",
  "mission.mode.gate.assignments": "Per-story adjustments proposed by Camille (confirmed with Approve)",
  "mission.mode.gate.assignmentLine": "{{sid}} · {{name}}: {{values}}",
  "mission.decisions.title": "Decisions",
  "mission.decisions.intro": "What Camille decided alone: the problem, the options, her choice and how to revert it.",
  "mission.decisions.empty": "No decision recorded yet.",
  "mission.decisions.loadFailed": "Could not load the decisions.",
  "mission.decisions.loadMore": "Older",
  "mission.decisions.problem": "Problem",
  "mission.decisions.choice": "Choice",
  "mission.decisions.options": "Options",
  "mission.decisions.pros": "Pros",
  "mission.decisions.cons": "Cons",
  "mission.decisions.rationale": "Why",
  "mission.decisions.reversibility.reversible": "Reversible",
  "mission.decisions.reversibility.irreversible": "Irreversible",
  "mission.decisions.revertHow": "How to revert",
  "mission.decisions.refs": "References",
  "mission.decisions.supersedes": "Supersedes decision {{id}}",
  "mission.decisions.revisitNote": "POC note",
  "mission.decisions.byAt": "{{by}} · {{at}}",
  "mission.decisions.details": "Details of decision #{{seq}}",
  "mission.decisions.trust": "Trust at the time: {{trust}}",
  "mission.decisions.class.minor": "minor",
  "mission.decisions.class.visible": "visible",
  "mission.decisions.class.irreversible": "irreversible",
  "mission.decisions.class.choice": "choice",
  "mission.decisions.status.recorded": "recorded",
  "mission.decisions.status.used": "applied",
  "mission.decisions.status.revisit_requested": "revisit requested",
  "mission.decisions.status.revisited": "revisited",
  "mission.decisions.revisit": "Revisit this decision",
  "mission.decisions.revisitLabel": "What you want revisited (500 characters max)",
  "mission.decisions.revisitSubmit": "Ask Camille to revisit",
  "mission.decisions.revisitCancel": "Cancel",
  "mission.decisions.revisitSent": "Request sent to Camille",
  "mission.decisions.notRevisable": "This decision can no longer be revisited.",
  "mission.decisions.revisitFailed": "Request failed",
  "mission.decisions.pocOnly": "Only the POC can ask to revisit a decision.",
  "mission.decisions.history": "History",
  "mission.decisions.alternatives": "Alternatives: {{list}}",
  "workspace.dock.decisions": "Camille's decisions",
  "mission.kickoff.effort.xhigh": "Extra",
  "mission.kickoff.effort.max": "Max",
  "mission.mode.source.default": "default",
  "mission.mode.source.unreadable": "unreadable: narrowest level",
  "mission.mode.pocOnly": "Only the POC can change this",
  "mission.mode.rigor.label": "Rigor",
  "mission.mode.saved": "Mode saved",
  "mission.mode.stale": "The mode changed meanwhile: values reloaded.",
  "mission.mode.agentNotInSquad": "A member is no longer in the squad: values reloaded.",
  "mission.mode.saveFailed": "Could not save the mode",
  "mission.mode.proposal.title": "Mission mode",
  "mission.mode.proposal.byCamille": "Proposed by Camille",
  "mission.mode.proposal.none": "No proposal: defaults pre-filled.",
  "mission.mode.proposal.signals": "Signals",
  "mission.mode.proposal.confirmHint": "Approving confirms this mode; you can still change it later in Squad.",
  "mission.mode.proposal.confirmed": "Mode confirmed by the POC",
  "mission.mode.proposal.infoDiff": "Camille’s proposal (information only, not applied): {{diff}}",
  "mission.mode.notAllowed": "The mode was not recorded on this gate",
  "mission.mode.notAllowedDetail": "The mode was not recorded on this gate: nothing was decided. Set it in Squad, or approve without the mode.",
  "mission.mode.approveWithoutMode": "Approve without the mode",
  "mission.mode.rigorUnmet": "Rigor requirements not met: re-plan or give a bypass reason.",
  "mission.mode.blocker.security_reviewer_missing": "No security-reviewer in the squad.",
  "mission.mode.blocker.e2e_missing": "P0 stories without an e2e oracle: {{sids}}",
  "mission.mode.blocker.e2e_facts_unreadable": "E2E facts unreadable: the plan rigor facts could not be read, re-plan.",
  "sidebar.archived.toggle": "Show archived",
  "sidebar.archived.tag": "Archived",
  "mission.archive.badge": "Archived",
  "mission.archive.menu": "Mission actions",
  "mission.archive.archive": "Archive",
  "mission.archive.unarchive": "Unarchive",
  "mission.archive.confirmArchiveTitle": "Archive this mission?",
  "mission.archive.confirmArchiveBody": "It leaves the sidebar (use the “Show archived” filter to find it). A new chat message unarchives it.",
  "mission.archive.confirmUnarchiveTitle": "Unarchive this mission?",
  "mission.archive.confirmUnarchiveBody": "It comes back to the sidebar, with the status of its current phase.",
  "mission.archive.cancel": "Cancel",
  "mission.archive.archived": "Mission archived",
  "mission.archive.unarchived": "Mission unarchived",
  "storyDrawer.tabs.budget": "Budget",
  "storyDrawer.budget.total": "Total budget",
  "storyDrawer.budget.split": "People {{humans}} · Agents {{agents}}",
  "storyDrawer.budget.incomplete": "Incomplete: {{unrated}} unrated, {{unpriced}} unpriced, {{hidden}} hidden",
  "storyDrawer.budget.humans": "People",
  "storyDrawer.budget.agents": "Agents",
  "storyDrawer.budget.empty": "Nothing spent yet.",
  "storyDrawer.budget.atRate": "at {{rate}}/h",
  "storyDrawer.budget.setRate": "Set your hourly rate",
  "storyDrawer.budget.unrated": "No rate",
  "storyDrawer.budget.redacted": "Rate private",
  "storyDrawer.budget.basis.harness": "Billed",
  "storyDrawer.budget.basis.priced": "Estimated ({{version}})",
  "storyDrawer.budget.basis.unpriced": "Unpriced",
  "storyDrawer.budget.running": "Running",
  "storyDrawer.budget.tokens": "{{in}} in · {{out}} out",
  "storyDrawer.budget.cache": "Cache: {{read}} read · {{write}} written",
  "storyDrawer.budget.cacheSummary": "Cache tokens",
  "storyDrawer.budget.rateLabel": "Hourly rate (USD/h)",
  "storyDrawer.budget.rateSource.office": "office rate",
  "storyDrawer.budget.rateSource.profile": "personal rate",
  "storyDrawer.budget.rateSource.none": "no rate",
  "storyDrawer.budget.rateHintSetOffice": "Saved as your office rate.",
  "storyDrawer.budget.rateHintOverride": "Applies to this entry only; your office rate is unchanged.",
  "storyDrawer.budget.rateAdjusted": "rate adjusted for this ticket",
  "storyDrawer.budget.effortLevel.low": "Low",
  "storyDrawer.budget.effortLevel.medium": "Medium",
  "storyDrawer.budget.effortLevel.high": "High",
  "storyDrawer.budget.effortLevel.xhigh": "Extra",
  "storyDrawer.budget.effortLevel.max": "Max",
  "storyDrawer.budget.effort": "effort {{level}}",
  "storyDrawer.budget.modelUnknown": "unknown model",
  "storyDrawer.budget.effortUnknown": "effort not recorded",
  "storyDrawer.budget.maxTokensTip": "Output cap: {{n}} tokens",
  "storyDrawer.budget.readOnly": "Recorded by the platform",
  "storyDrawer.budget.edit": "Edit",
  "storyDrawer.budget.delete": "Delete",
  "storyDrawer.budget.update": "Update",
  "storyDrawer.budget.cancel": "Cancel",
  "storyDrawer.budget.truncated": "Showing the newest entries only.",
  "storyDrawer.budget.noCost": "not priced",
  "storyDrawer.budget.attempt": "attempt {{n}}",
  "mission.journey.budgetTitle": "Mission budget: {{amount}}{{plus}}",
  "settings.rate.title": "Hourly rate",
  "settings.rate.help": "Visible to you, the office POC and agency admins.",
  "settings.rate.override": "Office rate",
  "settings.rate.source.profile": "from profile",
  "settings.rate.source.office": "office override",
  "settings.rate.save": "Save",
  "settings.rate.remove": "Remove",
  "settings.rate.currency": "Currency: USD",
  "settings.rate.none": "No rate set",
  "settings.rate.saved": "Rate saved",
  "settings.rate.removed": "Rate removed",
  "settings.rate.failed": "Could not save the rate",
  "settings.rate.removeOverride": "Remove office rate",
  "settings.rate.hidden": "Profile rate private until they log time here",
  "staff.title": "Office squad",
  "staff.status.hired": "Hired",
  "staff.status.pending_confirmation": "To confirm",
  "staff.priceUndefined": "price to be defined",
  "staff.perMonth": "{{amount}} / month",
  "staff.perMonthSuffix": "/ month",
  "staff.missionChip": "{{title}} — {{roles}}",
  "staff.openStories_one": "{{count}} open story",
  "staff.openStories_other": "{{count}} open stories",
  "staff.capLabel": "Cap",
  "staff.noCap": "no cap",
  "staff.capReached": "Cap reached",
  "staff.totalMonthly": "Monthly total: {{amount}}",
  "staff.newTotal": "New total: {{amount}}",
  "staff.proposals": "To decide ({{count}})",
  "staff.proposal.hire": "Hire {{name}}",
  "staff.proposal.confirm": "Confirm {{name}}",
  "staff.proposal.release": "Release {{name}}",
  "staff.raiseCap": "Raises the cap to {{cap}}",
  "staff.accept": "Accept",
  "staff.refuse": "Refuse",
  "staff.error.generic": "Could not record the decision.",
  "staff.error.staff_cap_reached": "Cap reached: raise it to hire.",
  "staff.error.champion_has_active_roles": "This champion still holds roles on an active mission.",
  "staff.showLegacy": "Show history ({{count}})",
  "staff.hideLegacy": "Hide history",
  "staff.legacy.badge": "History",
  "staff.legacy.banner": "History — this agent served the mission {{mission}}; its champion replaces it in the office squad.",
  "staff.legacy.bannerNoMission": "History — this agent served a past mission; its champion replaces it in the office squad.",
  "staff.legacy.replacedBy": "Replacement:",
  "staff.squadRoles": "Mission squad: champion — role",
  "staff.offSpecialty": "Off-specialty role",
  "staff.tab.missions": "Missions",
  "staff.noMissions": "No ongoing mission.",
  "staff.loading": "Loading…",
  "staff.untitledMission": "Untitled mission",
  "staff.untitledMissionOn": "Untitled mission · {{date}}",
  "staff.chart.title": "Office org chart",
  "staff.chart.list": "Office champions",
  "staff.chart.toConfirm_one": "{{count}} champion to confirm",
  "staff.chart.toConfirm_other": "{{count}} champions to confirm",
  "staff.chart.missions_one": "{{count}} mission",
  "staff.chart.missions_other": "{{count}} missions",
  "staff.chart.missionsLink_one": "{{name}}'s stories — {{count}} mission",
  "staff.chart.missionsLink_other": "{{name}}'s stories — {{count}} missions",
  "staff.chart.hire": "Hire",
  "staff.chart.hireAria": "Hire {{name}}",
  "staff.chart.more": "More actions for {{name}}",
  "staff.chart.refuse": "Decline the hire",
  "staff.chart.lead": "Conductor",
  "staff.chart.poc": "POC",
  "staff.chart.pocUnnamed": "Office POC",
  "staff.chart.open": "Open {{name}}'s card",
  "staff.panel.missions": "Missions ({{count}})",
  "staff.panel.close": "Close",
  "staff.panel.stories": "See their stories",
  "staff.panel.profile": "Agent profile",
  "staff.panel.reason": "Why: {{reason}}",
  "taskList.view.champion": "By champion",
  "taskList.champion.pick": "Champion",
  "taskList.champion.all_one": "All champions ({{count}})",
  "taskList.champion.all_other": "All champions ({{count}})",
  "taskList.champion.selected": "Selected champion",
  "taskList.champion.clear": "Show all",
  "taskList.champion.empty": "No assigned stories.",
  "taskList.champion.emptyOne": "No story assigned to this champion in this project.",
  "story.assignees.group": "{{role}} ({{count}})",
  "story.assignees.roleMark.implementer": "Im",
  "story.assignees.roleMark.reviewer": "Rv",
  "story.assignees.roleMark.tester": "Te",
  "story.assignees.roleMark.security-reviewer": "Se",
  "story.assignees.roleMark.architect": "Ar",
  "story.assignees.roleMark.account-manager": "AM",
  "story.assignees.roleMark.other": "··",
  "story.assignees.family.other": "Other",
  "story.assignees.aria": "{{parts}}",
  "story.assignees.ariaEffort": "effort {{value}}",
  "story.assignees.ariaTrust": "trust {{value}}",
  "story.assignees.ariaRigor": "rigor {{value}}",
  "story.assignees.tip.model": "Model",
  "story.assignees.tip.effort": "Effort",
  "story.assignees.tip.trust": "Trust",
  "story.assignees.tip.rigor": "Rigor",
  "story.assignees.adjusted": "adjusted for this story",
  "story.assignees.inherited.member": "inherited (member)",
  "story.assignees.inherited.mission": "inherited (mission)",
  "story.assignees.inherited.office": "inherited (office)",
  "story.assignees.more": "+{{n}}",
  "story.assignees.summary_one": "{{count}} assignee",
  "story.assignees.summary_other": "{{count}} assignees",
  "story.assignees.missingReviewer": "No reviewer",
  "story.assignees.missingReviewerHint": "This story has an implementer but no reviewer assigned.",
  "story.assignees.unassigned": "Unassigned",
  "assigneeEditor.open": "Edit assignments: {{names}}",
  "assigneeEditor.openEmpty": "Assign a champion to this story",
  "assigneeEditor.title": "Story assignments",
  "assigneeEditor.drawerTrigger": "Edit assignments",
  "assigneeEditor.list": "Assignments",
  "assigneeEditor.role": "Role",
  "assigneeEditor.champion": "Champion",
  "assigneeEditor.championPlaceholder": "Pick a champion…",
  "assigneeEditor.inherit": "Inherited ({{value}})",
  "assigneeEditor.modelNotForRole": "{{model}} — not available for this role",
  "assigneeEditor.save": "Save",
  "assigneeEditor.pocOnly": "Model, effort, trust and rigor: POC only.",
  "assigneeEditor.noMode": "Per-assignment settings are unavailable for this story.",
  "assigneeEditor.remove": "Remove {{name}}",
  "assigneeEditor.add": "Add",
  "assigneeEditor.toHire": "{{name}} — to hire",
  "assigneeEditor.offSquad": "{{name}} — not on the mission squad",
  "assigneeEditor.onStory": "{{name}} — already on the story",
  "assigneeEditor.hireLink_one": "{{count}} champion to hire → Hire",
  "assigneeEditor.hireLink_other": "{{count}} champions to hire → Hire",
  "assigneeEditor.error.modelBlocked": "This model is not selectable for this role.",
  "assigneeEditor.error.notOnStory": "This assignment no longer exists: refresh the story.",
  "assigneeEditor.error.forbidden": "POC only.",
  "assigneeEditor.error.memberNotFound": "This champion is not an active office agent.",
  "assigneeEditor.error.generic": "Could not save the change.",
  "assigneeEditor.lockedAfterStart": "Locked once implementation has started — only the POC can change this",
  "story.assignees.edit.unavailable": "Per-assignment model and effort are not available on this environment yet (migration pending).",
  "story.assignees.edit.inherit": "Inherited ({{value}})",
  "story.assignees.edit.inheritEffort": "Inherited",
  "story.assignees.role": "Role for this story",
  "story.assignees.rolePlaceholder": "Role…",
  "story.assignees.pick": "Add an assignee",
  "story.assignees.alreadyOnStory": "This champion is already on the story: one role per champion and story.",
  "story.assignees.roleNotHeld": "This champion does not hold that role on the mission.",
  "story.assignees.roleRequired": "This champion holds several roles: pick one.",
  "staff.cancel": "Cancel",
  "staff.price.edit": "Edit the price of {{name}}",
  "staff.price.label": "Monthly price of {{name}} (euros)",
  "staff.price.unit": "€ / month",
  "staff.price.save": "Save",
  "staff.cap.edit": "Edit the cap",
  "staff.cap.label": "Cap on hired champions",
  "staff.raiseCapTo": "Raise the cap to",
  "staff.settingsSaved": "Squad updated.",
  "staff.error.settings": "Could not save.",
  "staff.error.unknown_champion": "Unknown champion.",
  "staff.error.champion_not_in_catalog": "This champion is not in the Guild catalog.",
  "staff.error.already_hired": "This champion is already hired.",
  "staff.error.camille_is_permanent": "Camille is a permanent member of the office.",
  "staff.pocOnlyEdit": "POC only: persona, prompt and model apply to every mission.",
  "staff.matchmaking.hireTitle": "Hire into the office",
  "staff.matchmaking.rolesTitle": "Roles in the mission",
  "staff.matchmaking.hireIntro": "These champions are not in the office yet: hiring them stays your call.",
  "staff.matchmaking.hireRow": "Hire {{name}} ({{delta}})",
  "staff.matchmaking.noPrice": "price to be defined",
  "staff.matchmaking.decisionLink": "See the decision",
  "staff.matchmaking.offSpecialty": "Off specialty",
  "staff.matchmaking.decided": "Decision recorded.",
  "team.facepile.label": "Team: {{names}}",
  "team.facepile.labelMore": "Team: {{names}} and {{count}} more",
  "team.facepile.dialog": "Mission team",
  "team.facepile.more": "+{{count}}",
  "team.member.roles": "{{name}} — {{roles}}",
  "team.member.mention": "Mention",
  "team.member.mentionAria": "Mention {{name}}",
  "team.presence.working": "working",
  "team.presence.asking": "waiting for an answer",
  "team.presence.idle": "available",
  "team.unknownAgent": "An agent",
  "team.recipient.chip": "→ {{name}}",
  "team.recipient.reset": "Back to Camille",
  "team.recipient.listLabel": "Mention a team member",
  "team.recipient.hint": "{{name}} will answer this message",
  "team.question.region": "Question from {{name}}",
  "team.question.request": "Request",
  "team.question.story": "Open story {{sid}}",
  "team.question.mission": "Mission",
  "team.question.context": "Context",
  "team.question.options": "Options",
  "team.question.pros": "Pros",
  "team.question.cons": "Cons",
  "team.question.recommended": "Recommended",
  "team.question.because": "Why: {{because}}",
  "team.question.option": "Option {{n}}",
  "team.question.class.minor": "Minor",
  "team.question.class.visible": "Visible",
  "team.question.class.irreversible": "Irreversible",
  "team.question.state.waiting": "Waiting for Camille",
  "team.question.state.escalated": "Escalated to the POC",
  "team.question.state.answered": "Answered",
  "team.question.replies": "Answers",
  "team.question.replyBy.camille": "Camille",
  "team.question.replyBy.poc": "POC",
  "team.question.seeDecision": "See the decision",
  "team.escalation.title": "Camille proposes to answer:",
  "team.escalation.confirm": "Confirm",
  "team.escalation.refuse": "Refuse",
  "team.escalation.waitPoc": "Waiting for the POC",
  "team.answer.open": "Reply to {{name}}",
  "team.answer.label": "Your answer to {{name}}",
  "team.answer.send": "Send answer",
  "team.answer.cancel": "Cancel",
  "team.answer.error.already_answered": "This question was already answered.",
  "team.answer.error.question_not_found": "This question no longer exists.",
  "team.answer.error.generic": "Could not send the answer. Try again.",
  "team.notice.answerAgent": "Decision under {{name}}'s question",
  "team.notice.answerAgentGeneric": "Decision under an agent's question",
  "team.notice.goTo": "Go to the question",
  "team.seat.poc": "POC",
  "team.seat.camille": "Camille",
  "team.seat.pmSeat": "PM (seat)",
  "team.question.topic.product": "Product",
  "team.question.topic.delivery": "Shipping",
  "team.question.topic.other": "Other",
  "team.question.decides": "Decides: {{name}}",
  "team.question.deciderPo": "{{name}} (PO)",
  "team.question.deciderPm": "{{name}} (PM)",
  "team.question.reroutedBy": "re-routed by {{name}}",
  "team.question.rerouted": "re-routed",
  "team.question.state.waitingFor": "Waiting for {{name}}",
  "team.question.state.waitingPoc": "Waiting for the POC",
  "team.question.state.decidedBy": "Decided by {{name}}",
  "team.question.decision": "Decision",
  "team.question.adviceList": "Advice",
  "team.question.adviceBy": "Advice from {{name}}",
  "team.chain.title": "Chain of command",
  "team.chain.captionPm": "{{lead}} and {{pm}} report to the POC; the squad reports to {{pm}}",
  "team.chain.captionLead": "{{lead}} reports to the POC; the squad reports to {{lead}}",
  "team.chain.captionPmOnly": "{{pm}} reports to the POC; the squad reports to {{pm}}",
  "team.chain.disputes": "Disagreements ({{count}})",
  "team.dispute.title": "Disagreement · {{subject}}",
  "team.dispute.raisedBy": "Raised by {{name}}",
  "team.dispute.option": "Option {{letter}}",
  "team.dispute.otherOptions": "Other options",
  "team.dispute.costSeat": "seat estimate",
  "team.dispute.positionMissing": "Position not found: the seat's message is missing.",
  "team.dispute.positionSilent": "Gave no position within 30 min",
  "team.dispute.severity.minor": "Minor",
  "team.dispute.severity.visible": "Visible",
  "team.dispute.severity.major": "Major",
  "team.dispute.severityWith": "{{severity}}: {{reasons}}",
  "team.dispute.severityLabel": "Severity",
  "team.dispute.why.p0": "P0",
  "team.dispute.why.p0_order": "order ahead of a P0",
  "team.dispute.why.waterline": "waterline",
  "team.dispute.why.constraint": "constraint",
  "team.dispute.why.criticality": "high criticality",
  "team.dispute.why.irreversible": "irreversible",
  "team.dispute.why.envelope": "beyond the envelope",
  "team.dispute.why.unknown": "unreadable fact",
  "team.dispute.arbiterLabel": "Arbiter",
  "team.dispute.arbiterCamille": "Arbiter: {{name}}",
  "team.dispute.arbiterPoc": "Arbiter: POC",
  "team.dispute.reasonInput": "Reason (one line)",
  "team.dispute.reasonHint": "Write a reason to pick an option.",
  "team.dispute.choose": "Decide: option {{letter}} — {{label}}",
  "team.dispute.decidedPoc": "Decided by the POC — option {{letter}}",
  "team.dispute.decidedCamille": "Arbitrated by {{name}} — option {{letter}}",
  "team.dispute.error.choice_required": "Pick an option.",
  "team.dispute.error.already_answered": "This disagreement is already decided.",
  "team.dispute.error.generic": "Decision not sent. Try again.",
  "agentPrompt.title": "System prompt",
  "agentPrompt.mission": "Mission",
  "agentPrompt.noMission": "No mission",
  "agentPrompt.mode": "Turn type",
  "agentPrompt.modes.chat": "Chat",
  "agentPrompt.modes.wake": "Wake",
  "agentPrompt.loading": "Loading…",
  "agentPrompt.notLive": "This role has no runtime outside a mission: its prompt is composed at activation. Pick a mission to see the one an @-mention sends.",
  "agentPrompt.readOnly": "Read only: only the POC edits the office sections.",
  "agentPrompt.showFull": "show the full prompt",
  "agentPrompt.hideFull": "hide the full prompt",
  "agentPrompt.copy": "copy",
  "agentPrompt.copied": "Prompt copied",
  "agentPrompt.locked": "Locked section (not editable)",
  "agentPrompt.absent": "absent this turn",
  "agentPrompt.origin.platform": "Platform",
  "agentPrompt.origin.plugin": "Plugin",
  "agentPrompt.origin.office": "Office",
  "agentPrompt.origin.legacy": "Office (legacy)",
  "agentPrompt.diff.show": "show the changes from the default",
  "agentPrompt.diff.hide": "hide the changes",
  "agentPrompt.diff.same": "Identical.",
  "agentPrompt.diff.versus": "Current version → v{{version}}",
  "agentPrompt.editLabel": "Office text (empty = platform default)",
  "agentPrompt.placeholder.persona": "e.g. a calm project lead who decides fast.",
  "agentPrompt.placeholder.heartbeat": "e.g. 1. Read the board. 2. Unblock the oldest story. 3. Finish with set_conductor_status.",
  "agentPrompt.placeholder.office-instructions": "e.g. Always answer in French. Prioritise Wave 0 tickets.",
  "agentPrompt.save": "Save",
  "agentPrompt.saving": "Saving…",
  "agentPrompt.cancel": "cancel",
  "agentPrompt.reset": "back to default",
  "agentPrompt.history": "history",
  "agentPrompt.noVersions": "No saved version.",
  "agentPrompt.restore": "Restore v{{version}}",
  "agentPrompt.saved": "Section saved (v{{version}})",
  "agentPrompt.restored": "Version restored (v{{version}})",
  "agentPrompt.redacted_one": "{{count}} secret masked",
  "agentPrompt.redacted_other": "{{count}} secrets masked",
  "agentPrompt.action.edit": "edit",
  "agentPrompt.action.rollback": "restore",
  "agentPrompt.action.reset": "back to default",
  "agentPrompt.tools": "Exposed tools: {{tools}}",
  "agentPrompt.error.conflict": "Someone changed this section meanwhile: reloaded, try again.",
  "agentPrompt.error.tooLarge": "Text too long for this section.",
  "agentPrompt.error.locked": "Locked section.",
  "agentPrompt.error.forbidden": "POC only.",
  "agentPrompt.error.generic": "The operation failed.",
  "agentPrompt.error.load": "Could not load the prompt.",
  "agentPrompt.squadLink": "Persona and instructions: edit them in the agent's prompt",
  "ledger.oracle.eval": "eval",
  "ledger.oracle.e2e": "e2e",
  "ledger.oracle.live": "live",
  "ledger.oracle.review": "review",
  "ledger.oracle.capture": "capture",
  "storyContract.unframed": "Unframed",
  "storyContract.empty": "Nothing specified.",
  "storyContract.outcome": "Outcome:",
  "storyContract.input.title": "Input",
  "storyContract.input.context": "Context",
  "storyContract.input.consumes": "Consumes",
  "storyContract.input.read": "Read",
  "storyContract.input.constraints": "Constraints",
  "storyContract.input.other": "Other",
  "storyContract.output.title": "Output",
  "storyContract.output.unlocated": "no location given",
  "storyContract.gates.title": "Gates",
  "storyContract.gates.evidence": "Evidence",
  "storyContract.gates.noEvidence": "No evidence specified",
  "storyContract.gates.validatedBy": "Validated by",
  "storyContract.gates.oracles": "How it is checked",
  "storyContract.gates.criteria": "Acceptance criteria",
  "storyContract.gates.given": "Given",
  "storyContract.gates.when": "When",
  "storyContract.gates.then": "Then",
  "storyContract.validator.tester": "tester",
  "storyContract.validator.reviewer": "reviewer",
  "storyContract.validator.security-reviewer": "security reviewer",
  "storyContract.validator.poc": "POC",
  "storyContract.oracleHint.test": "an automated test",
  "storyContract.oracleHint.eval": "a replayed eval case",
  "storyContract.oracleHint.e2e": "an end-to-end journey",
  "storyContract.oracleHint.live": "observed on the real environment",
  "storyContract.oracleHint.review": "read by a person or an agent",
  "storyContract.oracleHint.capture": "a screenshot",
  "storyContract.oracleHint.checklist": "a ticked checklist",
  "storyContract.oracleHint.crossref": "a checked cross-reference",
  "storyContract.oracleHint.recompute": "a recomputed figure",
  "storyContract.oracleHint.prediction": "a prediction to confirm later",
  "storyContract.oracleHint.human_verify": "checked by a person",
  "storySet.title": "Story review",
  "storySet.loading": "Loading the plan…",
  "storySet.summary.stories_one": "{{count}} story",
  "storySet.summary.stories_other": "{{count}} stories",
  "storySet.summary.p0": "{{count}} on the P0 path",
  "storySet.summary.steps_one": "{{count}} step",
  "storySet.summary.steps_other": "{{count}} steps",
  "storySet.drift": "The stories changed after the plan was approved.",
  "storySet.truncated": "List truncated to the first 200 stories.",
  "storySet.step": "Step {{n}} — {{title}}",
  "storySet.stepImplicit": "Order not specified",
  "storySet.changed": "The plan changed, review it again",
  "storySet.hashRequired": "The plan could not be loaded: reload it before approving.",
  "storySet.decomposition.title": "How the work was split",
  "storySet.decomposition.missing": "Camille hasn't explained the split yet",
  "storySet.decomposition.invalid": "The split explanation is not complete yet:",
  "storySet.decomposition.problem": "The question:",
  "storySet.decomposition.options": "Options considered",
  "storySet.decomposition.chosen": "Chosen",
  "storySet.decomposition.pros": "Pros",
  "storySet.decomposition.cons": "Cons",
  "storySet.decomposition.rationale": "Why this split",
  "storySet.decomposition.outOfScope": "Left out",
  "storySet.decomposition.outOfScopeNone": "Nothing was left out.",
  "storySet.decomposition.when.later": "later",
  "storySet.decomposition.when.never": "never",
  "storySet.decomposition.p0Path": "P0 path",
  "storySet.decomposition.reversibility.reversible": "The split is reversible",
  "storySet.decomposition.reversibility.irreversible": "The split is hard to undo",
  "storySet.row.noOutcome": "outcome not described",
  "storySet.row.titleArtifactOnly": "(the title names a screen or a file, not what the user gets)",
  "storySet.row.unassigned": "unassigned",
  "storySet.row.dependsOn": "after",
  "storySet.row.changed": "changed since the last review",
  "storySet.row.commented": "commented",
  "storySet.row.showContract": "Show the contract of {{code}}",
  "storySet.row.hideContract": "Hide the contract of {{code}}",
  "storySet.row.comment": "Comment on {{code}}",
  "storySet.row.commentLabel": "Comment on {{code}}",
  "storySet.row.commentPlaceholder": "What should change in this story…",
  "storySet.row.commentCount": "{{n}}/{{max}}",
  "storySet.gate.showSummary": "Show the summary",
  "storySet.gate.hideSummary": "Collapse the summary",
  "storySet.gate.sendBackNeedsWhy": "To send back, say why: a general comment or one on a story.",
  "storySet.decomposition.missingHint": "She writes it down before asking you to approve the stories.",
  "storySet.errors.generic": "Something in the split still needs Camille's attention.",
  "storySet.errors.shaping_decomposition_missing": "Camille hasn't explained the split yet.",
  "storySet.errors.shaping_decomposition_invalid": "The explanation of the split is incomplete (the options weighed, the choice or why).",
  "storySet.errors.shaping_decomposition_too_large": "The explanation of the split is too long to show.",
  "storySet.errors.shaping_sequence_mismatch": "The order of the steps does not cover every story exactly once.",
  "storySet.errors.shaping_sequence_order": "A story is planned before a story it depends on.",
  "storySet.errors.shaping_p0_path_mismatch": "The core path does not list exactly the P0 stories.",
  "storySet.errors.shaping_priorities_undifferentiated": "Every story has the same priority, so the core path does not stand out.",
  "storySet.errors.shaping_p0_path_open": "A P0 story waits on a story that is not P0.",
  "storySet.errors.shaping_stories_unframed": "Some stories still lack their contract (what they deliver and how it is checked).",
  "storySet.legacyNote_one": "This story predates story contracts, so it has no outcome or gates yet.",
  "storySet.legacyNote_other": "These {{count}} stories predate story contracts, so they have no outcome or gates yet.",
  "storySet.banner.title": "How the work was split",
  "storySet.banner.show": "Show",
  "storySet.banner.hide": "Hide",
  "storySet.banner.steps_one": "{{count}} step",
  "storySet.banner.steps_other": "{{count}} steps",
  "storySet.banner.openGate": "Review on the gate",
  "storySet.draft": "Draft",
  "storySet.draftTitle": "Draft: not approved yet at the shaping gate",
  "cadrage.title": "Framing to validate",
  "cadrage.empty": "Nothing framed yet.",
  "cadrage.unconfirmed_one": "{{count}} proposal from Camille to confirm",
  "cadrage.unconfirmed_other": "{{count}} proposals from Camille to confirm",
  "cadrage.allValidated": "All validated by you",
  "cadrage.source.camille_proposed": "Proposed by Camille",
  "cadrage.source.poc_confirmed": "Confirmed by you",
  "cadrage.source.poc_stated": "Stated by you",
  "cadrage.confirm": "Confirm",
  "cadrage.confirmItem": "Confirm: {{label}}",
  "cadrage.correct": "Correct",
  "cadrage.correctItem": "Correct: {{label}}",
  "cadrage.correctionPlaceholder": "Your version, in one sentence",
  "cadrage.sendCorrection": "Send to Camille",
  "cadrage.cancel": "Cancel",
  "cadrage.correctionSent": "Correction sent to Camille",
  "cadrage.correctionMessage": "Framing correction — {{label}}: {{text}}",
  "cadrage.validate": "Validate the framing",
  "cadrage.sendBack": "Send back with comments",
  "cadrage.sendBackNeedsWhy": "Tell Camille what is wrong before sending the framing back.",
  "cadrage.sendBackMessage": "I am sending the framing back: {{text}}",
  "cadrage.changed": "The framing changed since it was shown — read the new version before validating.",
  "build.errors.cadrage_drift": "The framing changed since you validated it: confirm the changed items below again, then start the build.",
  "cadrage.quoteLabel": "Your words",
  "cadrage.correctionBusy": "Camille is still replying — send it again in a moment, your text is kept.",
  "constraints.title": "Finish, pace, budget",
  "constraints.edit": "Set finish level, pace and budget",
  "constraints.finition": "Finish level",
  "constraints.rythme": "Pace",
  "constraints.budget": "Budget (appetite)",
  "constraints.budgetQuestion": "What is this problem worth to you?",
  "constraints.envelope": "an envelope, not a quote",
  "constraints.budgetUnset": "To choose",
  "constraints.unavailable": "Not available",
  "constraints.critiqueUrgent": "Critical needs audit and redundancy: not compatible with a team assembled in a rush.",
  "constraints.finitionFrozen": "Finish level frozen when the plan was approved.",
  "constraints.spent": "Already spent: {{amount}}",
  "constraints.deadline": "Deadline (optional)",
  "constraints.deadlineHint": "Without a date, the end of the validated horizon applies.",
  "constraints.save": "Save",
  "constraints.saved": "Finish level, pace and budget saved",
  "constraints.errors.stale_constraints": "The constraints changed meanwhile — read the new version.",
  "constraints.errors.finition_frozen": "The finish level is frozen since the plan was approved.",
  "constraints.errors.use_plan_settings": "A plan is submitted: set them on the plan itself.",
  "constraints.errors.critique_urgent_unavailable": "Critical × Urgent is not available.",
  "constraints.errors.budget_below_spend": "The budget cannot go below what is already spent.",
  "constraints.errors.invalid_budget": "This amount is not possible.",
  "constraints.errors.invalid_deadline": "This date is not valid.",
  "constraints.errors.invalid_finition": "This finish level does not exist.",
  "constraints.errors.invalid_rythme": "This pace does not exist.",
  "constraints.errors.not_poc": "Only the office's POC sets these constraints.",
  "constraints.errors.poc_required": "Only the office's POC sets these constraints.",
  "constraints.noBudget": "No budget set: the platform's default cap applies ($25).",
  "constraints.spendLabel": "Spend against the budget",
  "constraints.spendOfEstimated": "{{spent}} spent of {{budget}}, estimate included (as the cap counts it)",
  "constraints.spendOf": "{{spent}} spent of {{budget}}",
  "constraints.unpriced_one": "{{count}} run with no known cost: counted at the highest model price, or a flat $12 when it recorded no tokens.",
  "constraints.unpriced_other": "{{count}} runs with no known cost: counted at the highest model price, or a flat $12 each when they recorded no tokens.",
  "constraints.waterline.rule": "Waterline — what is below is not built this time",
  "constraints.waterline.summary": "Estimated above the line: {{total}} · margin {{margin}}",
  "constraints.waterline.noBudget": "No budget set: the whole plan is above the line ({{total}} estimated).",
  "constraints.waterline.belowCount_one": "{{count}} line below the waterline: out of scope this time.",
  "constraints.waterline.belowCount_other": "{{count}} lines below the waterline: out of scope this time.",
  "constraints.waterline.sourceHistory_one": "From your office's history ({{count}} story).",
  "constraints.waterline.sourceHistory_other": "From your office's history ({{count}} stories).",
  "constraints.waterline.sourceMixed_one": "Partly from your office's history ({{count}} story), the rest a cautious estimate.",
  "constraints.waterline.sourceMixed_other": "Partly from your office's history ({{count}} stories), the rest a cautious estimate.",
  "constraints.waterline.sourceDefault": "Cautious estimate, no history yet.",
  "constraints.waterline.estimate": "≈ {{amount}}",
  "constraints.waterline.outOfScope": "out of scope",
  "constraints.waterline.belowTag": "below the waterline",
  "constraints.waterline.issue.waterline_p0_below": "P0 line below the waterline: raise the budget, lower the finish level or the pace, or make it P1.",
  "constraints.waterline.issue.waterline_dependency_below": "Depends on {{deps}}, which is below the line: move that one up or this one down.",
  "constraints.waterline.moveUp": "Move {{code}} up the order",
  "constraints.waterline.moveDown": "Move {{code}} down the order",
  "mission.mode.rigor.derived": "Follows the finish level the POC chose.",
  "cadrage.sendBackBusy": "Framing sent back. Camille is still replying: repeat your comment in the chat so she can use your words.",
  "cadrage.drift_one": "{{count}} item changed since you validated — confirm it again",
  "cadrage.drift_other": "{{count}} items changed since you validated — confirm them again",
  "plan.title": "Action plan",
  "plan.loading": "Loading the plan…",
  "plan.empty": "Nothing written here yet.",
  "plan.emptyTab": "Camille has not submitted an action plan for this mission yet.",
  "plan.changed": "The plan changed, read it again before approving.",
  "plan.cadrageStale": "The framing changed since this plan was written: Camille has to rework it.",
  "plan.cadrageSource.poc_stated": "said by you",
  "plan.cadrageSource.camille_proposed": "proposed by Camille",
  "plan.cadrageSource.poc_confirmed": "confirmed by you",
  "plan.storiesEmpty": "Stories are created when the plan is approved.",
  "plan.storiesEmptyLink": "Read the plan",
  "plan.approve.plain": "Approve the plan",
  "plan.approve.read": "I read the spec (rev. {{rev}}) and approve the plan",
  "plan.sendBack": "Send back to Camille",
  "plan.sendBackNeedsWhy": "To send back, say why: a general comment or one on a line.",
  "plan.approvedBadge": "Approved · fingerprint {{hash}}",
  "plan.status.submitted": "Waiting for your decision",
  "plan.status.approved": "approved",
  "plan.status.rejected": "sent back",
  "plan.status.superseded": "superseded",
  "plan.status.draft": "draft",
  "plan.versions.title": "Versions:",
  "plan.versions.current": "version {{n}}",
  "plan.versions.item": "v{{n}} · {{status}}",
  "plan.feedback.title": "What you sent back on version {{n}}",
  "plan.mode.title": "Mission settings",
  "plan.section.glance": "At a glance",
  "plan.section.problem": "The problem",
  "plan.section.solution": "Proposed solution",
  "plan.section.alternatives": "Alternatives considered",
  "plan.section.spec": "Architecture and spec",
  "plan.section.decomposition": "Decomposition",
  "plan.section.risks": "Risks and mitigations",
  "plan.section.lines": "Line by line",
  "plan.section.budget": "Budget and time",
  "plan.section.out_of_scope": "Out of scope",
  "plan.section.coverage": "Request coverage",
  "plan.section.budgetConstraints": "Budget, finish level, pace",
  "plan.section.approval": "What approving does",
  "plan.glance.version": "Version",
  "plan.glance.lines": "Lines",
  "plan.glance.p0": "P0 path",
  "plan.glance.criticality": "Criticality",
  "plan.glance.appetite": "Appetite:",
  "plan.glance.trigger_one": "Approving creates {{count}} story, already staffed and set.",
  "plan.glance.trigger_other": "Approving creates {{count}} stories, already staffed and set.",
  "plan.solution.why": "Why this solution",
  "plan.alternatives.rationale": "Why this choice",
  "plan.spec.read": "Read the spec (rev. {{rev}})",
  "plan.spec.missing": "The spec is not written yet.",
  "plan.spec.stale": "The spec was revised since this plan (rev. {{from}} → {{to}}).",
  "plan.spec.revisedSinceApproval": "Spec revised since approval (rev. {{from}} → {{to}}).",
  "plan.decomposition.sequence": "Order of the steps",
  "plan.risks.title": "Risks",
  "plan.risks.none": "No risk identified.",
  "plan.coverage.intro": "Each ask of your message and of the framing, and what the plan does with it. Check what is deferred or rejected before approving.",
  "plan.coverage.summary": "{{covered}} covered · {{deferred}} deferred · {{rejected}} rejected",
  "plan.coverage.requirement": "Ask",
  "plan.coverage.source": "Your words",
  "plan.coverage.status": "Status",
  "plan.coverage.lines": "Lines",
  "plan.coverage.reason": "Reason",
  "plan.coverage.status.covered": "Covered",
  "plan.coverage.status.deferred": "Deferred",
  "plan.coverage.status.rejected": "Rejected",
  "plan.coverage.belowWaterline": "below the waterline",
  "plan.risks.impact": "Impact",
  "plan.risks.likelihood": "Likelihood",
  "plan.risks.mitigation": "Mitigation:",
  "plan.level.low": "low",
  "plan.level.medium": "medium",
  "plan.level.high": "high",
  "plan.budget.complexity": "Complexity",
  "plan.budget.horizon": "Horizon:",
  "plan.budget.estimate": "Estimated cost: between ${{low}} and ${{high}}, from the office's delivered stories.",
  "plan.budget.noHistory": "No history yet to estimate the cost.",
  "plan.approval.text_one": "The {{count}} line becomes a story, with {{assignments}} assignment(s) and the settings above, signed by you. The build can then start. Until you approve, no story exists.",
  "plan.approval.text_other": "The {{count}} lines become stories, with {{assignments}} assignment(s) and the settings above, signed by you. The build can then start. Until you approve, no story exists.",
  "plan.approval.done_one": "Plan approved: {{count}} story created, staffed and set as decided.",
  "plan.approval.done_other": "Plan approved: {{count}} stories created, staffed and set as decided.",
  "plan.col.line": "Line",
  "plan.col.settings": "Settings",
  "plan.col.team": "Team",
  "plan.col.priority": "Priority",
  "plan.col.criticality": "Criticality",
  "plan.col.complexity": "Complexity",
  "plan.col.rigor": "Rigor",
  "plan.col.trust": "Trust",
  "plan.criticality.critical": "Critical",
  "plan.criticality.high": "High",
  "plan.criticality.normal": "Normal",
  "plan.criticality.low": "Low",
  "plan.complexity.xs": "XS",
  "plan.complexity.s": "S",
  "plan.complexity.m": "M",
  "plan.complexity.l": "L",
  "plan.complexity.xl": "XL",
  "plan.line.edit": "Edit line {{code}}",
  "plan.line.editShort": "Edit",
  "plan.line.noOutcome": "outcome not described",
  "plan.line.noTeam": "No team",
  "plan.line.dependsOn": "after",
  "plan.line.whyCriticality": "Criticality:",
  "plan.line.whyStaffing": "Team:",
  "plan.line.floorReason": "Below the default setting, your reason:",
  "plan.line.changedSinceReview": "changed since the last review",
  "plan.line.changedSinceApproval": "changed since approval",
  "plan.line.commented": "commented",
  "plan.line.showContract": "Show the contract of {{code}}",
  "plan.line.hideContract": "Hide the contract of {{code}}",
  "plan.line.comment": "Comment on {{code}}",
  "plan.line.commentLabel": "Comment on {{code}}",
  "plan.line.commentPlaceholder": "What to change in this line…",
  "plan.line.pocSet": "Set by you. Camille proposed: {{proposed}}",
  "plan.line.pocSetShort": "set by you",
  "plan.line.proposedDefault": "the default",
  "plan.line.staffingPoc": "team set by you",
  "plan.line.runsSource.agent": "pinned on the agent",
  "plan.line.runsSource.office": "office setting",
  "plan.line.runsSource.default": "platform pick (cost)",
  "plan.line.runsLine": "line: {{value}}",
  "plan.line.runsSource.mission": "mission setting",
  "plan.line.runsSource.profileDefault": "profile default",
  "plan.line.runsViaMap": "via office map",
  "plan.line.unknownChampion": "Unknown champion",
  "plan.editor.title": "Set line {{code}}",
  "plan.editor.addRole": "Add a role…",
  "plan.editor.removeRole": "Remove the {{role}} role",
  "plan.editor.floorReason": "This setting is below the usual level for this criticality. In one line, why?",
  "plan.editor.floorReasonPlaceholder": "E.g. throwaway prototype, no real data",
  "plan.errors.generic": "This change could not be saved. Reload the plan and try again.",
  "plan.errors.someLines": "some lines",
  "plan.errors.field.rigor": "rigor",
  "plan.errors.field.trust": "trust",
  "plan.errors.field.effort": "effort",
  "plan.errors.plan_changed": "The plan changed since you opened it. Read it again before approving.",
  "plan.errors.plan_hash_required": "The plan could not be loaded: reload it before approving.",
  "plan.errors.plan_hash_not_allowed": "This decision is not about a plan.",
  "plan.errors.plan_missing": "Camille has not submitted a plan to approve yet.",
  "plan.errors.plan_invalid": "The plan is incomplete: Camille has to rework it.",
  "plan.errors.plan_not_found": "This plan no longer exists. Reload the page.",
  "plan.errors.plan_frozen": "This plan is already decided: it can no longer be changed.",
  "plan.errors.plan_line_not_found": "This line is not in the plan.",
  "plan.errors.plan_too_large": "These settings make the plan too large.",
  "plan.errors.stale_plan_settings": "Someone changed the plan at the same time. It was just reloaded: redo your change.",
  "plan.errors.invalid_field": "A value in this form is not accepted.",
  "plan.errors.forbidden": "Only the POC can set the plan.",
  "plan.errors.poc_required": "Only the office POC can decide this plan.",
  "plan.errors.story_comment_unknown_sid": "A comment targets a line that does not exist ({{sids}}).",
  "plan.errors.plan_staffing_invalid": "The team of {{sids}} is not valid: check the roles and the champions.",
  "plan.errors.plan_staffing_role_duplicated": "A role appears twice on {{sids}}.",
  "plan.errors.plan_role_missing": "A required role is missing on {{sids}} (implementation, review, or security at this rigor).",
  "plan.errors.plan_role_not_held": "A champion on {{sids}} does not hold that role on the mission, or their hire is not confirmed yet.",
  "plan.errors.plan_self_review": "On {{sids}}, the same champion cannot both build and review.",
  "plan.errors.plan_champion_unconfirmed": "A champion on {{sids}} is not hired yet: confirm the hire first.",
  "plan.errors.plan_conductor_rule": "On {{sids}}, Camille cannot hold that role.",
  "plan.errors.plan_model_not_routable": "On {{sids}}, the chosen model is not available for that role.",
  "plan.errors.plan_p0_path_open": "A P0 line ({{sids}}) waits on a line that is not P0. Put them at the same level or change the order.",
  "plan.errors.plan_floor_reason_required": "On {{sids}}, {{fields}} falls below the usual level for this criticality: write in one line why.",
  "plan.errors.plan_floor_reason_required_lines": "On {{lines}}: below the usual level for this criticality. Write in one line why below, or raise the level.",
  "plan.floorReason.inline.label": "{{sid}} — {{fields}} below the usual level for this criticality. In one line, why?",
  "plan.floorReason.inline.save": "Save the reason",
  "plan.floorReason.inline.hint": "Or raise the level with the line's pencil. Once every reason is saved, approve the plan.",
  "plan.floorReason.inline.saved": "Reason saved for {{sid}}.",
  "plan.errors.plan_mission_not_empty": "Stories already exist on this mission: the plan can no longer create them.",
  "plan.errors.plan_spec_missing": "The spec must be written before the plan is decided.",
  "plan.errors.plan_spec_stale": "The spec was revised since this plan: Camille has to update it.",
  "plan.errors.plan_cadrage_stale": "The framing changed since this plan: Camille has to rework it.",
  "plan.errors.plan_gate_pending": "A decision is already pending on this plan.",
  "plan.errors.plan_gate_launch_refused": "This mission builds from its approved plan: start it with \"Start the build\" in the mission view, not from this flow.",
  "plan.errors.plan_gate_requires_plan_review": "This mission moves to building only through its plan: open the Plan review to approve it.",
  "plan.errors.plan_not_approved": "The plan is not approved yet: no story can be created.",
  "plan.errors.mode_not_allowed": "The mission mode is set in the plan header, not in this decision.",
  "plan.errors.story_set_hash_not_allowed": "This decision is about a plan, not a list of stories.",
  "plan.errors.critique_urgent_unavailable": "Critical × Urgent is not available: Critical needs audit and redundancy.",
  "plan.errors.invalid_constraints": "These finish level, pace or budget settings are not valid.",
  "plan.errors.invalid_budget": "This amount is not possible.",
  "plan.errors.invalid_finition": "This finish level does not exist.",
  "plan.errors.invalid_rythme": "This pace does not exist.",
  "plan.errors.invalid_order": "This order does not list exactly the plan's lines. Reload the plan.",
  "plan.errors.plan_cost_basis_missing": "This plan has no cost estimate yet: Camille must submit it again.",
  "plan.errors.waterline_p0_below": "A P0 line ({{sids}}) is below the waterline: raise the budget, lower the finish level or the pace, or make it P1.",
  "plan.errors.waterline_dependency_below": "{{sids}} depends on a line below the waterline: change the order or the budget.",
  "plan.errors.rigor_derived_from_finition": "The mission rigor follows from the finish level: set the finish level.",
  "plan.errors.stale_constraints": "The mission constraints changed in the meantime: reload the plan.",
  "plan.errors.budget_below_spend": "The budget cannot go below what is already spent.",
  "plan.section.method": "Methodology followed",
  "plan.section.appetite": "Appetite",
  "plan.section.breadboard": "Breadboard",
  "plan.section.rabbit_holes": "Rabbit holes and no-gos",
  "plan.section.mock": "Mock",
  "mission.process.stepState.poc_skipped": "Skipped by the POC",
  "mission.process.evidence.ask_answered": "Question answered by the POC",
  "mission.process.evidence.breadboard_section": "Evidence: {{ref}}",
  "mission.process.evidence.plan": "Plan v{{version}} submitted to the POC",
  "mission.process.evidence.appetite": "Appetite confirmed by the POC",
  "methodology.evidence.breadboard": "Open the breadboard",
  "methodology.evidence.appetite": "Appetite confirmed by the POC",
  "methodology.evidence.appetiteText": "Appetite confirmed by the POC: {{text}}",
  "methodology.evidence.askAnswered": "Question answered by the POC",
  "methodology.skippedByYou": "Skipped by you — {{reason}}",
  "methodology.skippedByPoc": "Skipped by the POC — {{reason}}",
  "methodology.how": "How to prove it: {{how}}",
  "methodology.howFor.appetite": "the appetite comes from you — Camille asks you if it is missing",
  "methodology.howFor.breadboard_section": "Camille writes it in the breadboard",
  "methodology.howFor.signoff": "your decision on the phase signoff",
  "methodology.howFor.file": "Camille saves the step's document",
  "methodology.howFor.plan": "rendered automatically when Camille submits the plan",
  "methodology.howFor.ask": "Camille asks you the question; your answer is the proof",
  "methodology.howFor.record": "Camille records a checkable proof (document, question, decision or link)",
  "methodology.skip.action": "Skip this step",
  "methodology.skip.undo": "Undo the skip",
  "methodology.skip.reasonLabel": "Why skip this step? (10 to 200 characters)",
  "methodology.skip.reasonPlaceholder": "e.g. the customer interviews already happened outside the platform",
  "methodology.skip.confirm": "Confirm the skip",
  "methodology.skip.error.generic": "The skip could not be saved. Try again.",
  "methodology.skip.error.skip_reason_required": "Give a reason of 10 to 200 characters.",
  "methodology.skip.error.step_already_done": "This step is already proven: nothing to skip.",
  "methodology.skip.error.gate_not_skippable": "The phase gate is your own decision: it cannot be skipped.",
  "methodology.skip.error.poc_required": "Only the POC can skip a step.",
  "methodology.skip.error.phase_not_reached": "This phase has not started yet.",
  "methodology.skip.error.step_not_in_phase": "This step is no longer in the phase's methodology.",
  "methodology.skip.error.step_not_skipped": "This step is not skipped.",
  "methodology.gateWaiting_one": "The gate is waiting for: {{count}} step",
  "methodology.gateWaiting_other": "The gate is waiting for: {{count}} steps",
  "methodology.unavailable": "The phase's methodology could not be read.",
  "methodology.appetite.missing": "Appetite not confirmed by the POC.",
  "methodology.appetite.constraints": "Set by the POC",
  "methodology.appetite.cadrage": "Confirmed by the POC at framing",
  "breadboard.title": "Breadboard",
  "breadboard.loading": "Loading the breadboard…",
  "breadboard.loadFailed": "The breadboard could not be loaded.",
  "breadboard.missing": "No breadboard.md yet.",
  "breadboard.none": "None — {{reason}}",
  "breadboard.affordances": "What one can do in {{place}}",
  "breadboard.to": "to",
  "breadboard.section.problem": "Problem",
  "breadboard.section.places": "Places",
  "breadboard.section.connections": "Connections",
  "breadboard.section.rabbit_holes": "Rabbit holes",
  "breadboard.section.no_gos": "No-gos",
  "breadboard.errorsTitle_one": "Incomplete breadboard: {{count}} point to fix",
  "breadboard.errorsTitle_other": "Incomplete breadboard: {{count}} points to fix",
  "breadboard.error.generic": "The {{section}} section needs work.",
  "breadboard.error.section_missing": "The {{section}} section is missing.",
  "breadboard.error.section_too_long": "The {{section}} section is too long.",
  "breadboard.error.section_empty": "The {{section}} section is empty.",
  "breadboard.error.problem_too_short": "The problem is too short to bet on.",
  "breadboard.error.problem_copies_objective": "The problem copies the objective: it must say what is wrong.",
  "breadboard.error.place_line_invalid": "A place line is malformed: {{detail}}",
  "breadboard.error.place_duplicate": "Duplicate place: {{detail}}",
  "breadboard.error.place_without_affordance": "The place {{detail}} has no affordance.",
  "breadboard.error.affordances_too_many": "Too many affordances for the place {{detail}}.",
  "breadboard.error.places_too_many": "Too many places.",
  "breadboard.error.places_too_few": "At least two places are needed.",
  "breadboard.error.connection_line_invalid": "A connection line is malformed: {{detail}}",
  "breadboard.error.connection_unknown_place": "A connection leads to an undeclared place: {{detail}}",
  "breadboard.error.connection_affordance_unknown": "A connection uses an affordance its place does not have: {{detail}}",
  "breadboard.error.connections_too_many": "Too many connections.",
  "breadboard.error.none_reason_too_short": "« None » must give a reason (at least 10 characters).",
  "mock.title": "Shaping mock",
  "mock.status.requested": "Requested",
  "mock.status.generating": "Generating",
  "mock.status.ready": "Ready — your call",
  "mock.status.changes_requested": "Changes requested",
  "mock.status.validated": "Validated",
  "mock.status.waived": "Waived",
  "mock.status.abandoned": "Abandoned",
  "mock.status.failed": "Failed",
  "mock.status.declined": "Declined",
  "mock.round": "Round {{round}} / {{max}}",
  "mock.generatingNow": "Generating…",
  "mock.generatingSince": "Generating for {{minutes}} min",
  "mock.costTitle": "Cost per round",
  "mock.roundCost": "Round {{round}}: {{cost}}",
  "mock.total": "Total {{cost}}",
  "mock.open": "Open the mock",
  "mock.validate": "Validate the mock",
  "mock.changes": "Request changes",
  "mock.extraRound": "One more round",
  "mock.retry": "Retry",
  "mock.abandon": "Abandon the mock",
  "mock.capNote": "All {{max}} rounds are done: validate, abandon or grant one more round.",
  "mock.changesLabel": "What must change (10 to 1000 characters)",
  "mock.changesPlaceholder": "e.g. the map must come before the schedule",
  "mock.changesSend": "Send the changes",
  "mock.cancel": "Cancel",
  "mock.declined": "Shaping mock declined by the POC.",
  "mock.notOffered": "Shaping mock: not offered.",
  "mock.viewer.title": "Mock — round {{round}}",
  "mock.viewer.note": "Throwaway mock, fake data. It runs isolated from the Studio.",
  "mock.viewer.navigatedAway": "The mock navigated away to another page: it was closed for safety. Close and reopen the mock.",
  "mock.viewer.stalled": "The mock disrupted annotating (out-of-sequence messages): reload it to continue.",
  "mock.viewer.reload": "Reload the mock",
  "mock.annotate.title": "Mock annotations",
  "mock.annotate.sendWith": "{{count}} annotation(s) will be sent with this round — the overall comment becomes optional.",
  "mock.annotate.element": "Annotate an element",
  "mock.annotate.cancel": "Cancel selection",
  "mock.annotate.armedHint": "Click the element to comment on. Keyboard: Tab / Shift+Tab to browse, Arrow up = parent, Arrow down = child, Enter to pick, Escape to cancel.",
  "mock.annotate.waiting": "Loading the mock…",
  "mock.annotate.channelClosed": "The mock sends too many messages: annotating is off for this opening. Close and reopen the mock.",
  "mock.annotate.count": "{{count}} / {{max}}",
  "mock.annotate.empty": "No annotation yet. Point at an element of the mock to say what is wrong.",
  "mock.annotate.listTitle": "Annotations",
  "mock.annotate.showList": "Show",
  "mock.annotate.hideList": "Hide",
  "mock.annotate.number": "Annotation {{n}}:",
  "mock.annotate.zone": "area {{w}} × {{h}}",
  "mock.annotate.details": "Element details",
  "mock.annotate.selector": "Selector",
  "mock.annotate.path": "Path",
  "mock.annotate.box": "Box",
  "mock.annotate.boxValue": "x {{x}}, y {{y}} — {{w}} × {{h}} px",
  "mock.annotate.styles": "Styles",
  "mock.annotate.comment": "Comment for annotation {{n}}",
  "mock.annotate.commentPlaceholder": "e.g. this button should stand out more",
  "mock.annotate.commentHint": "{{count}} characters — {{min}} to {{max}}, required",
  "mock.annotate.commentTooShort": "At least {{min}} characters.",
  "mock.annotate.delete": "Delete annotation {{n}}",
  "mock.annotate.added": "Annotation {{n}} added",
  "mock.annotate.removed": "Annotation deleted — {{count}} left",
  "mock.annotate.estimate": "This round: {{cost}} (≤ {{cap}})",
  "mock.annotate.estimateUnknown": "This round: unknown cost (unpriced model).",
  "mock.annotate.noVision": "This model does not read images: each zone is described by its rectangle and its elements.",
  "mock.annotate.imagesTrimmed": "The zone images exceed the round cap: each zone is described by its rectangle and its elements.",
  "mock.error.mock_input_too_large": "This round's annotations exceed the generation cap, even shortened. Skip the mock for this step, or start a round with fewer annotations.",
  "mock.annotate.caps.annotations": "At most {{max}} annotations per round.",
  "mock.annotate.region": "Draw an area",
  "mock.annotate.cancelRegion": "Cancel the area",
  "mock.annotate.armedRegionHint": "Draw a rectangle on the mock. Keyboard: arrows move it (Shift = 1 px), Alt + arrows resize it, Enter captures, Escape cancels.",
  "mock.annotate.approx": "approximate preview",
  "mock.annotate.thumbAlt": "Approximate preview of area {{n}} ({{w}} × {{h}} px)",
  "mock.annotate.zoneDetails": "Area details",
  "mock.annotate.elements": "Elements",
  "mock.annotate.noElements": "No element found in the area.",
  "mock.annotate.captureFailed": "Capture failed — the area and its elements are kept.",
  "mock.annotate.captureTooLarge": "Capture too heavy — the area and its elements are sent.",
  "mock.annotate.captureUnsupported": "This browser cannot capture the mock — the area and its elements are kept.",
  "mock.annotate.captureRefused": "Capture refused by the image check — the area and its elements are kept.",
  "mock.annotate.caps.images": "At most {{max}} captures per round — this area and its elements are kept without an image.",
  "mock.error.generic": "The mock could not be processed. Try again.",
  "mock.wake.queued": "Decision saved. Camille finishes the step in progress, then picks up your decision.",
  "mock.wake.held": "Decision saved. Camille is paused (wake budget reached): she picks it up as soon as the budget allows.",
  "mock.wake.unavailable": "Decision saved, but Camille could not be notified: write to her in the chat to restart her.",
  "mock.error.mock_real_pii_suspected": "The mock contained data that look like real personal data: it was refused.",
  "mock.error.mock_real_pii_suspected.email": "Refused: a real e-mail address is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.phone": "Refused: a real phone number is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.address": "Refused: a real postal address is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.card": "Refused: a payment card number is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.iban": "Refused: a real IBAN is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.nir": "Refused: a social security number is suspected. Retry the same round.",
  "mock.error.mock_real_pii_suspected.external_url": "Refused: a link to an outside site. Retry the same round.",
  "mock.error.mock_output_invalid": "The generated file was not a valid self-contained mock (external resource, network or missing banner).",
  "mock.error.mock_truncated": "The mock was too long for this round's limit: nothing was saved. Retry the same round.",
  "mock.error.mock_timeout": "The generator took too long to answer. Retry the same round.",
  "mock.error.mock_generation_failed": "Generation failed. You can ask for a mock again.",
  "mock.error.mock_interrupted": "Generation was interrupted. You can ask for a mock again.",
  "mock.error.mock_job_unavailable": "The mock generator cannot be reached right now.",
  "mock.error.mock_job_busy": "A mock is already being generated for this mission.",
  "mock.error.mock_job_crashed": "Generation failed. You can ask for a mock again.",
  "mock.error.mock_store_failed": "The mock could not be stored.",
  "mock.error.mock_store_failed.read_only_mirror": "The mock could not be stored: this mission mirrors its GitHub repository and its mission folder is not synced yet. A retry costs nothing and works once the folder is synced.",
  "mock.error.mock_role_missing": "Nobody on the squad can draw the mock (designer or frontend).",
  "mock.error.mock_scan_unavailable": "The mock content could not be checked: it stays blocked.",
  "mock.error.stale_mock": "The mock changed meanwhile: the view is refreshed, decide again.",
  "mock.error.mock_status": "The mock is not waiting for a decision right now.",
  "mock.error.ui_mock_round_cap": "No rounds left: validate, abandon or grant one more round.",
  "mock.error.poc_required": "Only the POC decides on the mock.",
  "mock.error.mock_not_found": "Mock not found.",
  "mock.error.invalid_input": "The comment must be 10 to 1000 characters.",
  "mock.line.queued": "Queued — starts after the mock being generated",
  "mock.line.chip": "Mock",
  "mock.line.serves": "Before the backend of",
  "mock.line.note": "Line added by the server: screens on fake data, validated by you on a preview.",
  "mock.line.ui": "UI",
  "mock.line.uiTitle": "This line changes a screen",
  "mock.line.mockTitle": "This line's mock",
  "mock.line.mock.auto": "Mock first",
  "mock.line.mock.waived": "No mock",
  "mock.line.mock.unavailable": "Mock unavailable",
  "mock.line.by.poc": "POC",
  "mock.line.by.office": "office",
  "mock.line.by.server": "server",
  "mock.line.byNamed": "{{source}} · {{name}}",
  "plan.htmlMock.chip": "Mock",
  "plan.htmlMock.serves": "Serves",
  "plan.htmlMock.note": "HTML mock generated by the server, validated by you before their stories.",
  "plan.htmlMock.budget": "UI mocks: {{count}} × one mock round (≤ 3 rounds each)",
  "plan.htmlMock.banner": "Mock optional for this office (set by {{by}}, {{date}}) — each UI line can ask for one again.",
  "mock.editor.ui": "This line changes a screen",
  "mock.editor.waive": "No mock for this line",
  "mock.editor.waiveReason": "Why no mock?",
  "mock.editor.waivePlaceholder": "e.g. copy only, no new screen",
  "mock.story.round": "UI mock — round {{round}} / {{max}}",
  "mock.story.serves": "before {{sids}}",
  "mock.story.note": "Validate = the mock is right, the screens' backend can start. Request changes = a new mock round, not a failure.",
  "mock.story.waiting": "Waiting for the validation of mock {{sid}}",
  "mock.story.waitingHtml": "Waiting for the validation of « {{title}} » ({{key}})",
  "mock.line.titleFallback": "UI mock",
  "mock.line.servesList": "Serves {{sids}}",
  "mock.line.retry": "Retry",
  "mock.line.waive": "No mock for this step",
  "mock.line.waiveLabel": "Why no mock for this step?",
  "mock.line.waiveHint": "{{count}} / 200 visible characters (10 minimum)",
  "mock.line.waiveSend": "Confirm: no mock",
  "mock.line.waiveNote": "This step's UI stories will start without a mock. Your reason is logged.",
  "mock.line.waived": "No mock — {{reason}}",
  "mock.line.panelTitle": "UI mocks of the steps",
  "mock.line.panelNote": "Every step that changes a screen has its mock: its UI stories wait for your validation.",
  "mock.story.openMock": "Open the mock",
  "mock.history.title": "History",
  "mock.history.show": "Show the history",
  "mock.history.hide": "Hide the history",
  "mock.history.loading": "Loading the history…",
  "mock.history.error": "The history could not be loaded.",
  "mock.history.empty": "No round decided yet.",
  "mock.history.round": "Round {{round}}",
  "mock.history.verdict.validate": "Validated",
  "mock.history.verdict.changes": "Changes requested",
  "mock.history.verdict.abandon": "Abandoned",
  "mock.history.pending": "Waiting for a decision",
  "mock.history.decidedBy": "by {{name}} on {{date}}",
  "mock.history.someone": "a POC",
  "mock.history.validatedBy": "Validated by {{name}} on {{date}} — round {{round}}",
  "mock.history.waivedBy": "No mock, decided by {{name}} on {{date}}: {{reason}}",
  "mock.history.comment": "Overall comment",
  "mock.history.annotations_one": "{{count}} annotation",
  "mock.history.annotations_other": "{{count}} annotations",
  "mock.history.noAnnotations": "No annotation.",
  "mock.history.element": "Element",
  "mock.history.region": "Area {{w}} × {{h}}",
  "mock.history.notes": "notes for the build",
  "mock.history.approx": "approximate preview",
  "mock.history.imageAlt": "Capture of area {{n}} (approximate preview)",
  "mock.history.capture.failed": "Capture failed — the area and its elements are kept",
  "mock.history.capture.unsupported": "Capture not supported by this browser — the area and its elements are kept",
  "mock.history.capture.too_large": "Capture too heavy — the area and its elements are sent",
  "mock.history.model": "Model {{model}}",
  "mock.editor.waiveHint": "{{count}} / 200 visible characters (10 minimum)",
  "mock.error.mock_line_abandon": "A step mock cannot be abandoned: choose « No mock for this step ».",
  "mock.error.mock_scope": "This mock is not decided here.",
  "mock.error.annotations_not_allowed": "Annotations go with « Validate » or « Request changes » only.",
  "mock.error.annotations_cap": "At most 12 annotations per round.",
  "mock.error.images_cap": "At most 6 captures per round.",
  "mock.error.images_total_cap": "The captures exceed 1.5 MB for this round: remove an area.",
  "mock.error.annotation_n_duplicate": "Two annotations carry the same number.",
  "mock.error.annotation_comment": "Every annotation needs a comment of 3 to 500 characters.",
  "mock.error.annotation_invalid": "An annotation is unreadable: delete it and try again.",
  "mock.error.annotation_target_too_large": "An annotation is too large: delete it and try again.",
  "mock.error.annotation_image_invalid": "A capture was refused: delete the area and try again.",
  "mock.error.annotation_real_data": "An annotation holds what looks like real personal data: sending is refused.",
  "mock.error.comment_real_data": "Your comment holds what looks like real personal data: remove it.",
  "mock.error.annotation_store_failed": "The captures could not be stored. Try again.",
  "mock.error.payload_too_large": "The round is too heavy to send: remove a capture.",
  "mock.error.mock_not_viewable": "This mock does not open in the viewer.",
  "mock.error.waive_reason": "The reason must be 10 to 200 visible characters.",
  "connectionCard.waitingPoc": "Waiting for the POC",
  "connectionCard.action.connect": "Connect {{name}}",
  "connectionCard.action.reconnect": "Reconnect {{name}}",
  "connectionCard.action.connecting": "Opening…",
  "connectionCard.action.authorize": "Authorize for this mission",
  "connectionCard.action.authorizing": "Authorizing…",
  "connectionCard.scope.office": "Connected for the office",
  "connectionCard.scope.mission": "Authorized for this mission",
  "connectionCard.scope.missionPending": "Not yet authorized for this mission",
  "connectionCard.unavailable.not_published": "{{name}} isn't offered on this platform yet — the Nova team has to enable it.",
  "connectionCard.unavailable.not_configured": "Data sources aren't enabled on this platform.",
  "connectionCard.unavailable.directory_error": "The connection status can't be read right now. Try again later.",
  "connectionCard.repo.linked": "Linked repository: {{list}}",
  "connectionCard.repo.managed": "No GitHub repository linked — the mission uses its managed repository ({{name}}).",
  "connectionCard.repo.none": "No repository is linked to this mission, its project or the office.",
  "connectionCard.repo.link": "Link a repository to the office",
  "connectionCard.repo.candidates": "Several repositories are linked to the office ({{list}}) — Camille will ask which one this mission uses.",
  "connectionCard.repo.linkHint": "Pick it on the office GitHub page (opens in a new tab) — this mission then uses it. This card updates when you come back.",
  "connectionCard.repo.onboarding": "{{name}} is linked to the office — its onboarding is not finished yet (bootstrap PR), so the build cannot use it. This card updates when it is ready.",
  "connectionCard.repo.failed": "{{name}} is linked to the office, but its onboarding failed — the build cannot use it. The office GitHub page shows what to do next.",
  "connectionCard.repo.followOnboarding": "Follow the onboarding",
  "connectionCard.toast.connected": "{{name}} is connected.",
  "connectionCard.toast.notConnected": "The connection didn't complete — try again from the card.",
  "connectionCard.toast.pocOnly": "Only the office POC can do this.",
  "connectionCard.toast.error": "This can't be done right now. Try again.",
  "champion.step.propose_connection": "is proposing a connection",
  "champion.step.list_mission_repos": "is checking the linked repository",
  "champion.tooling.sandbox.label": "Sandbox",
  "champion.tooling.sandbox.hint": "Codes in an isolated sandbox",
  "champion.tooling.codemode.label": "Code Mode",
  "champion.tooling.codemode.hint": "Runs light code (Code Mode)",
  "champion.tooling.conversation.label": "Conversation",
  "champion.tooling.conversation.hint": "Conversation agent — no sandbox",
  "workspace.champion.modelRoute.default": "Simple request: default model",
  "workspace.champion.modelRoute.complex": "Request judged complex: stronger model",
  "workspace.champion.modelRoute.escalated": "Escalated to a stronger model mid-conversation",
  "workspace.champion.modelRoute.kept": "Kept for the ongoing conversation",
  "workspace.champion.modelRoute.budget": "Limited by the office budget",
  "workspace.champion.modelRoute.gate": "Gate step: fixed model",
  "workspace.champion.modelRoute.pinned": "Fixed model (mission or office)",
  "workspace.champion.modelRoute.uncertain": "Default model kept",
  "workspace.champion.modelRoute.router_unavailable": "Routing unavailable: default model",
  "workspace.tickets.state.wait": "Waiting on you",
  "workspace.tickets.state.run": "In progress",
  "workspace.tickets.state.review": "In review",
  "workspace.tickets.state.blocked": "Blocked",
  "workspace.tickets.state.todo": "To do",
  "workspace.tickets.state.done": "Done",
  "workspace.tickets.state.idle": "In progress · idle",
  "prototype.title": "Prototype",
  "prototype.status.running": "In progress",
  "prototype.status.ready": "Ready",
  "prototype.status.error": "Error",
  "prototype.status.summarized": "Turn cut short",
  "prototype.status.budget_exceeded": "Budget reached",
  "prototype.status.approved": "Approved",
  "prototype.status.promoted": "Live",
  "prototype.status.handed_off": "Robust version started",
  "prototype.status.skipped": "Skipped",
  "prototype.version": "v{{n}}",
  "prototype.buildingFirst": "The prototype is being built — a first preview arrives in a few minutes.",
  "prototype.updating": "Your change is on its way…",
  "prototype.hostDown": "The prototype can't be reached right now. Try again in a moment.",
  "prototype.turnFailed": "The last turn did not complete. Describe the change to Camille to try again.",
  "prototype.startFailed": "The prototype could not start. Try again, or ask Camille to restart it.",
  "prototype.retryStart": "Try again",
  "prototype.retryRows": "Retry the data import",
  "prototype.error.prototype_not_retryable": "Nothing to retry: the prototype has already started.",
  "prototype.error.prototype_not_eligible": "This mission can no longer be prototyped.",
  "prototype.error.handoff_rows_not_retryable": "There is no data import to retry.",
  "prototype.summarized": "The last turn hit its limit: the last working version stays up.",
  "prototype.budgetExceeded": "Today's prototype budget ({{cap}}) is spent: changes resume tomorrow.",
  "prototype.turnFacts": "Last turn",
  "prototype.cost": "Last turn cost: {{cost}}",
  "prototype.duration": "Duration: {{duration}}",
  "prototype.firstReady": "First preview in {{duration}}",
  "prototype.open": "Open the private preview",
  "prototype.privateNote": "Private link, valid 12 h, for you only. The data you enter is kept from one version to the next.",
  "prototype.linkStaffOnly": "This prototype's preview is not open to clients on this environment yet.",
  "prototype.robustBanner": "Switch to the robust version — reason: {{reason}}",
  "prototype.trigger.sensitive_data": "personal or sensitive data",
  "prototype.trigger.size": "bigger than a prototype holds",
  "prototype.trigger.out_of_model": "a need outside the prototype model",
  "prototype.trigger.client_request": "a spec or a review was asked",
  "prototype.trigger.red_streak": "two failed turns in a row",
  "prototype.trigger.model_flag": "flagged by the prototype agent",
  "prototype.dismiss": "Lift this trigger",
  "prototype.dismissLabel": "Why lift this trigger?",
  "prototype.dismissPlaceholder": "E.g. this is test data, no real address",
  "prototype.dismissSend": "Lift",
  "prototype.reasonHint": "Between {{min}} and {{max}} characters.",
  "prototype.cancel": "Cancel",
  "prototype.versions_one": "{{count}} version",
  "prototype.versions_other": "{{count}} versions",
  "prototype.current": "(current)",
  "prototype.restoredFrom": "restored from v{{n}}",
  "prototype.versionBroken": "(not published)",
  "prototype.restore": "Restore v{{n}}",
  "prototype.approve": "Approve this prototype",
  "prototype.skip": "Skip this step",
  "prototype.skipLabel": "Why skip the prototype?",
  "prototype.skipPlaceholder": "E.g. we already have approved mockups",
  "prototype.skipSend": "Skip the prototype",
  "prototype.skipped": "Prototype skipped at the client's request.",
  "prototype.skippedNoUi": "No prototype: this mission has no user interface.",
  "prototype.consent": "I agree to put version v{{n}} live as is, with the data entered.",
  "prototype.promoteAction": "Go live",
  "prototype.promoteUnavailable": "Putting a prototype live directly is not available yet. To publish the app, switch to the robust version.",
  "prototype.handoffAction": "Switch to the robust version",
  "prototype.promote.deploying": "Putting v{{version}} live…",
  "prototype.promote.propagating": "Propagating…",
  "prototype.promote.live": "Live:",
  "prototype.promote.failed": "Going live failed.",
  "prototype.promote.count_mismatch": "Going live stopped: the number of copied rows does not match.",
  "prototype.handoff.packaged": "Robust version started: the repository is being set up, the data follows.",
  "prototype.handoff.imported": "Robust version started: repository created, data imported and checked.",
  "prototype.handoff.kept_live": "Robust version started: the live app's data is kept.",
  "prototype.handoff.count_mismatch": "Robust version data: the number of rows does not match — to check.",
  "prototype.handoff.failed": "Importing the robust version's data failed.",
  "prototype.error.generic": "That did not work. Try again.",
  "prototype.error.poc_required": "Only the client lead can do this.",
  "prototype.error.turn_running": "Wait for the current turn to finish.",
  "prototype.error.version_not_green": "This version does not work: pick a published version.",
  "prototype.error.phase_closed": "This step is over.",
  "prototype.error.prototype_trigger_active": "A « Garanties » trigger is active: switch to the robust version or lift it.",
  "prototype.error.prototype_budget_exceeded": "Today's prototype budget is spent.",
  "prototype.error.not_configured": "Going live is not available on this environment yet.",
  "prototype.error.count_mismatch": "The number of copied rows does not match.",
  "prototype.error.promote_in_progress": "Going live is already in progress.",
  "prototype.error.reason_invalid": "The reason must be 10 to 200 characters long.",
  "prototype.error.not_active": "This trigger is no longer active.",
  "prototype.error.prototype_host_error": "The prototype can't be reached right now.",
  "settings.github.missionLimitUnlimited": "unlimited",
  "settings.github.officeLimitLabel": "Active missions for the office (all repositories)",
  "settings.github.missionLimitInert": "A per-repository limit above the office limit has no effect.",
  "settings.github.missionCounts": "{{active}} active · {{queued}} waiting",
  "settings.github.officeBusy": "This office already runs {{count}} active missions (limit {{limit}}).",
  "build.errors.office_busy": "This office already runs its maximum number of active missions.",
  "build.amendment.title": "Amendment #{{seq}} proposed by Camille: {{codes}}",
  "build.amendment.beforeRelease": "Once approved it joins the build: the release waits for it.",
  "build.amendment.envelope": "Estimated {{estimate}} · budget {{budget}} · spent {{spent}} · open stories {{open}} · remaining {{remaining}}",
  "build.amendment.over": "Does not fit the envelope.",
  "build.amendment.approve": "Approve",
  "build.amendment.approveOver": "Approve above the envelope",
  "build.amendment.confirmOver": "The budget is not raised: the build stops at the current cap if spending exceeds it. Approve anyway?",
  "build.amendment.confirmOverYes": "Yes, approve",
  "build.amendment.reject": "Send back",
  "build.amendment.rejectComment": "Why (optional)",
  "build.amendment.rejectConfirm": "Send back to Camille",
  "build.amendment.cancel": "Cancel",
  "build.amendment.pocOnly": "The POC decides this amendment.",
  "build.amendment.last.approved": "Amendment #{{seq}} approved: {{codes}} joins the build.",
  "build.amendment.last.rejected": "Amendment #{{seq}} sent back ({{codes}}).",
  "build.amendment.errors.amendment_changed": "The amendment changed: read it again before deciding.",
  "build.amendment.errors.amendment_stale": "The amendment no longer matches the build: Camille must propose it again.",
  "build.amendment.errors.amendment_over_envelope": "It no longer fits the envelope: use « Approve above the envelope ».",
  "build.amendment.errors.release_open": "The release is already requested: the scope can no longer grow in this build.",
  "build.amendment.errors.poc_required": "Only the POC decides.",
  "build.amendment.errors.unknown": "The decision could not be recorded.",
  "build.amendment.sensitive": "Touches sensitive paths: {{paths}}",
  "build.amendment.belowOversight": "Lighter oversight than the mission's:",
  "build.amendment.belowField": "{{field}} {{line}} (mission: {{mission}})",
  "build.amendment.approveBelowOversight": "Approve with reduced oversight",
  "build.amendment.confirmBelowOversight": "These stories will run with less oversight than the rest of the mission (trust / rigor above). Approve anyway?",
  "build.amendment.confirmBelowOversightYes": "Yes, with reduced oversight",
  "build.amendment.last.approved_unscheduled": "Amendment #{{seq}} approved after the release opened: {{codes}} is NOT in this build (stories cancelled).",
  "build.amendment.errors.amendment_below_oversight": "Reduced oversight: confirm it with « Approve with reduced oversight ».",
  "build.amendment.errors.amendment_below_floor": "A line touches sensitive paths below the criticality floor: Camille must propose it again.",
  "build.amendment.field.outcome": "Outcome",
  "build.amendment.field.priority": "Priority",
  "build.amendment.field.complexity": "Complexity",
  "build.amendment.field.criticality": "Criticality",
  "build.amendment.field.trust": "Trust",
  "build.amendment.field.rigor": "Rigor",
  "build.amendment.field.finition": "Finish",
  "build.amendment.field.floor_rigor": "Floor rigor",
  "build.amendment.field.floor_reason": "Floor reason",
  "build.amendment.field.estimate_usd": "Estimate ($)",
  "build.amendment.field.champion": "Role",
  "build.amendment.field.depends_on": "Depends on",
  "build.amendment.field.staffing": "Staffing",
  "build.amendment.field.staffing_source": "Staffing chosen by",
  "build.amendment.field.required_roles": "Required roles",
  "build.amendment.field.input.context": "Context",
  "build.amendment.field.input.consumes": "Consumes",
  "build.amendment.field.input.read": "Read first",
  "build.amendment.field.input.constraints": "Constraints",
  "build.amendment.field.outputs": "Deliverable → location",
  "build.amendment.field.criteria": "Criterion",
  "build.amendment.field.gates.evidence": "Evidence",
  "build.amendment.field.gates.validated_by": "Validated by",
  "build.amendment.field.why.criticality": "Why this criticality",
  "build.amendment.field.why.staffing": "Why this staffing",
  "champion.step.propose_plan_amendment": "is proposing a plan amendment",
  "champion.step.list_plan_amendments": "is reading the plan amendments",
  "workspace.tickets.title": "Tickets",
  "workspace.tickets.count_one": "{{count}} ticket",
  "workspace.tickets.count_other": "{{count}} tickets",
  "workspace.tickets.legend": "Legend",
  "workspace.tickets.listLabel": "Mission tickets",
  "workspace.tickets.empty": "No tickets yet.",
  "workspace.tickets.unassigned": "unassigned",
  "workspace.tickets.since.now": "just now",
  "workspace.tickets.composer.placeholder": "Write about {{sid}}…",
  "workspace.tickets.composer.empty": "No messages on this ticket yet.",
  "workspace.tickets.composer.inputLabel": "Message about {{sid}}",
  "mock.edit.title": "Edit the mock",
  "mock.edit.select": "Select an element",
  "mock.edit.cancelSelect": "Cancel selection",
  "mock.edit.armedHint": "Click the element to edit. Keyboard: Tab / Shift+Tab to browse, Arrow up = parent, Arrow down = child, Enter to pick, Escape to cancel.",
  "mock.edit.noSelection": "Select an element of the mock to edit it.",
  "mock.edit.selected": "Element selected: {{tag}}",
  "mock.edit.scriptElement": "Element created by the mock's script: it cannot be edited.",
  "mock.edit.commentThis": "Comment on this element",
  "mock.edit.generating": "A generation is running — comment instead.",
  "mock.edit.tooLarge": "Mock too large to edit: comment instead.",
  "mock.edit.text": "Text",
  "mock.edit.textHint": "Enter applies, Shift+Enter adds a line.",
  "mock.edit.editInPlace": "Edit the text on the mock",
  "mock.edit.inPlaceHint": "Type in the mock: Enter confirms, Shift+Enter adds a line, Escape cancels.",
  "mock.edit.inPlaceCancelled": "In-place text edit cancelled (or not available in this browser: use the Text field).",
  "mock.edit.color": "Text colour",
  "mock.edit.background": "Background",
  "mock.edit.fontSize": "Font size",
  "mock.edit.unit": "Unit",
  "mock.edit.weight": "Weight",
  "mock.edit.weights.normal": "Normal",
  "mock.edit.weights.bold": "Bold",
  "mock.edit.font": "Font",
  "mock.edit.unchanged": "Unchanged",
  "mock.edit.fonts.system": "System",
  "mock.edit.fonts.sans": "Sans serif",
  "mock.edit.fonts.serif": "Serif",
  "mock.edit.fonts.mono": "Monospace",
  "mock.edit.fonts.rounded": "Rounded",
  "mock.edit.align": "Alignment",
  "mock.edit.alignTo.left": "Left",
  "mock.edit.alignTo.center": "Centre",
  "mock.edit.alignTo.right": "Right",
  "mock.edit.alignTo.justify": "Justified",
  "mock.edit.margin": "Margins",
  "mock.edit.padding": "Inner spacing",
  "mock.edit.linked": "Same value on every side",
  "mock.edit.side.all": "All sides",
  "mock.edit.side.top": "Top",
  "mock.edit.side.right": "Right",
  "mock.edit.side.bottom": "Bottom",
  "mock.edit.side.left": "Left",
  "mock.edit.gap": "Spacing",
  "mock.edit.radius": "Corner radius",
  "mock.edit.moveUp": "Move up",
  "mock.edit.moveDown": "Move down",
  "mock.edit.remove": "Remove",
  "mock.edit.journalTitle": "Pending changes",
  "mock.edit.journal_one": "{{count}} change (max {{max}})",
  "mock.edit.journal_other": "{{count}} changes (max {{max}})",
  "mock.edit.removeOp": "Remove: {{label}}",
  "mock.edit.dropRefused": "Remove this change",
  "mock.edit.refusedRow": "Change {{n}} refused: remove it, then save again.",
  "mock.edit.bannerProtected": "The « Maquette — données fictives » banner and the elements that contain it cannot be edited.",
  "mock.edit.undo": "Undo",
  "mock.edit.undoAll": "Undo all",
  "mock.edit.save": "Save ($0)",
  "mock.edit.saveValidated": "Save as the validated version ($0)",
  "mock.edit.saving": "Saving…",
  "mock.edit.saved": "Version {{revision}} saved",
  "mock.edit.applied": "Change applied",
  "mock.edit.undone": "Change undone",
  "mock.edit.undoneAll": "All changes undone",
  "mock.edit.op.setText": "Text of <{{tag}}>: “{{text}}”",
  "mock.edit.op.setStyle": "{{prop}} of <{{tag}}>: {{value}}",
  "mock.edit.op.setAttr": "Attribute {{name}} of <{{tag}}>",
  "mock.edit.op.remove": "<{{tag}}> removed",
  "mock.edit.op.moveUp": "<{{tag}}> moved up",
  "mock.edit.op.moveDown": "<{{tag}}> moved down",
  "mock.edit.invalid.grammar": "Value not recognised for this field.",
  "mock.edit.invalid.range": "Value outside the allowed range.",
  "mock.edit.invalid.chars": "Character not allowed in this value.",
  "mock.edit.invalid.length": "Value too long.",
  "mock.edit.invalid.prop": "Property not editable.",
  "mock.edit.invalid.element": "This attribute does not apply to this element.",
  "mock.edit.invalid.control": "Control character not allowed.",
  "mock.edit.invalid.type": "Invalid value.",
  "mock.edit.invalid.invalid": "Invalid value.",
  "mock.edit.invalid.cap": "Too many changes: save first.",
  "mock.edit.invalid.not_ready": "The mock is not ready yet.",
  "mock.edit.invalid.real_data": "Real data detected ({{kind}}): use fictional data.",
  "mock.edit.kind.email": "e-mail",
  "mock.edit.kind.phone": "phone",
  "mock.edit.kind.address": "postal address",
  "mock.edit.kind.card": "payment card",
  "mock.edit.kind.iban": "IBAN",
  "mock.edit.kind.nir": "social security number",
  "mock.edit.kind.external_url": "link to an outside site",
  "mock.error.invalid_edit": "Change refused: it goes beyond what the editor allows.",
  "mock.error.edit_real_data": "Change refused: real data was detected.",
  "mock.error.edit_base_stale": "The mock changed since it was opened: reload it and redo your changes.",
  "mock.error.edit_cap": "Maximum number of saves reached for this round.",
  "mock.error.edit_rate": "Too many saves in one hour: try again later.",
  "mock.error.edit_target_unknown": "An edited element no longer exists in the stored version.",
  "mock.error.edit_target_mismatch": "An edited element no longer matches the stored version.",
  "mock.error.edit_target_forbidden": "This element cannot be changed this way.",
  "mock.error.edit_text_not_leaf": "This text contains other elements: it cannot be replaced.",
  "mock.error.edit_move_edge": "This element cannot move further.",
  "mock.error.edit_value_invalid": "A value goes beyond what the editor allows.",
  "mock.error.edit_output_invalid": "The edited version fails the mock checks (banner, links…).",
  "mock.error.edit_too_large": "The edited version would be too large.",
  "mock.error.edit_not_stampable": "Mock too large to edit: comment instead.",
  "mock.error.edit_apply_failed": "The change could not be applied. Try again.",
  "mock.error.edit_output_unstable": "This change would alter the page structure: it was not saved.",
  "mock.error.edit_target_banner": "The « Maquette — données fictives » banner must stay visible and in place: this style or move is refused.",
  "mock.error.edit_ops_too_large": "Too many changes in one save: save in several steps.",
  "mock.panel.tabs": "Mock tools",
  "mock.panel.comment": "Comment",
  "mock.panel.edit": "Edit",
  "mock.comment.element": "Comment an element",
  "mock.comment.modeHint": "Each comment goes to Camille at once, without a decision on the mock.",
  "mock.comment.empty": "No comment in progress. Point at an element or draw an area on the mock.",
  "mock.comment.send": "Send the comment",
  "mock.comment.sending": "Sending…",
  "mock.comment.sent": "Comment sent ({{ref}})",
  "mock.comment.sentTitle": "Sent",
  "mock.comment.duringGeneration": "Sent during the generation: not taken into account by this round.",
  "mock.comment.wake.queued": "Comment saved. Camille finishes the step in progress, then answers it.",
  "mock.comment.wake.held": "Comment saved. Camille will answer it when she next resumes.",
  "mock.comment.wake.unavailable": "Comment saved, but Camille could not be told: nudge her in the chat.",
  "mock.comment.card.title": "Comment on the mock “{{mock}}” — round {{round}}, {{ref}}",
  "mock.comment.card.shaping": "shaping",
  "mock.comment.card.unknown": "of the step",
  "mock.comment.card.by": "by {{name}} on {{date}}",
  "mock.comment.card.imageAlt": "Capture of comment {{ref}} (approximate preview)",
  "mock.outcome.title": "Validated mock: what should happen with this comment?",
  "mock.outcome.reopenAction": "Reopen a round",
  "mock.outcome.reopenWithCost": "Reopen a round (≈ {{cost}})",
  "mock.outcome.reopenCost": "A new round would cost about {{cost}}.",
  "mock.outcome.costUnknown": "unknown cost",
  "mock.outcome.noteAction": "Note for the implementation",
  "mock.outcome.later": "Later",
  "mock.outcome.reopenNote": "The round {{round}} validation stays in the history; UI stories already started are not recalled.",
  "mock.outcome.shapingStale": "A submitted plan will need approving again.",
  "mock.outcome.none": "no follow-up",
  "mock.outcome.reopen": "round reopened",
  "mock.outcome.note": "note for the implementation",
  "mock.outcome.round": "taken into the next round",
  "mock.history.comments_one": "{{count}} comment outside a decision",
  "mock.history.comments_other": "{{count}} comments outside a decision",
  "mock.history.commentBy": "by {{name}} on {{date}}",
  "mock.history.commentOutcomeBy": "outcome set by {{name}} on {{date}}",
  "mock.history.commentImageAlt": "Capture of comment {{ref}} (approximate preview)",
  "mock.history.edits_one": "{{count}} version edited by the POC",
  "mock.history.edits_other": "{{count}} versions edited by the POC",
  "mock.history.editBy_one": "Version edited by {{name}} on {{date}} — {{count}} change",
  "mock.history.editBy_other": "Version edited by {{name}} on {{date}} — {{count}} changes",
  "mock.history.editMore_one": "… and {{count}} more change",
  "mock.history.editMore_other": "… and {{count}} more changes",
  "mock.history.versionView": "View this version",
  "mock.history.versionGenerated": "View the generated version",
  "mock.history.reopenedBy": "Round reopened by {{name}} on {{date}} — the validation still holds.",
  "mock.error.mock_closed": "This mock is closed: it can no longer be commented.",
  "mock.error.round_not_found": "This round of the mock cannot be viewed.",
  "mock.error.comment_rate": "Too many comments in an hour on this mission: try again later.",
  "mock.error.comments_cap": "Maximum number of comments reached for this round.",
  "mock.error.comment_busy": "Another comment was just saved: try again.",
  "mock.error.comment_not_found": "Comment not found.",
  "mock.error.comment_outcome_set": "This comment already has an outcome.",
  "mock.error.comment_round_stale": "This comment belongs to an earlier round: it cannot reopen the validated round. Keep it as a note or comment again.",
  "mock.error.ui_mock_already_open": "Another shaping mock is already open: finish it before reopening this one.",
  "mock.error.mock_stamp_invalid": "The generated mock could not be prepared for editing: nothing was saved. Retry the same round.",
  "mock.error.edit_store_failed": "The edited version could not be saved. Try again.",
  "mock.error.invalid_revision": "This version of the mock does not exist.",
  "workspace.pane.close": "Close the panel",
  "workspace.pane.dialogDescription": "Mission section, shown over the chat. Close it to return to the chat.",
  "mission.journey.stage.flow": "Journey",
  "mission.journey.stage.now": "now: {{step}}",
  "mission.journey.stage.events_one": "{{count}} step",
  "mission.journey.stage.events_other": "{{count}} steps",
  "mission.journey.event.advance": "→ {{stage}}",
  "mission.journey.event.list": "Steps — {{stage}}",
  "mission.journey.event.decisionPrefix": "Camille decided:",
  "mission.journey.event.decisionUntitled": "Decision",
  "mission.journey.fold": "Fold the timeline",
  "mission.journey.unfold": "Unfold the timeline",
  "mission.journey.noEvents": "No decision yet.",
  "workspace.tab.plan": "Plan",
  "workspace.dock.process": "Mission process"
}
